// import "../syncfusionLicense";
import React, {
  useCallback,
  useRef,
  useState,
  useEffect,
  useMemo,
  use,
} from "react";
import showdown from "showdown";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import useUndoRedo from "./useUndoRedo";
import { logAppEvent } from "../Helpers/EventLogging";
// import rtfToHTML from 'rtf-to-html'; // Optional: Only if you want to handle RTF
import CustomPropertiesModal from "../Components/CustomPropertiesModal";
// import "primereact/resources/themes/vela-blue/theme.css"; // Choose a theme
// import "primereact/resources/themes/mira/theme.css";
// import "primereact/resources/primereact.min.css"; // Core CSS
import "primeicons/primeicons.css";
import { MenuItemCommandEvent } from "primereact/menuitem";
import { Tree, TreeCheckboxSelectionKeys } from "primereact/tree";
import { TreeNode } from "primereact/treenode";
import { insightsCollection } from "../insightsCollection";
import { ContextMenu } from "primereact/contextmenu";
import { getEnrichedCVRdata } from "../Helpers/AzureOpenAI";
import { startGaming } from "../Helpers/ApiGame";
import { getTranscript } from "../Helpers/AzureVision";
import useForceLayout from "../hooks/useForceLayout";
import { stratify, tree } from "d3-hierarchy";
import { SelectButton, SelectButtonChangeEvent } from "primereact/selectbutton";
import { readEml } from "eml-parse-js";
import UnsplashImagePicker from "../Components/unsplashImagePicker";
import SustainabilityWheel from "../Components/SystemTemplates/SustainabilityWheel";
import sustainabilityWheelData from "../data/sustainability_wheel.json";
import FocusWheel from "../Components/FocusWheel";
import KanbanArea from "../Components/KanbanArea";
import { HTMLarkdown } from "htmlarkdown";
import { isHTML, removeOptionalBrTags, hasBrTags } from "../utils/DomHandler";
import ImageNode from "../Components/ImageNode";
import { fetchTimelineData } from "../Helpers/GraphTimeline";
import { fetchCopilotData } from "../Helpers/GraphCopilot";
import { getExtensionFromString } from "../Helpers/GraphTimelineNormalizer";
import Tips from "../Components/Tips";
import * as d3 from "d3";
import ReactFlow, {
  ConnectionLineType,
  NodeOrigin,
  Node,
  OnConnect,
  OnConnectEnd,
  OnConnectStart,
  useReactFlow,
  useStoreApi,
  Controls,
  applyNodeChanges,
  applyEdgeChanges,
  ProOptions,
  Edge,
  EdgeChange,
  NodeChange,
  OnNodesChange,
  OnEdgesChange,
  Connection,
  Panel,
  MiniMap,
  Background,
  BackgroundVariant,
  NodeDragHandler,
  SelectionDragHandler,
  OnNodesDelete,
  OnEdgesDelete,
} from "reactflow";
import { shallow } from "zustand/shallow";
import MenuBar from "../Components/MenuBar";
import TourGuide from "../Components/TourGuide";
import { useStore, RFState } from "./store";
import NodeItem from "../Components/NodeItem";
import CenterItem from "../Components/CenterItem";
import FocusItem from "../Components/FocusItem";
import EdgeItem from "../Components/EdgeItem";
import CrossLine from "../Components/CrossLine";
import ImageItem from "../Components/ImageItem";
import NotesModal from "../Components/NotesModal";
import {
  saveFlowData,
  loadFlowData,
  loadFlowProps,
  getUserDoc,
  updateUserInsights,
  updateUserSettings,
  saveTemplate,
  loadTemplate,
} from "../storage/storageProxy"; // Import Firestore functions
import { v4 as uuidv4 } from "uuid"; // Import UUID library
import { updateNodePositions } from "../Helpers/circleLayout";
import { auth } from "../firebase"; // Import Firebase auth
import { nanoid } from "nanoid/non-secure";
import {
  exportJsonToFileWithPrompt,
  importJsonFromFileWithPrompt,
  importWordFromFile,
} from "../Helpers/FileHandling";
import "./contextMenu.css";
import "reactflow/dist/style.css";
import { treeLayout } from "../Helpers/TreeLayout";
import { SwatchesPicker } from "react-color"; // Import color picker
import CustomAlert from "../Components/CustomAlert"; // Import CustomAlert component
import ConfirmModal from "../Components/ConfirmModal"; // Import CustomAlert component
import { toPng } from "html-to-image"; // Import html-to-image library
import { EmojiClickData } from "emoji-picker-react";
import { BrainstormPanel } from "../Components/BrainstormPanel"; // Import BrainstormPanel component
import GuidedCreationDialog from "../Components/GuidedCreationDialog";
import AIInputFloat from "../Components/AIInputFloat";
import {
  NodeData,
  MapEdge,
  Address,
  Event,
  WheelData,
  LawyerData,
  Task,
  FlowWheelProps,
  MS365DocumentFilter,
  MS365Document,
  NodeTypes,
  EdgeTypes,
} from "../types/types";

import "./flow.css";
import { saveAs } from "file-saver";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";

import {
  PDFDocumentProxy,
  getDocument,
  GlobalWorkerOptions,
  version as pdfjsVersion,
} from "pdfjs-dist";
import { generateAiMap } from "../Helpers/ApiChatGpt"; // Import the generateAiMap function
import AIQueryForm from "../Components/AIQueryForm";
import PubMedQueryForm from "../Components/PubMedQueryForm";
import BonsaiQueryForm from "../Components/BonsaiQueryForm";
import CVRQueryForm from "../Components/CVRQueryForm";
import { updateOrCreateUserDoc } from "../storage/storageProxy";
import {
  uploadImageToStorage,
  uploadImageToStorageForPublicUrl,
} from "../firebase"; // Import the new function
import { add, set, update } from "lodash";
import colors from "../colors.json"; // Import colors from the new JSON file
import { link, linkSync } from "fs";
import { Sidebar } from "primereact/sidebar";
import { Button } from "primereact/button";
import dagre from "@dagrejs/dagre";
import BrainstormComponent from "../Components/BrainstormComponent"; // Import the BrainstormComponent
import GuidePanel from "../Components/GuidePanel";
import DetailsSidebar from "../Components/DetailsSidebar"; // Import the new DetailsSidebar
import * as XLSX from "xlsx";
import { CustomProperty, User, viewTypes } from "../types/types";
import { ProgressSpinner } from "primereact/progressspinner";
import { FcIdea } from "react-icons/fc";
import { IoClose } from "react-icons/io5";
import HelpModal from "../Components/HelpModal";
import TimeLineArea from "../Components/TimeLineArea";
import GridArea from "../Components/GridArea";
import WorldMapArea from "../Components/WorldMapArea";
import ZoomableSunburstArea from "../Components/ZoomableSunburstArea";
import { color } from "html2canvas/dist/types/css/types/color";
import EmojiPickerPopup from "../Components/EmojiPickerPopup";
import UserSettings from "../Components/UserSettings";
import { Separator } from "docx";
import ZoomableSunburst from "../Components/ZoomableSunburstArea";
import { MdDescription } from "react-icons/md";
import { on } from "events";
import addToStructureGif from "../assets/gifs/bit-sized-add-to-structure.gif";
import reorganizeGif from "../assets/gifs/bit-sized-reorganize.gif";
import addIdeaGif from "../assets/gifs/bit-sized-add-idea.gif";
import deleteGif from "../assets/gifs/bit-sized-delete.gif";
import { Tooltip } from "primereact/tooltip";
import { sep } from "path";
import {
  getNonOverlappingPosition,
  splitTextIntoTitleAndNotes,
} from "../Helpers/NodeHelpers";

const colorArray: string[][] = colors.colors as string[][];

GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/pdf.worker.min.js`;

const selector = (state: RFState) => ({
  oneNotePages: state.oneNotePages,
  nodes: state.nodes,
  edges: state.edges,
  isDirty: state.isDirty,
  onNodesChange: state.onNodesChange,
  onEdgesChange: state.onEdgesChange,
  addChildNode: state.addChildNode,
  updateParentNode: state.updateParentNode,
  setNodes: state.setNodes,
  setEdges: state.setEdges,
  resetStore: state.resetStore,
  updateNodeNotes: state.updateNodeNotes,
  selectedNodeId: state.selectedNodeId,
  setSelectedNodeId: state.setSelectedNodeId,
  selectedNode: state.selectedNode,
  setSelectedNode: state.setSelectedNode,
  focusValue: state.focusValue,
  setFocusValue: state.setFocusValue,
  snapToGrid: state.snapToGrid,
  toggleSnapToGrid: state.toggleSnapToGrid,
  showMiniMap: state.showMiniMap,
  toggleShowMiniMap: state.toggleShowMiniMap,
  updateNodeLabelWithEmoji: state.updateNodeLabelWithEmoji,
  hideChildNodes: state.hideChildNodes,
  showChildNodes: state.showChildNodes,
  setIsDirty: state.setIsDirty,
  addCrossLine: state.addCrossLine,
  selectedEdgeId: state.selectedEdgeId,
  setSelectedEdgeId: state.setSelectedEdgeId,
  showNotesModal: state.showNotesModal,
  setShowNotesModal: state.setShowNotesModal,
  aiResponse: state.aiResponse,
  setAIResponse: state.setAIResponse,
  currentNotes: state.currentNotes,
  setCurrentNotes: state.setCurrentNotes,
  currentLinks: state.currentLinks,
  setCurrentLinks: state.setCurrentLinks,
  currentView: state.currentView,
  setCurrentNodeLabel: state.setCurrentNodeLabel,
  currentNodeLabel: state.currentNodeLabel,
  setCurrentView: state.setCurrentView,
  calculateSummary: state.calculateSummary,
  updateNodeCustomProperties: state.updateNodeCustomProperties,
  useLocalStorage: state.useLocalStorage,
  setUseLocalStorage: state.setUseLocalStorage,
  presentWithShowHideButtons: state.presentWithShowHideButtons,
  setPresentWithShowHideButtons: state.setPresentWithShowHideButtons,
  currentFlowId: state.currentFlowId,
  setCurrentFlowId: state.setCurrentFlowId,
  showViewSelector: state.showViewSelector,
  setShowViewSelector: state.setShowViewSelector,
  ideationMode: state.ideationMode,
  setIdeationMode: state.setIdeationMode,
  setMS365Mode: state.setMS365Mode,
  ms365Mode: state.ms365Mode,
  aiMode: state.aiMode,
  setAIMode: state.setAIMode,
  detailsMode: state.detailsMode,
  setDetailsMode: state.setDetailsMode,
  isPresentationMode: state.isPresentationMode,
  currency: state.currency,
  setCurrency: state.setCurrency,
  setUser: state.setUser,
  tabModeActive: state.tabModeActive,
  setTabModeActive: state.setTabModeActive,
  setTabModeParentId: state.setTabModeParentId,
  toastMessage: state.toastMessage,
  clearToast: state.clearToast,
});

interface FocusMapFlowState {
  nodes: Node<NodeData>[];
  edges: Edge[];
}

const nodeTypes: NodeTypes = {
  mindmap: NodeItem,
  nodeItem: NodeItem,
  center: FocusItem,
  image: ImageNode,
};

const edgeTypes: EdgeTypes = {
  mindmap: EdgeItem,
  edge: EdgeItem,
  center: EdgeItem,
  crossline: CrossLine,
  image: ImageItem,
};

const converter = new showdown.Converter();

const nodeOrigin: NodeOrigin = [0.5, 0.5];

const connectionLineStyle = { stroke: "rgb(18, 102, 86)", strokeWidth: 1 };
const defaultEdgeOptions = { style: connectionLineStyle, type: "mindmap" };

type MindMapEdge = Edge;

function Flow() {
  const proOptions: ProOptions = { account: "paid-pro", hideAttribution: true };
  const { undo, redo, canUndo, canRedo, takeSnapshot } = useUndoRedo();
  const toast = useRef<Toast>(null);
  const [currentNodeComplete, setCurrentNodeComplete] = useState(false);
  const [currentNodeFlagged, setCurrentNodeFlagged] = useState("");
  const [currentNodeColor, setCurrentNodeColor] = useState("#ffffff");
  const [brainstormVisible, setBrainstormVisible] = useState(false);
  const [guideVisible, setGuideVisible] = useState(false);
  const [currentTemplateId, setCurrentTemplateId] = useState<string | null>(
    null
  );
  const [userSettingsVisible, setUserSettingsVisible] = useState(false);
  const [showWhyTag, setShowWhyTag] = useState(true); // Default to true
  const [showStartupDialog, setShowStartupDialog] = useState(false); // Default to false - only shown if user enables
  const [showAIPromptOnNewMap, setShowAIPromptOnNewMap] = useState(false); // Default to false
  const [aiModel, setAiModel] = useState("gpt-4o-mini"); // Default AI model
  const [userSettingsLoaded, setUserSettingsLoaded] = useState(false);
  const [gettingStartedVisible, setGettingStartedVisible] =
    useState<boolean>(false);
  const [doNotShowGettingStartedNextTime, setDoNotShowGettingStartedNextTime] =
    useState(false);
  const [showStructureHelp, setShowStructureHelp] = useState(false);
  const [userDetails, setUserDetails] = useState<User | null>(null);
  const [currentMapName, setCurrentMapName] = useState("");
  const [mapTemplate, setMapTemplate] = useState("flow");
  const [mapTheme, setMapTheme] = useState("");
  const [insights, setInsights] = useState<TreeNode[]>([]);
  const [showStructureHelpGif, setShowStructureHelpGif] = useState(false);
  const [showAddIdeaHelpGif, setShowAddIdeaHelpGif] = useState(false);
  const [showReorganizeHelpGif, setShowReorganizeHelpGif] = useState(false);
  const [showDeleteHelpGif, setShowDeleteHelpGif] = useState(false);
  const [selectedInsights, setSelectedInsights] =
    useState<TreeCheckboxSelectionKeys | null>(null);
  const markdownConverter = new HTMLarkdown();
  const [loading, setLoading] = useState(false);
  const [showAIInput, setShowAIInput] = useState(false);
  const { flowId } = useParams();
  const location = useLocation(); // Move this line inside the Flow component or a custom hook
  const queryParams = new URLSearchParams(location.search);
  const template = queryParams.get("template");
  const reactFlowInstance = useReactFlow();
  const navigate = useNavigate();
  const [showCustomPropertiesModal, setShowCustomPropertiesModal] =
    useState(false);
  const [initialCustomProperties, setInitialCustomProperties] = useState<
    CustomProperty[]
  >([]);
  // const [detectedAddresses, setDetectedAddresses] = useState<Addresses[]>([]);
  // const [detectedEvents, setDetectedEvents] = useState<Events[]>([]);
  const cm = useRef<ContextMenu>(null);
  const ncm = useRef<ContextMenu>(null);
  const [wheelData, setWheelData] = useState<WheelData[]>(
    sustainabilityWheelData as WheelData[]
  );
  const [showTips, setShowTips] = useState<boolean>(false);
  const [tipsActiveIndex, setTipsActiveIndex] = useState<number>(0);
  // --- TourGuide state ---
  const [showTour, setShowTour] = useState(false);
  const [tourSteps, setTourSteps] = useState<any[]>([]);
  const [tourKey, setTourKey] = useState(0);
  const centerNodeRef = useRef<HTMLDivElement>(null);
  const aiButtonRef = useRef<HTMLButtonElement>(null);
  const store = useStoreApi();
  const {
    oneNotePages,
    nodes,
    edges,
    isDirty,
    onNodesChange,
    onEdgesChange,
    addChildNode,
    updateParentNode,
    setNodes,
    setEdges,
    resetStore,
    updateNodeNotes,
    selectedNodeId,
    setSelectedNodeId,
    selectedNode,
    setSelectedNode,
    focusValue,
    setFocusValue,
    snapToGrid,
    toggleSnapToGrid,
    showMiniMap,
    toggleShowMiniMap,
    hideChildNodes,
    showChildNodes,
    setIsDirty,
    addCrossLine,
    selectedEdgeId,
    setSelectedEdgeId,
    setShowNotesModal,
    showNotesModal,
    aiResponse,
    setAIResponse,
    setCurrentNotes,
    currentNotes,
    setCurrentLinks,
    currentLinks,
    setCurrentNodeLabel,
    currentNodeLabel,
    setCurrentView,
    currentView,
    calculateSummary,
    updateNodeCustomProperties,
    useLocalStorage,
    setUseLocalStorage,
    presentWithShowHideButtons,
    setPresentWithShowHideButtons,
    currency,
    setCurrency,
    currentFlowId,
    setCurrentFlowId,
    showViewSelector,
    setShowViewSelector,
    ideationMode,
    setIdeationMode,
    ms365Mode,
    setMS365Mode,
    aiMode,
    setAIMode,
    detailsMode,
    setDetailsMode,
    isPresentationMode,
    tabModeActive,
    setTabModeActive,
    setTabModeParentId,
    setUser,
    toastMessage,
    clearToast,
  } = useStore(selector, shallow);
  const connectingNodeId = useRef<string | null>(null);
  const justCreatedNodeViaConnect = useRef<boolean>(false);
  const { project, fitView, getViewport } = useReactFlow();

  const { dragEvents, simulation } = useForceLayout({
    strength: -1000,
    distance: 150,
    enabled: ideationMode,
  });

  const flowMapWrapper = useRef<HTMLDivElement | null>(null);
  const timelineWrapper = useRef<HTMLDivElement | null>(null);
  const gridWrapper = useRef<HTMLDivElement | null>(null);
  const kanbanWrapper = useRef<HTMLDivElement | null>(null);
  const worldMapWrapper = useRef<HTMLDivElement | null>(null);
  const wheelWrapper = useRef<HTMLDivElement | null>(null);
  // const [canvasContextMenu, setCanvasContextMenu] = useState<{
  //   mouseX: number;
  //   mouseY: number;
  // } | null>(null);

  const toastCenter = useRef<Toast>(null);
  const gettingStartedVideoRef = useRef(null);
  const [showHelpModal, setShowHelpModal] = useState(false);
  const [initialVideoUrl, setInitialVideoUrl] = useState<string | null>(null);
  const [showGettingStartedVideoModal, setShowGettingStartedVideoModal] =
    useState(false);

  const togglePlay = (event: React.MouseEvent) => {
    event.stopPropagation();
    setGettingStartedVisible(false);
    setShowStartModal(false);
    setShowGettingStartedVideoModal(true);
  };

  // Validation function to prevent circular connections
  const isValidConnection = useCallback(
    (connection: Connection) => {
      // Prevent connecting a node to itself
      if (connection.source === connection.target) {
        return false;
      }

      // Check if adding this connection would create a circular dependency
      // by checking if target is an ancestor of source
      const isAncestor = (
        potentialAncestorId: string,
        nodeId: string,
        visited = new Set<string>()
      ): boolean => {
        if (potentialAncestorId === nodeId) return true;

        // Prevent infinite loops in case of existing circular references
        if (visited.has(nodeId)) return false;
        visited.add(nodeId);

        const parentEdge = edges.find((edge) => edge.target === nodeId);
        if (!parentEdge) return false;

        return isAncestor(potentialAncestorId, parentEdge.source, visited);
      };

      if (
        connection.source &&
        connection.target &&
        isAncestor(connection.target, connection.source)
      ) {
        return false;
      }

      return true;
    },
    [edges]
  );

  const handleOnConnect: OnConnect = useCallback(
    (connection) => {
      // Double-check validation and show alert if invalid
      if (connection.source === connection.target) {
        showAlert("Info", "A node cannot be connected to itself");
        return;
      }

      // Check for circular dependency
      const isAncestor = (
        potentialAncestorId: string,
        nodeId: string,
        visited = new Set<string>()
      ): boolean => {
        if (potentialAncestorId === nodeId) return true;
        if (visited.has(nodeId)) return false;
        visited.add(nodeId);
        const parentEdge = edges.find((edge) => edge.target === nodeId);
        if (!parentEdge) return false;
        return isAncestor(potentialAncestorId, parentEdge.source, visited);
      };

      if (
        connection.source &&
        connection.target &&
        isAncestor(connection.target, connection.source)
      ) {
        showAlert(
          "Info",
          "This connection would create a circular reference and is not allowed"
        );
        return;
      }

      // 👇 make adding edges undoable
      takeSnapshot();
    },
    [edges, takeSnapshot]
  );

  // useEffect(() => {
  //   if (ideationMode) {
  //       setIdeationMode(false);
  //   }
  //   return () => {
  //     setIdeationMode(false);
  //   };
  // }, [ideationMode]);

  // Show tour when a new map is created and center/goal node is visible
  // useEffect(() => {
  //   // Example: show tour if nodes has only the center node (new map)
  //   if (nodes && nodes.length === 1 && nodes[0].type === "center") {
  //     setTourSteps([
  //       {
  //         target: "#goal-center-item",
  //         content:
  //           "Dette er dit centrale mål eller fokuspunkt. Du kan bygge dit mindmap ud fra dette punkt.",
  //         placement: "bottom",
  //       },
  //       {
  //         target: "#tour-guide-btn",
  //         content:
  //           "Kl8ik her for at åbne denne Tour Guide når som helst, hvis du har brug for hjælp.",
  //         placement: "bottom",
  //       },
  //       {
  //         target: "#ai-menu-btn",
  //         content:
  //           "Klik her for at bruge AI til at generere nye ideer eller hjælpe med dit mindmap.",
  //         placement: "bottom",
  //       },
  //     ]);
  //     setShowTour(true);
  //   }
  // }, [nodes]);

  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      if (isDirty) {
        event.preventDefault();
        event.returnValue = "";
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [isDirty]);

  // Effect to show toast messages from store
  useEffect(() => {
    if (toastMessage && toast.current) {
      toast.current.show({
        severity: toastMessage.severity as any,
        summary: toastMessage.summary,
        detail: toastMessage.detail,
        life: 3000,
      });
      clearToast();
    }
  }, [toastMessage, clearToast]);

  const [contextMenu, setContextMenu] = useState<{
    mouseX: number;
    mouseY: number;
    node: Node | null;
  }>({ mouseX: 0, mouseY: 0, node: null });

  const [colorPickerVisible, setColorPickerVisible] = useState(false);

  //const [selectedNode, setSelectedNode] = useState<Node<NodeData> | null>(null);
  const lastSelectedNodeRef = useRef<Node<NodeData> | null>(null);
  const clickTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const [colorPickerPosition, setColorPickerPosition] = useState<{
    x: number;
    y: number;
  }>({ x: 0, y: 0 });

  const [nodeColor, setNodeColor] = useState<string>("#ffffff");
  const [alertTitle, setAlertTitle] = useState<string | null>(null);
  const [alertMessage, setAlertMessage] = useState<string | null>(null);
  const [showCreateTemplate, setShowCreateTemplate] = useState(false);
  const [templateName, setTemplateName] = useState("");
  const [templateDescription, setTemplateDescription] = useState("");
  const [showSetImageByUrl, setShowSetImageByUrl] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [currentMapFavourite, setCurrentMapFavourite] = useState(false);
  const [emojiPickerVisible, setEmojiPickerVisible] = useState(false);
  const [emojiPickerPosition, setEmojiPickerPosition] = useState<{
    x: number;
    y: number;
  }>({ x: 0, y: 0 });
  const [emojiNodeId, setEmojiNodeId] = useState<string | null>(null);
  const [imagePickerVisible, setImagePickerVisible] = useState(false);
  const [pickedImages, setPickedImages] = React.useState<any[]>([]);

  const [cursorPosition, setCursorPosition] = useState<number>(0);
  const [showProgressSpinner, setShowProgressSpinner] =
    useState<boolean>(false);
  const [newFlowPosition, setNewFlowPosition] = useState<{
    x: number;
    y: number;
  }>({ x: 0, y: 0 });
  const [emojiPickerDrag, setEmojiPickerDrag] = useState<{
    x: number;
    y: number;
  }>({ x: 0, y: 0 });
  const [isDraggingEmojiPicker, setIsDraggingEmojiPicker] = useState(false);
  const viewItems = useMemo(() => {
    if (mapTemplate === "microsoft365") {
      return [viewTypes.FocusMap, viewTypes.TimeLine];
    }
    //setMS365Mode(true);
    return [
      viewTypes.FocusMap,
      //viewTypes.Wheel,
      viewTypes.TimeLine,
      //viewTypes.WorldMap,
      viewTypes.Kanban,
    ];
  }, [mapTemplate]);
  //const [viewSelectorItems, setViewSelectorItems] = useState<string>(viewItems[0]);
  const handleViewChange = (view: any) => {
    setCurrentView(view);
  };

  const handleEmojiPickerMouseDown = (event: React.MouseEvent) => {
    setIsDraggingEmojiPicker(true);
    setEmojiPickerDrag({ x: event.clientX, y: event.clientY });
  };

  const handleEmojiPickerMouseMove = (event: React.MouseEvent) => {
    if (isDraggingEmojiPicker) {
      const dx = event.clientX - emojiPickerDrag.x;
      const dy = event.clientY - emojiPickerDrag.y;
      setEmojiPickerPosition((prevPosition) => ({
        x: prevPosition.x + dx,
        y: prevPosition.y + dy,
      }));
      setEmojiPickerDrag({ x: event.clientX, y: event.clientY });
    }
  };

  // const options = ["Data Offline", "Data in the Cloud"];
  // const [dataOnline, setDataOnline] = useState(options[0]);
  // const [userLocalData, setUseLocalData] = useState(false);

  const handleEmojiPickerMouseUp = () => {
    setIsDraggingEmojiPicker(false);
  };

  // Keep track of the last selected node before it gets cleared by clicks
  useEffect(() => {
    if (selectedNode) {
      lastSelectedNodeRef.current = selectedNode;
    }
  }, [selectedNode]);

  const showMessage = (
    summary: string,
    details: string,
    ref: React.RefObject<Toast>,
    severity:
      | "success"
      | "info"
      | "warn"
      | "error"
      | "secondary"
      | "contrast"
      | undefined
  ) => {
    if (ref.current) {
      ref.current.show({
        severity: severity,
        summary: summary,
        detail: details,
        life: 1500,
      });
    }
  };

  const handleAddIdea = async (
    title: string,
    notes: string,
    x: number,
    y: number,
    isPasted: boolean = false,
    parentNode: Node<NodeData> | null = null
  ) => {
    try {
      takeSnapshot();

      let newFocusX = x;
      let newFocusY = y;

      let parentId: string | undefined = undefined;
      let parentEdge: Edge | undefined = undefined;
      const nodeToUseAsParent = parentNode || selectedNode;
      if (nodeToUseAsParent) {
        parentId = nodeToUseAsParent.id;
      }

      const viewport = getViewport();
      if (x !== 0 && y !== 0) {
        // Convert screen coordinates to flow coordinates
        newFocusX = (newFocusX - viewport.x) / viewport.zoom;
        newFocusY = (newFocusY - viewport.y) / viewport.zoom;

        // If there's a parent, make position relative to parent
        if (
          nodeToUseAsParent?.positionAbsolute &&
          nodeToUseAsParent?.width &&
          nodeToUseAsParent?.height
        ) {
          newFocusX =
            newFocusX -
            nodeToUseAsParent.positionAbsolute.x +
            nodeToUseAsParent.width / 2;
          newFocusY =
            newFocusY -
            nodeToUseAsParent.positionAbsolute.y +
            nodeToUseAsParent.height / 2;
        }
      } else {
        const { x: nonOverlappingX, y: nonOverlappingY } =
          getNonOverlappingPosition({
            nodes,
            viewport,
            flowMapWrapper,
            selectedNode: nodeToUseAsParent,
            ideaWidth: 50,
            ideaHeight: 18,
          });
        newFocusX = nonOverlappingX || 0;
        newFocusY = nonOverlappingY || 0;
      }

      const ideaNode: Node = {
        id: nanoid(),
        type: "mindmap",
        style: {
          backgroundColor: "#fff",
        },
        data: {
          label: title,
          icon: isPasted
            ? "https://static.wixstatic.com/media/2fe974_787025d806fc4adfb35aa3f4cadfb735~mv2.png"
            : "",
          object: "",
          objectType: "text",
          objectWidth: 50,
          objectHeight: 18,
          notes: notes,
          complete: false,
          status: "none",
          flagged: "none",
          color: "black",
          backgroundColor: "#ffffff",
          presentationOrder: "",
          priority: "",
          links: [],
          value: "0",
          values: [],
          rollupValues: [],
          customProperties: [], //rootNode.data.customProperties,
          event: {} as Event,
          address: {} as Address,
          task: {} as Task,
        },
        position: { x: newFocusX, y: newFocusY },
        positionAbsolute: { x: newFocusX, y: newFocusY },
        dragging: false,
        selected: false,
        width: 50,
        height: 18,
        dragHandle: ".dragHandle",
        parentId: "",
      };
      const newFlowNodes: Node<NodeData>[] = [ideaNode, ...nodes];
      if (parentId) {
        ideaNode.parentId = parentId;
        parentEdge = {
          id: nanoid(),
          source: parentId,
          target: ideaNode.id,
          type: "mindmap",
        };
        edges.push(parentEdge);
      }
      const customState: FocusMapFlowState = {
        nodes: newFlowNodes,
        edges: edges,
      };
      store.setState(customState);

      setNodes(newFlowNodes);
      setEdges(edges);

      if (newFlowNodes.length < 2) {
        handleFitView();
      }
      setNewFlowPosition({ x: 0, y: 0 });

      return ideaNode.id;
    } catch (error) {
      alert("Error adding idea: " + error);
      return null;
    }
  };

  const handleAddObject = async (
    title: string,
    object: string,
    file: File | null,
    x: number,
    y: number,
    isPasted: boolean = false,
    objectWidth: number = 200,
    objectHeight: number = 200
  ) => {
    try {
      takeSnapshot();
      setShowProgressSpinner(true);
      if (objectWidth > 200) {
        const scale = 200 / objectWidth;
        objectWidth = 200;
        objectHeight = Math.round(objectHeight * scale);
      }

      let newFocusX = x;
      let newFocusY = y;

      let parentId: string | undefined = undefined;
      let parentEdge: Edge | undefined = undefined;
      if (selectedNode || selectedNodeId) {
        parentId = selectedNode.id;
      }

      const viewport = getViewport();
      if (x !== 0 && y !== 0) {
        newFocusX = (newFocusX - viewport.x) / viewport.zoom;
        newFocusY = (newFocusY - viewport.y) / viewport.zoom;
      } else {
        const { x: nonOverlappingX, y: nonOverlappingY } =
          getNonOverlappingPosition({
            nodes,
            viewport,
            flowMapWrapper,
            selectedNode,
            ideaWidth: 50,
            ideaHeight: 18,
          });
        newFocusX = nonOverlappingX || 0;
        newFocusY = nonOverlappingY || 0;
      }

      const ideaNode: Node = {
        id: nanoid(),
        type: "image",
        style: {
          backgroundColor: "#fff",
        },
        data: {
          label: title,
          icon: "",
          object: isPasted ? object : "",
          objectType: "text",
          objectWidth: objectWidth,
          objectHeight: objectHeight,
          notes: "",
          complete: false,
          status: "none",
          flagged: "none",
          color: "black",
          backgroundColor: "#ffffff",
          presentationOrder: "",
          priority: "",
          links: [],
          value: "0",
          values: [],
          rollupValues: [],
          customProperties: [], //rootNode.data.customProperties,
          event: {} as Event,
          address: {} as Address,
          task: {} as Task,
        },
        position: { x: newFocusX, y: newFocusY },
        positionAbsolute: { x: newFocusX, y: newFocusY },
        dragging: false,
        selected: false,
        width: objectWidth,
        height: objectHeight,
        dragHandle: ".dragHandle",
        parentId: "",
      };

      // 1. Upload to public storage (e.g., Firebase Storage)
      const publicUrl = await uploadImageToStorageForPublicUrl(file);

      // 2. Call Azure Computer Vision with the public URL
      const transcription = await getTranscript(publicUrl);
      //console.log("Transcription:", transcription);
      ideaNode.data.notes = transcription || "";

      // 3. Update the node with the transcription
      const newFlowNodes: Node<NodeData>[] = [ideaNode, ...nodes];
      if (parentId) {
        ideaNode.parentId = parentId;
        parentEdge = {
          id: nanoid(),
          source: parentId,
          target: ideaNode.id,
          type: "image",
        };
        edges.push(parentEdge);
      }
      const customState: FocusMapFlowState = {
        nodes: newFlowNodes,
        edges: edges,
      };
      store.setState(customState);

      setNodes(newFlowNodes);
      setEdges(edges);

      setNewFlowPosition({ x: 0, y: 0 });

      setShowProgressSpinner(false);
    } catch (error) {
      alert("Error adding image: " + error);
    }
  };

  const showAlert = (title: string, message: string) => {
    setAlertTitle(title);
    setAlertMessage(message);
  };

  const handleCloseAlert = () => {
    setAlertTitle(null);
    setAlertMessage(null);
  };
  const resetDirtyFlag = () => {
    setTimeout(() => {
      setIsDirty(false);
    }, 1000);
  };

  const handleUpdate = (updated: WheelData[]) => {
    setWheelData(updated);
  };

  useEffect(() => {
    setInsights(insightsCollection);
  }, []);

  useEffect(() => {
    const handleAddMS365Item = (event: CustomEvent) => {
      const item = event.detail as MS365Document;

      // Determine icon based on item type
      const iconType = getExtensionFromString(item);

      const iconUrl = `https://static2.sharepointonline.com/files/fabric/assets/item-types/96/${iconType}.png`;

      // Get viewport center for positioning
      const viewport = reactFlowInstance.getViewport();
      const centerX = (window.innerWidth / 2 - viewport.x) / viewport.zoom;
      const centerY = (window.innerHeight / 2 - viewport.y) / viewport.zoom;

      // Generate unique ID to allow adding the same document multiple times
      const uniqueId = `${item.id}-${Date.now()}-${Math.random()
        .toString(36)
        .substr(2, 9)}`;

      const newNode: Node<NodeData> = {
        id: uniqueId,
        type: "nodeItem",
        position: {
          x: centerX + Math.random() * 100 - 50,
          y: centerY + Math.random() * 100 - 50,
        },
        data: {
          label: item.title,
          icon: iconUrl,
          notes: item.summary || "",
          ms365Document: item,
          object: "",
          objectType: "",
          objectWidth: 200,
          objectHeight: 200,
          complete: false,
          status: "none",
          flagged: "",
          color: "",
          backgroundColor: "#ffffff",
          presentationOrder: "",
          priority: "",
          links: item.link
            ? [
                {
                  title: "MS365 Source",
                  url: item.link || "",
                },
              ]
            : [],
          value: "",
          values: [],
          rollupValues: [],
          customProperties: [],
          event: {} as Event,
          address: {} as Address,
          task: {} as Task,
        },
      };

      // Get current nodes from store to ensure we have the latest state
      const currentNodes = useStore.getState().nodes;
      setNodes([...currentNodes, newNode]);
    };

    window.addEventListener(
      "addMS365ItemToMap",
      handleAddMS365Item as EventListener
    );

    return () => {
      window.removeEventListener(
        "addMS365ItemToMap",
        handleAddMS365Item as EventListener
      );
    };
  }, [setNodes, reactFlowInstance]);

  // Load user settings on mount
  useEffect(() => {
    const loadUserSettings = async () => {
      const authUser = auth.currentUser;
      if (authUser) {
        const user: User | null = await getUserDoc(authUser.uid, false);
        if (user) {
          setUserDetails(user);
          setUser(user); // Update store with user data
          setPresentWithShowHideButtons(
            user.settings?.presentWithShowHideButtons || false
          );
          setCurrency(user.settings?.currency || "EUR");
          setShowWhyTag(user.settings?.showWhyTag !== false); // Default to true
          setShowStartupDialog(user.settings?.showStartupDialog === true); // Default to false - must be explicitly enabled
          setShowAIPromptOnNewMap(user.settings?.showAIPromptOnNewMap === true); // Default to false
          setAiModel(user.settings?.aiModel || "gpt-4o-mini"); // Load AI model preference
        }
      }
      setUserSettingsLoaded(true);
    };
    loadUserSettings();
  }, []);

  useEffect(() => {
    // Wait for user settings to be loaded before initializing
    if (!userSettingsLoaded) return;

    if (flowId && flowId !== "new") {
      setCurrentFlowId(flowId);
      handleLoad(flowId);
      resetDirtyFlag();
    } else if (template) {
      handleTemplate(template);
      setCurrentMapName("");
      setCurrentFlowId("new");
      resetDirtyFlag();
    } else {
      setCurrentMapName("");
      setCurrentFlowId("new");
      setInitialCustomProperties([]);
      const { nodes: storedNodes, edges: storedEdges } =
        store.getState() as unknown as FocusMapFlowState;
      if (storedNodes && storedNodes.length > 0 && storedEdges.length > 0) {
        setNodes(storedNodes);
        setEdges(storedEdges);
      } else {
        // Auto-create Goal node and show guided creation dialog if setting is enabled
        handleStartWithFocus();
        // Show guided creation dialog only if user has enabled it in settings
        setShowGuidedCreation(showStartupDialog);
        // Show AI input if user has enabled it in settings
        setShowAIInput(showAIPromptOnNewMap);
        // setSidebarVisible(false);
        setAIMode(false);
      }
    }
    setFocusValue("all");

    return () => {
      resetStore();
    };
  }, [flowId, userSettingsLoaded]);

  const [showStartModal, setShowStartModal] = useState(false);

  const handleStartWithFocus = () => {
    const initialNodes: Node<NodeData>[] = [
      {
        id: "root",
        type: "center",
        data: {
          label: "Goal",
          icon: "",
          object: "",
          objectType: "",
          objectWidth: 200,
          objectHeight: 200,
          notes: "",
          complete: false,
          status: "none",
          flagged: "none",
          color: "black",
          backgroundColor: "#ffffff",
          presentationOrder: "",
          priority: "",
          links: [],
          value: "0",
          values: [],
          rollupValues: [],
          customProperties: [],
          event: {} as Event,
          address: {} as Address,
          task: {} as Task,
          ms365Document: null,
        },
        style: {
          backgroundColor: "#fff",
        },
        position: { x: 0, y: 0 },
        positionAbsolute: { x: 0, y: 0 },
        dragHandle: ".dragHandle",
        dragging: false,
        selected: false,
        width: 200,
        height: 100,
        parentId: "",
      },
    ];
    setNodes(initialNodes);
    setEdges([]);
    resetDirtyFlag();
    setShowStartModal(false);
    setGettingStartedVisible(true);
    setAIMode(false);
  };

  const handleStartWithIdeation = () => {
    handleAddIdea("Idea...", "", 0, 0);
    resetDirtyFlag();
    setShowStartModal(false);
    setGettingStartedVisible(true);
    setIdeationMode(true);
    setAIMode(false);
  };

  const handleStartWithBrainstorm = () => {
    // Create initial Goal node
    const initialNodes: Node<NodeData>[] = [
      {
        id: "root",
        type: "center",
        data: {
          label: "Goal",
          icon: "",
          object: "",
          objectType: "",
          objectWidth: 200,
          objectHeight: 200,
          notes: "",
          complete: false,
          status: "none",
          flagged: "none",
          color: "black",
          backgroundColor: "#ffffff",
          presentationOrder: "",
          priority: "",
          links: [],
          value: "0",
          values: [],
          rollupValues: [],
          customProperties: [],
          event: {} as Event,
          address: {} as Address,
          task: {} as Task,
          ms365Document: null,
        },
        style: {
          backgroundColor: "#fff",
        },
        position: { x: 0, y: 0 },
        positionAbsolute: { x: 0, y: 0 },
        dragHandle: ".dragHandle",
        dragging: false,
        selected: false,
        width: 200,
        height: 100,
        parentId: "",
      },
    ];
    setNodes(initialNodes);
    setEdges([]);
    resetDirtyFlag();
    setShowStartModal(false);
    setShowBrainstorm(true); // Open brainstorm panel
    setAIMode(false);
  };

  const handleGuidedTemplateSelect = async (templateId: string) => {
    logAppEvent("activity", {
      type: "event",
      name: "guided_template_select",
      template: templateId,
    });

    setShowGuidedCreation(false);
    setCurrentTemplateId(templateId);
    setGuideVisible(true);

    // Load the template - reuse the existing handleImport functionality
    await handleImport(templateId);
  };

  const handleTemplate = async (template: string) => {
    logAppEvent("activity", {
      type: "event",
      name: "load_template",
      template: template,
    });
    setMapTemplate(template);
    switch (template) {
      case "onenote":
        await handleOneNoteData(template);
        break;
      case "sustainability":
        await handleSustainabilityData(template);
        break;
      case "lawyer":
        await handleLawyerData(template);
        break;
      case "microsoft365":
        await handleMicrosoft365Data(template);
        break;
      case "rapidlearningcycles":
        await handleRapidLearningCyclesData(template);
        break;
      default:
        await handleImport(template);
        break;
    }
  };

  const handlePaste = async (event: ClipboardEvent) => {
    if (showNotesModal) return;

    const activeElement = document.activeElement;
    if (
      activeElement &&
      (activeElement.tagName === "INPUT" ||
        activeElement.tagName === "TEXTAREA")
    ) {
      // Let the browser handle the paste event for input/textarea fields
      return;
    }

    const html = event.clipboardData.getData("text/html");
    const rtf = event.clipboardData.getData("text/rtf");
    const plain = event.clipboardData.getData("text/plain");

    if (html) {
      event.preventDefault();

      const { title, notes } = splitTextIntoTitleAndNotes(plain, html);
      const pos =
        newFlowPosition.x !== 0 || newFlowPosition.y !== 0
          ? newFlowPosition
          : { x: 0, y: 0 };
      handleAddIdea(title, notes, pos.x, pos.y, true);
      setNewFlowPosition({ x: 0, y: 0 });
      return;
    }

    if (rtf) {
      // Optional: Handle RTF -> HTML -> Markdown
      event.preventDefault();

      // If you want full RTF support, uncomment and install rtf-to-html
      /*
      const htmlFromRtf = await rtfToHTML(rtf);
      const markdown = htmlToMarkdown(htmlFromRtf);
      */

      // Fallback for now: use plain text if available
      const fallbackText = plain || "[Unsupported RTF content]";
      const { title, notes } = splitTextIntoTitleAndNotes(plain, fallbackText);
      const pos =
        newFlowPosition.x !== 0 || newFlowPosition.y !== 0
          ? newFlowPosition
          : { x: 0, y: 0 };
      handleAddIdea(title, notes, pos.x, pos.y, true);
      setNewFlowPosition({ x: 0, y: 0 });
      return;
    }

    if (plain) {
      event.preventDefault();
      const { title, notes } = splitTextIntoTitleAndNotes(
        plain,
        "plain fallback"
      );
      const pos =
        newFlowPosition.x !== 0 || newFlowPosition.y !== 0
          ? newFlowPosition
          : { x: 0, y: 0 };
      handleAddIdea(title, notes, pos.x, pos.y, true);
      setNewFlowPosition({ x: 0, y: 0 });
      return;
    }

    // Handle objects (files/images)
    if (event.clipboardData.items && event.clipboardData.items.length > 0) {
      const items = event.clipboardData.items;
      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        if (item.type.indexOf("image") !== -1) {
          const file = item.getAsFile();
          // Try to get image dimensions if possible
          if (file && file.type.startsWith("image/")) {
            const img = new window.Image();
            const url = URL.createObjectURL(file);
            img.onload = () => {
              const width = img.width;
              const height = img.height;
              URL.revokeObjectURL(url);
              const reader = new FileReader();
              reader.onload = (e) => {
                const base64 = e.target?.result as string;
                handleAddObject(
                  "image",
                  base64,
                  file,
                  0,
                  0,
                  true,
                  width,
                  height
                );
              };
              reader.readAsDataURL(file);
            };
            img.src = url;
          }
          event.preventDefault();
          return;
        }
        // Handle other file types (e.g., PDFs, text files)
        if (item.type.indexOf("application/pdf") !== -1) {
          const file = item.getAsFile();
          if (file) {
            const reader = new FileReader();
            reader.onload = async (e) => {
              let width = 200;
              let height = 200;
              const url = URL.createObjectURL(file);

              handleAddObject("pdf", url, file, 0, 0, true, width, height);
            };
            reader.readAsDataURL(file);
          }
          event.preventDefault();
          return;
        }
      }
    }

    // Other data types
    const types = Array.from(event.clipboardData.types).filter(
      (t) => t !== "text/plain"
    );
    if (types.length > 0) {
      event.preventDefault();
      showAlert(
        "Paste Detected",
        `You pasted data of type(s): ${types.join(
          ", "
        )}. This is not yet supported.`
      );
    }
  };

  // Clipboard paste event handler
  useEffect(() => {
    window.addEventListener("paste", handlePaste);
    return () => window.removeEventListener("paste", handlePaste);
  }, [showNotesModal, setNodes, showAlert, getViewport]);

  // Keyboard shortcut handler for CTRL+L (layout child nodes), Tab navigation, and arrow key navigation
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      // Tab/Shift+Tab navigation to select nodes
      if (event.key === "Tab") {
        // Check if we're currently in an input field (editing text)
        const activeElement = document.activeElement;
        if (
          activeElement &&
          (activeElement.tagName === "INPUT" ||
            activeElement.tagName === "TEXTAREA")
        ) {
          return; // Allow normal Tab behavior in input fields
        }

        event.preventDefault();

        // Get all visible nodes sorted by position (top to bottom, left to right)
        const visibleNodes = nodes
          .filter((n) => !n.hidden)
          .sort((a, b) => {
            const aY = a.positionAbsolute?.y || a.position.y;
            const bY = b.positionAbsolute?.y || b.position.y;
            const aX = a.positionAbsolute?.x || a.position.x;
            const bX = b.positionAbsolute?.x || b.position.x;

            // Sort by Y first (top to bottom), then by X (left to right)
            if (Math.abs(aY - bY) < 50) {
              // Within 50px vertically, sort by X
              return aX - bX;
            }
            return aY - bY;
          });

        if (visibleNodes.length === 0) {
          return;
        }

        // Find current index
        const currentIndex = selectedNodeId
          ? visibleNodes.findIndex((n) => n.id === selectedNodeId)
          : -1;

        let nextNode: Node<NodeData>;

        if (event.shiftKey) {
          // Shift+Tab: go to previous node
          if (currentIndex <= 0) {
            // Wrap to last node
            nextNode = visibleNodes[visibleNodes.length - 1];
          } else {
            nextNode = visibleNodes[currentIndex - 1];
          }
        } else {
          // Tab: go to next node
          if (currentIndex < 0 || currentIndex >= visibleNodes.length - 1) {
            // Wrap to first node
            nextNode = visibleNodes[0];
          } else {
            nextNode = visibleNodes[currentIndex + 1];
          }
        }

        // Select the node (update both store state and ReactFlow node state)
        setSelectedNode(nextNode);
        setSelectedNodeId(nextNode.id);
        lastSelectedNodeRef.current = nextNode as Node<NodeData>;
        setCurrentNodeColor(nextNode.data.backgroundColor);

        // Update nodes to mark the selected node
        const updatedNodes = nodes.map((node) => ({
          ...node,
          selected: node.id === nextNode.id,
        }));
        setNodes(updatedNodes);

        return;
      }

      // Arrow key navigation to move node position
      if (
        (event.key === "ArrowUp" ||
          event.key === "ArrowDown" ||
          event.key === "ArrowLeft" ||
          event.key === "ArrowRight") &&
        !event.ctrlKey &&
        !event.metaKey
      ) {
        // Check if a node is selected
        if (!selectedNodeId) {
          return;
        }

        // Check if any PrimeReact dialog is visible in the DOM
        const visibleDialogs = document.querySelectorAll(
          ".p-dialog:not(.p-dialog-hidden)"
        );
        if (visibleDialogs.length > 0) {
          return; // Don't navigate if any dialog is open
        }

        // Check if we're currently in an input field (editing text)
        const activeElement = document.activeElement;
        if (
          activeElement &&
          (activeElement.tagName === "INPUT" ||
            activeElement.tagName === "TEXTAREA" ||
            activeElement.getAttribute("contenteditable") === "true")
        ) {
          return; // Don't navigate if user is editing text
        }

        // Also check if any modal state indicates a dialog is open
        if (
          showNotesModal ||
          showCustomPropertiesModal ||
          showHelpModal ||
          showStartModal ||
          showAiModal ||
          showFocusAiModal ||
          showPubMedModal ||
          showBonsaiModal ||
          showCvrModal ||
          showGuidedCreation
        ) {
          return;
        }

        event.preventDefault();

        // Find the currently selected node
        const currentNode = nodes.find((n) => n.id === selectedNodeId);
        if (!currentNode) {
          return;
        }

        // Calculate movement delta (with Shift for larger steps)
        const baseStep = 10;
        const largeStep = 50;
        const step = event.shiftKey ? largeStep : baseStep;

        let deltaX = 0;
        let deltaY = 0;

        switch (event.key) {
          case "ArrowUp":
            deltaY = -step;
            break;
          case "ArrowDown":
            deltaY = step;
            break;
          case "ArrowLeft":
            deltaX = -step;
            break;
          case "ArrowRight":
            deltaX = step;
            break;
        }

        // Take snapshot for undo
        takeSnapshot();

        // Update node position
        // For nodes with parents, position is relative to parent
        // For root nodes, position is absolute on canvas
        const updatedNodes = nodes.map((node) => {
          if (node.id === selectedNodeId) {
            return {
              ...node,
              position: {
                x: node.position.x + deltaX,
                y: node.position.y + deltaY,
              },
            };
          }
          return node;
        });

        setNodes(updatedNodes);
        return;
      }

      // CTRL+SHIFT+L or CMD+SHIFT+L to layout all child branches recursively from selected node
      if (
        event.key === "l" &&
        (event.ctrlKey || event.metaKey) &&
        event.shiftKey
      ) {
        event.preventDefault();

        // Only work if a node is selected
        if (selectedNodeId) {
          takeSnapshot();
          const { redistributeAllChildNodes } = useStore.getState();
          redistributeAllChildNodes(selectedNodeId);
        }
        return;
      }

      // CTRL+SHIFT+R or CMD+SHIFT+R to layout all child nodes in radial/circular pattern
      if (
        event.key === "r" &&
        (event.ctrlKey || event.metaKey) &&
        event.shiftKey
      ) {
        event.preventDefault();

        // Only work if a node is selected
        if (selectedNodeId) {
          takeSnapshot();
          const { redistributeAllChildNodesRadial } = useStore.getState();
          redistributeAllChildNodesRadial(selectedNodeId);
        }
        return;
      }

      // CTRL+N or CMD+N to open notes dialog for selected node
      if (event.key === "n" && (event.ctrlKey || event.metaKey)) {
        event.preventDefault();

        // Check if a node is selected
        if (selectedNodeId) {
          const currentNode = nodes.find((n) => n.id === selectedNodeId);
          if (currentNode) {
            setSelectedNode(currentNode);
            setCurrentNodeLabel(currentNode.data.label);
            setCurrentLinks(currentNode.data.links);
            setCurrentNotes(currentNode.data.notes);
            setShowNotesModal(true);
          }
        }
        return;
      }

      // CTRL+L or CMD+L to layout child nodes in circular pattern
      if (event.key === "l" && (event.ctrlKey || event.metaKey)) {
        event.preventDefault();

        // Check if a node is selected
        if (selectedNodeId) {
          takeSnapshot();
          const { redistributeChildNodes } = useStore.getState();
          redistributeChildNodes(selectedNodeId);
        }
      }

      // F2 to focus input field on selected node
      if (event.key === "F2") {
        event.preventDefault();

        // Check if a node is selected
        if (selectedNodeId) {
          // Find the input element for the selected node
          const inputElement = document.querySelector(
            `input[node-identifier="${selectedNodeId}"]`
          ) as HTMLInputElement;

          if (inputElement) {
            inputElement.focus();
            inputElement.select();
          }
        }
        return;
      }

      // CTRL+SHIFT+Plus or CMD+SHIFT+Plus to increase ALL node distances globally
      if (
        (event.key === "+" || event.key === "=") &&
        (event.ctrlKey || event.metaKey) &&
        event.shiftKey
      ) {
        event.preventDefault();
        takeSnapshot();

        if (selectedNodeId) {
          // Scale all levels from selected node proportionally
          const { increaseChildNodeDistance, scaleAllChildNodePositions } =
            useStore.getState();
          const oldDistance = useStore.getState().childNodeDistance;
          increaseChildNodeDistance();
          const newDistance = useStore.getState().childNodeDistance;
          const scaleFactor = newDistance / oldDistance;
          scaleAllChildNodePositions(selectedNodeId, scaleFactor);
        } else {
          // No node selected, increase globally for all roots
          const { increaseGlobalNodeDistance } = useStore.getState();
          increaseGlobalNodeDistance();
        }
        return;
      }

      // CTRL+Plus or CMD+Plus to increase child node distance
      if (
        (event.key === "+" || event.key === "=") &&
        (event.ctrlKey || event.metaKey) &&
        !event.shiftKey
      ) {
        event.preventDefault();

        const { increaseChildNodeDistance, scaleChildNodePositions } =
          useStore.getState();
        const oldDistance = useStore.getState().childNodeDistance;
        increaseChildNodeDistance();
        const newDistance = useStore.getState().childNodeDistance;
        const scaleFactor = newDistance / oldDistance;

        // If a node is selected, scale its children proportionally
        if (selectedNodeId) {
          takeSnapshot();
          scaleChildNodePositions(selectedNodeId, scaleFactor);
        }
        return;
      }

      // CTRL+SHIFT+Minus or CMD+SHIFT+Minus to decrease ALL node distances globally
      if (
        (event.key === "-" || event.key === "_" || event.code === "Minus") &&
        (event.ctrlKey || event.metaKey) &&
        event.shiftKey
      ) {
        event.preventDefault();
        console.log("🔽 Global decrease triggered");
        takeSnapshot();

        if (selectedNodeId) {
          // Scale all levels from selected node proportionally
          const { decreaseChildNodeDistance, scaleAllChildNodePositions } =
            useStore.getState();
          const oldDistance = useStore.getState().childNodeDistance;
          decreaseChildNodeDistance();
          const newDistance = useStore.getState().childNodeDistance;
          const scaleFactor = newDistance / oldDistance;
          scaleAllChildNodePositions(selectedNodeId, scaleFactor);
        } else {
          // No node selected, decrease globally for all roots
          const { decreaseGlobalNodeDistance } = useStore.getState();
          decreaseGlobalNodeDistance();
        }
        return;
      }

      // CTRL+Minus or CMD+Minus to decrease child node distance
      if (
        (event.key === "-" || event.key === "_" || event.code === "Minus") &&
        (event.ctrlKey || event.metaKey) &&
        !event.shiftKey
      ) {
        event.preventDefault();
        console.log("🔽 Local decrease triggered");

        const { decreaseChildNodeDistance, scaleChildNodePositions } =
          useStore.getState();
        const oldDistance = useStore.getState().childNodeDistance;
        decreaseChildNodeDistance();
        const newDistance = useStore.getState().childNodeDistance;
        const scaleFactor = newDistance / oldDistance;

        // If a node is selected, scale its children proportionally
        if (selectedNodeId) {
          takeSnapshot();
          scaleChildNodePositions(selectedNodeId, scaleFactor);
        }
        return;
      }

      // Shift+R to resolve overlaps
      if (
        event.key === "R" &&
        event.shiftKey &&
        !event.ctrlKey &&
        !event.metaKey
      ) {
        // Check if any PrimeReact dialog is visible in the DOM
        const visibleDialogs = document.querySelectorAll(
          ".p-dialog:not(.p-dialog-hidden)"
        );
        if (visibleDialogs.length > 0) {
          return; // Don't execute if any dialog is open
        }

        // Check if we're currently in an input field (editing text)
        const activeElement = document.activeElement;
        if (
          activeElement &&
          (activeElement.tagName === "INPUT" ||
            activeElement.tagName === "TEXTAREA" ||
            activeElement.getAttribute("contenteditable") === "true")
        ) {
          return; // Don't execute if user is editing text
        }

        event.preventDefault();

        // Save snapshot for undo
        takeSnapshot();

        // Iterate until all overlaps are resolved (max 10 iterations to prevent infinite loops)
        let currentNodes = [...nodes];
        let totalOverlapsResolved = 0;
        const maxIterations = 10;
        let previousOverlapCount = -1;
        let stuckCounter = 0;

        for (let iteration = 0; iteration < maxIterations; iteration++) {
          const adjustedNodes: Node<NodeData>[] = [];
          let overlapFoundThisIteration = false;
          let overlapCountThisIteration = 0;

          currentNodes.forEach((node, index) => {
            let hasOverlap = false;
            let newPosition = { ...node.position };

            for (let i = 0; i < currentNodes.length; i++) {
              if (i === index) continue;

              const otherNode = currentNodes[i];
              // Use actual node dimensions (no padding for detection)
              const nodeWidth = node.width || 150;
              const nodeHeight = node.height || 50;
              const otherNodeWidth = otherNode.width || 150;
              const otherNodeHeight = otherNode.height || 50;

              // Add margin for detection + icon offset (icon is 30px circle at left: -30px)
              // We only care about text overlap, not icon overlap
              const margin = 5;
              const iconOffset = 35; // 30px icon + 5px buffer

              // Check if bounding boxes actually overlap (rectangles intersect)
              // Add iconOffset to left side to skip icon area
              const node1Left = node.position.x + iconOffset;
              const node1Right = node.position.x + nodeWidth - margin;
              const node1Top = node.position.y + margin;
              const node1Bottom = node.position.y + nodeHeight - margin;

              const node2Left = otherNode.position.x + iconOffset;
              const node2Right = otherNode.position.x + otherNodeWidth - margin;
              const node2Top = otherNode.position.y + margin;
              const node2Bottom =
                otherNode.position.y + otherNodeHeight - margin; // Only overlap if boxes truly intersect (not just touching)
              const overlapX = node1Left < node2Right && node1Right > node2Left;
              const overlapY = node1Top < node2Bottom && node1Bottom > node2Top;

              if (overlapX && overlapY) {
                hasOverlap = true;
                overlapFoundThisIteration = true;
                overlapCountThisIteration++;
                totalOverlapsResolved++;

                // Log details only on first iteration
                if (iteration === 0) {
                  console.log(
                    `  Overlap found between node ${node.id} (${node.data?.label}) and ${otherNode.id} (${otherNode.data?.label})`
                  );
                  console.log(
                    `    Node1: x=${node1Left.toFixed(
                      1
                    )} to ${node1Right.toFixed(1)}, y=${node1Top.toFixed(
                      1
                    )} to ${node1Bottom.toFixed(
                      1
                    )} (w=${nodeWidth}, h=${nodeHeight})`
                  );
                  console.log(
                    `    Node2: x=${node2Left.toFixed(
                      1
                    )} to ${node2Right.toFixed(1)}, y=${node2Top.toFixed(
                      1
                    )} to ${node2Bottom.toFixed(
                      1
                    )} (w=${otherNodeWidth}, h=${otherNodeHeight})`
                  );
                }

                // Calculate direction to move away from overlapping node
                const dx = node.position.x - otherNode.position.x;
                const dy = node.position.y - otherNode.position.y;
                const distance = Math.sqrt(dx * dx + dy * dy);

                // If nodes are at same position, move in random direction
                if (distance < 1) {
                  const angle = Math.random() * Math.PI * 2;
                  newPosition.x += Math.cos(angle) * 50;
                  newPosition.y += Math.sin(angle) * 50;
                } else {
                  // Move just enough to clear the overlap
                  const normalizedDx = dx / distance;
                  const normalizedDy = dy / distance;

                  // Calculate minimum separation needed
                  const minSeparation =
                    Math.max(nodeWidth, nodeHeight) / 2 +
                    Math.max(otherNodeWidth, otherNodeHeight) / 2 +
                    10;
                  const currentSeparation = distance;
                  const moveAmount = minSeparation - currentSeparation;

                  if (moveAmount > 0) {
                    newPosition.x += normalizedDx * moveAmount;
                    newPosition.y += normalizedDy * moveAmount;
                  }
                }
              }
            }

            adjustedNodes.push({
              ...node,
              position: hasOverlap ? newPosition : node.position,
            });
          });

          currentNodes = adjustedNodes;

          // If no overlaps found in this iteration, we're done
          if (!overlapFoundThisIteration) {
            console.log(
              `✅ All overlaps resolved after ${
                iteration + 1
              } iteration(s). Total overlaps fixed: ${totalOverlapsResolved}`
            );
            break;
          }

          // Check if we're stuck (same number of overlaps for 3 consecutive iterations)
          if (overlapCountThisIteration === previousOverlapCount) {
            stuckCounter++;
            if (stuckCounter >= 3) {
              console.log(
                `⚠️ Overlap resolution stuck after ${
                  iteration + 1
                } iterations with ${overlapCountThisIteration} overlaps remaining. Stopping to prevent infinite loop.`
              );
              break;
            }
          } else {
            stuckCounter = 0; // Reset if count changed
          }
          previousOverlapCount = overlapCountThisIteration;

          // If this was the last iteration and still had overlaps
          if (iteration === maxIterations - 1) {
            console.log(
              `⚠️ Reached max iterations (${maxIterations}). Total overlaps fixed: ${totalOverlapsResolved}, ${overlapCountThisIteration} remaining`
            );
          }
        }

        setNodes(currentNodes);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [selectedNodeId, nodes, setNodes]);

  const getChildNodePosition = (
    event: React.MouseEvent<Element, MouseEvent>,
    parentId?: Node
  ) => {
    const { domNode } = store.getState();

    if (
      !domNode ||
      // we need to check if these properites exist, because when a node is not initialized yet,
      // it doesn't have a positionAbsolute nor a width or height
      !parentId?.positionAbsolute ||
      !parentId?.width ||
      !parentId?.height
    ) {
      // console.log("parentNode not yet initialized", domNode);
      return;
    }

    const { top, left } = domNode.getBoundingClientRect();

    // we need to remove the wrapper bounds, in order to get the correct mouse position
    const panePosition = project({
      x: event.clientX - left,
      y: event.clientY - top,
    });

    // we are calculating with positionAbsolute here because child nodes are positioned relative to their parent
    return {
      x: panePosition.x - parentId.positionAbsolute.x + parentId.width / 2,
      y: panePosition.y - parentId.positionAbsolute.y + parentId.height / 2,
    };
  };

  const onConnectStart: OnConnectStart = useCallback((_, { nodeId }) => {
    // Check if the source node is disabled (not draggable)
    const { nodeInternals } = store.getState();
    const sourceNode = nodeInternals.get(nodeId || "");

    // Allow FocusItem nodes (type === 'center') to create connections even if disabled
    if (
      sourceNode &&
      sourceNode.draggable === false &&
      sourceNode.type !== "center"
    ) {
      // Don't allow connection from disabled nodes (except FocusItem)
      connectingNodeId.current = null;
      return;
    }
    // we need to remember where the connection started so we can add the new node to the correct parent on connect end
    takeSnapshot();
    connectingNodeId.current = nodeId;
  }, []);

  const onConnectEnd: OnConnectEnd = useCallback(
    (event) => {
      const { nodeInternals, edges } = store.getState();
      const targetIsPane = (event.target as Element).classList.contains(
        "react-flow__pane"
      );
      const node = (event.target as Element).closest(".react-flow__node");

      if (node && connectingNodeId.current === node.getAttribute("data-id")) {
        if (node.querySelector("input")) {
          const inputField = node.querySelector("input");
          inputField?.focus({ preventScroll: true });
        }
      } else if (targetIsPane && connectingNodeId.current) {
        const parentNode = nodeInternals.get(connectingNodeId.current);
        const childNodePosition = getChildNodePosition(
          event as unknown as React.MouseEvent<Element, MouseEvent>,
          parentNode
        );

        if (parentNode && childNodePosition) {
          addChildNode(parentNode, childNodePosition);

          // Capture the selected node immediately while it's still in the store
          const newlyCreatedNode = useStore.getState().selectedNode;
          if (newlyCreatedNode) {
            lastSelectedNodeRef.current = newlyCreatedNode;
            justCreatedNodeViaConnect.current = true;

            // Focus the input field of the newly created node
            setTimeout(() => {
              const newNodeElement = document.querySelector(
                `[data-id="${newlyCreatedNode.id}"]`
              );
              const inputField = newNodeElement?.querySelector("input");
              if (inputField) {
                (inputField as HTMLInputElement).focus({ preventScroll: true });
              }
            }, 50);
          }
        }
      } else if (connectingNodeId.current) {
        const childNodeId = connectingNodeId.current;
        if (childNodeId === "root") {
          showAlert(
            "Info",
            "This is the top node in the hierarchy and cannot be connected to a child node"
          );
          return;
        }

        const newParentNodeId = (event.target as Element)
          .closest(".react-flow__node")
          ?.getAttribute("data-id");

        if (newParentNodeId) {
          // Validate connection before creating it
          if (childNodeId === newParentNodeId) {
            showAlert("Info", "A node cannot be connected to itself");
            return;
          }

          // Check for circular dependency
          const isAncestor = (
            potentialAncestorId: string,
            nodeId: string,
            visited = new Set<string>()
          ): boolean => {
            if (potentialAncestorId === nodeId) return true;
            if (visited.has(nodeId)) return false;
            visited.add(nodeId);
            const parentEdge = edges.find((edge) => edge.target === nodeId);
            if (!parentEdge) return false;
            return isAncestor(potentialAncestorId, parentEdge.source, visited);
          };

          if (isAncestor(childNodeId, newParentNodeId)) {
            showAlert(
              "Info",
              "This connection would create a circular reference and is not allowed"
            );
            return;
          }

          // Check if the child node is already connected to another parent node
          const existingEdge = edges.find(
            (edge) => edge.target === childNodeId
          );

          if (existingEdge) {
            const childNode = nodes.find((node) => node.id === childNodeId);
            const newParentNode = nodes.find(
              (node) => node.id === newParentNodeId
            );

            if (childNode && newParentNode) {
              if (event.shiftKey) {
                takeSnapshot();
                addCrossLine(childNodeId, newParentNodeId);
              } else {
                // Update the parent node connection to the new node and remove the connection from the previous parent node
                updateParentNode(
                  childNodeId,
                  newParentNodeId,
                  childNode,
                  newParentNode
                );
              }
            }
          } else {
            const childNode = nodes.find((node) => node.id === childNodeId);
            const newParentNode = nodes.find(
              (node) => node.id === newParentNodeId
            );
            if (!newParentNode || !childNode) {
              console.error("New parent node or child node not found");
              return;
            }

            // Don't change position - just set the parent and add the edge
            // Let ReactFlow handle the positioning internally
            const updatedNodes = nodes.map((node) =>
              node.id === childNodeId
                ? {
                    ...node,
                    parentId: newParentNodeId,
                  }
                : node
            );

            // If no existing edge, add a new edge connecting the child node to the new parent node
            const newEdge: Edge = {
              id: nanoid(),
              source: newParentNodeId,
              target: childNodeId,
              type: "mindmap",
            };

            setNodes(updatedNodes);
            setEdges([...edges, newEdge]);
          }
        }
      }
      setIsDirty(true);
    },
    [getChildNodePosition, updateParentNode]
  );

  const handleCompleteToggle = (event: MenuItemCommandEvent): void => {
    if (selectedNodeId) {
      takeSnapshot();
      const updatedNodes = nodes.map((node) => {
        if (
          selectedNodeId &&
          node.id === selectedNodeId
          //|| (event.shiftKey && isChildNode(selectedNodeId, node.id))
        ) {
          return {
            ...node,
            data: {
              ...node.data,
              complete: selectedNode ? !selectedNode.data.complete : false,
            },
          };
        }
        return node;
      });
      setNodes(updatedNodes);
      setIsDirty(true);
    }
    handleCloseContextMenu();
  };

  const handleCloseContextMenu = () => {
    setContextMenu({ mouseX: 0, mouseY: 0, node: null });
  };

  const nodeContextMenuItems = [
    {
      label: "Notes & Links",
      icon: "pi pi-book",
      command: (event: MenuItemCommandEvent) => handleOpenNotes(event),
    },
    {
      separator: true,
    },
    // {
    //   label: selectedNode?.data?.complete ? "Remove Done" : "Done",
    //   icon: "pi pi-check-circle",
    //   command: (event: MenuItemCommandEvent) => handleCompleteToggle(event),
    // },
    {
      label: "Flag",
      icon: "pi pi-flag",
      items: [
        {
          label: "None",
          icon: "pi pi-flag",
          command: (event: MenuItemCommandEvent) =>
            handleFlagChange("none", event),
        },
        {
          label: "Green",
          icon: "pi pi-flag-fill green-flag",
          command: (event: MenuItemCommandEvent) =>
            handleFlagChange("green", event),
        },
        {
          label: "Yellow",
          icon: "pi pi-flag-fill yellow-flag",
          command: (event: MenuItemCommandEvent) =>
            handleFlagChange("yellow", event),
        },
        {
          label: "Red",
          icon: "pi pi-flag-fill red-flag",
          className: "red-flag",
          command: (event: MenuItemCommandEvent) =>
            handleFlagChange("red", event),
        },
      ],
    },
    {
      label: "Color",
      icon: "pi pi-circle",
      command: (event: MenuItemCommandEvent) => handleSelectColor(event),
    },
    {
      label: "Image",
      icon: "pi pi-image",
      items: [
        {
          label: "Image",
          icon: "pi pi-image",
          command: (event: MenuItemCommandEvent) =>
            handleImageMenuItemClick(event),
        },
        {
          label: "Image from URL",
          icon: "pi pi-link",
          command: (event: MenuItemCommandEvent) =>
            handleImageByUrlMenuItemClick(event),
        },
        {
          label: "Emoji",
          icon: "pi pi-face-smile",
          command: (event: MenuItemCommandEvent) =>
            handleEmojiMenuItemClick(event),
        },
        { separator: true },
        {
          label: "Remove",
          icon: "pi pi-times-circle",
          command: (event: MenuItemCommandEvent) => handleRemoveImage(event),
        },
      ],
    },
    {
      label: "Properties",
      icon: "pi pi-code",
      command: (event: MenuItemCommandEvent) =>
        handleLoadCustomProperties(event),
    },
    {
      separator: true,
    },
    {
      label: "Copy Nodes",
      icon: "pi pi-copy",
      command: (event: MenuItemCommandEvent) => handleCopyNodes(event),
    },
  ];

  const contextMenuItems = [
    {
      label: "Add Goal",
      icon: "pi pi-circle",
      command: () =>
        handleAddFocus(newFlowPosition.x + 70, newFlowPosition.y - 35),
    },
    {
      label: "Add Idea",
      icon: "pi pi-lightbulb",
      command: () =>
        handleAddIdea("Idea...", "", newFlowPosition.x + 70, newFlowPosition.y),
    },
    {
      label: "Add Insights",
      icon: "pi pi-database",
      items: useStore.getState().sourceOptions.map((source) => {
        const insight = insightsCollection.find(
          (insight) => insight.key === source
        );
        const title = insight ? insight.data.title : source;
        return {
          label: title,
          command: () => {
            switch (source) {
              case "chatgpt":
                setShowAiModal(true);
                break;
              case "focusai":
                setShowFocusAiModal(true);
                break;
              case "pubmed":
                setShowPubMedModal(true);
                break;
              default:
                showAlert("Information", "This source is not yet implemented");
                break;
            }
          },
        };
      }),
    },
    {
      separator: true,
    },
    {
      label: "Paste Nodes",
      icon: "pi pi-clipboard",
      command: () => handlePasteNodes(newFlowPosition.x, newFlowPosition.y),
    },
    // {
    //   separator: true,
    // },
    // {
    //   label: "Paste Clipboard",
    //   icon: "pi pi-clipboard",
    //   command: async () => {
    //     const pastedText = await navigator.clipboard.readText();
    //     if (pastedText) {
    //       const { title, notes } = splitTextIntoTitleAndNotes(
    //         pastedText,
    //         "fallback clipboard paste"
    //       );
    //       handleAddIdea(title, notes, newFlowPosition.x, newFlowPosition.y);
    //     } else {
    //       showAlert(
    //         "Error",
    //         "No text found in clipboard. Please copy some text and try again."
    //       );
    //     }
    //   },
    // },
  ];

  const handleLoad = async (flowId: string | undefined) => {
    logAppEvent("activity", {
      type: "event",
      name: "load_map",
      flowId: flowId,
    });
    if (!flowId || flowId === "new") {
      return;
    }
    const flowData = await loadFlowData(
      flowId ? flowId : "",
      useStore.getState().useLocalStorage
    );
    if (flowData) {
      setCurrentMapFavourite(flowData.favourite);
      setCurrentMapName(flowData.name);

      // Convert legacy "parentNode" property to "parentId" for each node
      if (flowData.nodes && Array.isArray(flowData.nodes)) {
        flowData.nodes = flowData.nodes.map((node: any) => {
          if (node.parentId !== undefined && node.parentId === undefined) {
            return {
              ...node,
              parentId: node.parentId,
              data: {
                ...node.data,
                // notes:
                //   node.data.notes && isHTML(node.data.notes)
                //     ? markdownConverter.convert(node.data.notes)
                //     : node.data.notes,
              },
              ...(delete node.parentId, node),
            };
          }
          return node;
        });
      }

      const updatedNodes = flowData.nodes.map((node: Node<NodeData>) => {
        // Auto-set type to "image" for old maps with icon but no type
        let nodeType = node.data?.type;
        if (!nodeType && node.data?.icon && node.data.icon.length > 0) {
          nodeType = "image";
        }

        if (
          node.data &&
          node.data.notes &&
          (isHTML(node.data.notes) || hasBrTags(node.data.notes))
        ) {
          return {
            ...node,
            data: {
              ...node.data,
              type: nodeType,
              // notes:
              //   node.data.notes && isHTML(node.data.notes)
              //     ? markdownConverter.convert(node.data.notes)
              //     : removeOptionalBrTags(node.data.notes),
              event: node.data.event ?? {},
              address: node.data.address ?? {},
              task: node.data.task ?? {},
            },
          };
        }

        // Apply type update even if no notes conversion needed
        if (nodeType && nodeType !== node.data?.type) {
          return {
            ...node,
            data: {
              ...node.data,
              type: nodeType,
            },
          };
        }

        return node;
      });

      flowData.nodes = updatedNodes;

      const customState: FocusMapFlowState = {
        nodes: flowData.nodes,
        edges: flowData.edges,
      };
      store.setState(customState);

      setNodes(flowData.nodes);
      setEdges(flowData.edges);
    }
  };

  const handleAddFocus = async (x: number, y: number) => {
    try {
      takeSnapshot();

      // const rootNode = nodes.find((node) => node.id === "root");
      // if (!rootNode) {
      //   alert("Root node not found");
      //   return;
      // }

      let newFocusX = x;
      let newFocusY = y;

      const viewport = getViewport();
      newFocusX = (newFocusX - viewport.x) / viewport.zoom;
      newFocusY = (newFocusY - viewport.y) / viewport.zoom;

      const newRootNode: Node = {
        id: nanoid(),
        type: "center",
        data: {
          label: "New Focus",
          icon: "",
          object: "",
          objectType: "",
          objectWidth: 40,
          objectHeight: 18,
          notes: "",
          complete: false,
          status: "none",
          flagged: "none",
          color: "black",
          backgroundColor: "#ffffff",
          presentationOrder: "",
          priority: "",
          links: [],
          value: "0",
          values: [],
          rollupValues: [],
          customProperties: [], //rootNode.data.customProperties,
          event: {} as Event,
          address: {} as Address,
        },
        position: { x: newFocusX, y: newFocusY },
        positionAbsolute: { x: newFocusX, y: newFocusY },
        dragHandle: ".dragHandle",
        width: 40,
        height: 18,
        parentId: "",
      };
      const newFlowData = [newRootNode, ...nodes];
      const customState: FocusMapFlowState = {
        nodes: newFlowData,
        edges: edges,
      };
      store.setState(customState);

      setNodes(newFlowData);
      setEdges(edges);
    } catch (error) {
      alert("Error adding focus: " + error);
    }
  };

  const handlePasteNodes = async (x: number, y: number) => {
    try {
      takeSnapshot();

      let newFocusX = x;
      let newFocusY = y;

      const viewport = getViewport();
      newFocusX = (newFocusX - viewport.x) / viewport.zoom;
      newFocusY = (newFocusY - viewport.y) / viewport.zoom;

      const parentNodeX = newFocusX;
      const parentNodeY = newFocusY;

      if (copiedNodes.length > 0) {
        const idMap = new Map<string, string>();
        const newNodes: Node<NodeData>[] = copiedNodes.map((node) => {
          const newId = nanoid();
          idMap.set(node.id, newId);

          const xOffset =
            node.id === copiedNodes[0].id ? parentNodeX : node.position.x;
          const yOffset =
            node.id === copiedNodes[0].id ? parentNodeY : node.position.y;

          return {
            ...node,
            id: newId,
            position: {
              x: xOffset,
              y: yOffset,
            },
            parentId: node.parentId ? idMap.get(node.parentId) || "" : "",
          };
        });

        const newEdges = copiedEdges.map((edge) => ({
          ...edge,
          id: nanoid(),
          source: idMap.get(edge.source) || edge.source,
          target: idMap.get(edge.target) || edge.target,
        }));

        setNodes([...nodes, ...newNodes]);
        setEdges([...edges, ...newEdges]);
      }
      setNewFlowPosition({ x: 0, y: 0 });
    } catch (error) {
      alert("Error pasting nodes: " + error);
    }
  };

  const addUpdateEvent = (
    id: string,
    nodeTitle: string,
    title: string,
    description: string,
    date: Date,
    icon: string = "",
    color: string = ""
  ) => {
    try {
      takeSnapshot();

      const existingNodeIndex = nodes.findIndex(
        (node: Node<NodeData>) => node.id === id
      );
      if (existingNodeIndex !== -1) {
        // Node exists, update its properties
        const updatedNodes = nodes.map((node: Node<NodeData>, idx) =>
          idx === existingNodeIndex
            ? {
                ...node,
                data: {
                  ...node.data,
                  event: {
                    id: id,
                    nodeTitle: nodeTitle || "",
                    title: title || "",
                    description: description || "",
                    date: date || undefined,
                    icon: icon,
                    color: color,
                  },
                },
              }
            : node
        );
        setNodes(updatedNodes);
        setSelectedNode(updatedNodes[existingNodeIndex]);
        setIsDirty(true);
        return;
      }

      const viewport = getViewport();
      let newFocusX = (viewport.x + 40) / viewport.zoom;
      let newFocusY = (viewport.y + 40) / viewport.zoom;

      const eventNode: Node<NodeData> = {
        id: nanoid(),
        type: "mindmap",
        style: {
          backgroundColor: "#fff",
        },
        data: {
          label: nodeTitle,
          icon: "https://static.wixstatic.com/shapes/2fe974_5975ddfac84d4a449ef668e0fcab3a26.svg",
          object: "",
          objectType: "text",
          objectWidth: 50,
          objectHeight: 18,
          notes: description || "",
          complete: false,
          status: "none",
          flagged: "none",
          color: "black",
          backgroundColor: "#ffffff",
          presentationOrder: "",
          priority: "",
          links: [],
          value: "0",
          values: [],
          rollupValues: [],
          customProperties: [],
          event: {
            id: id,
            date: date || undefined,
            description: description || "",
            title: title || "",
          } as Event,
          address: {} as Address,
          task: {} as Task,
          ms365Document: null,
        },
        position: { x: 0, y: 0 },
        positionAbsolute: { x: 0, y: 0 },
        dragging: false,
        selected: false,
        width: 50,
        height: 18,
        dragHandle: ".dragHandle",
        parentId: "",
      };
      const newFlowNodes: Node<NodeData>[] = [eventNode, ...nodes];
      const customState: FocusMapFlowState = {
        nodes: newFlowNodes,
        edges: edges,
      };
      store.setState(customState);

      setNodes(newFlowNodes);
      setEdges(edges);

      if (newFlowNodes.length < 2) {
        handleFitView();
      }
    } catch (error) {
      alert("Error adding event: " + error);
    }
  };

  const handleDeleteEvent = async (id: string) => {
    try {
      takeSnapshot();
      const updatedNodes = nodes.map((node) =>
        node.id === id
          ? {
              ...node,
              data: {
                ...node.data,
                event: {
                  id: "",
                  nodeTitle: "",
                  title: "",
                  description: "",
                  date: undefined,
                  icon: "",
                  color: "",
                },
              },
            }
          : node
      );
      const customState: FocusMapFlowState = {
        nodes: updatedNodes,
        edges: edges,
      };
      store.setState(customState);
      setNodes(updatedNodes);
      setEdges(edges);
    } catch (error) {
      alert("Error deleting event: " + error);
    }
  };

  const addUpdateTask = async (
    id: string,
    title: string,
    nodeTitle: string,
    status: string,
    summary: string,
    priority: string,
    tags: string,
    assignee: string,
    estimate: number,
    rankId: number,
    color: string,
    className: string,
    startDate: Date | null,
    endDate: Date | null
  ) => {
    try {
      takeSnapshot();

      // Get fresh nodes from store to avoid stale closure
      const currentNodes = useStore.getState().nodes;
      const existingNodeIndex = currentNodes.findIndex(
        (node: Node<NodeData>) => node.id === id
      );
      if (existingNodeIndex !== -1) {
        // Node exists, update its properties
        const updatedNodes = currentNodes.map((node: Node<NodeData>, idx) =>
          idx === existingNodeIndex
            ? {
                ...node,
                data: {
                  ...node.data,
                  task: {
                    id,
                    nodeTitle,
                    title,
                    status,
                    summary,
                    priority,
                    tags,
                    assignee,
                    estimate,
                    rankId,
                    color,
                    className,
                    startDate: startDate ? startDate.toISOString() : undefined,
                    endDate: endDate ? endDate.toISOString() : undefined,
                  } as Task,
                },
              }
            : node
        );
        setNodes(updatedNodes);
        setSelectedNode(updatedNodes[existingNodeIndex]);
        setIsDirty(true);
        return;
      }

      const viewport = getViewport();
      let newFocusX = (viewport.x + 40) / viewport.zoom;
      let newFocusY = (viewport.y + 40) / viewport.zoom;

      const taskNode: Node<NodeData> = {
        id: nanoid(),
        type: "mindmap",
        style: {
          backgroundColor: "#fff",
        },
        data: {
          label: title,
          icon: "https://static.wixstatic.com/media/_ce2765a9e79f4854a82fa418e8a86b8d~mv2.png",
          object: "",
          objectType: "text",
          objectWidth: 50,
          objectHeight: 18,
          notes: summary || "",
          complete: false,
          status: status || "none",
          flagged: "none",
          color: color || "black",
          backgroundColor: "#ffffff",
          presentationOrder: "",
          priority: priority || "",
          links: [],
          value: "0",
          values: [],
          rollupValues: [],
          customProperties: [],
          event: {} as Event,
          address: {
            id: id,
            nodeTitle: "",
            vat: "",
            name: "",
            street: "",
            zip_code: "",
            city: "",
            Phone: "",
            email: "",
            employees: "",
            notes: "",
            icon: "",
            color: "",
          } as Address,
          task: {} as Task,
          ms365Document: null,
        },
        position: { x: 0, y: 0 },
        positionAbsolute: { x: 0, y: 0 },
        dragging: false,
        selected: false,
        width: 50,
        height: 18,
        dragHandle: ".dragHandle",
        parentId: "",
      };
      const newFlowNodes: Node<NodeData>[] = [taskNode, ...nodes];
      const customState: FocusMapFlowState = {
        nodes: newFlowNodes,
        edges: edges,
      };
      store.setState(customState);

      setNodes(newFlowNodes);
      setEdges(edges);

      if (newFlowNodes.length < 2) {
        handleFitView();
      }
    } catch (error) {
      alert("Error adding task: " + error);
    }
  };

  const deleteTask = async (id: string) => {
    try {
      takeSnapshot();
      const updatedNodes = nodes.map((node) =>
        node.id === id
          ? {
              ...node,
              data: {
                ...node.data,
                task: {} as Task,
              },
            }
          : node
      );
      const customState: FocusMapFlowState = {
        nodes: updatedNodes,
        edges: edges,
      };
      store.setState(customState);
      setNodes(updatedNodes);
      setEdges(edges);
    } catch (error) {
      alert("Error deleting task: " + error);
    }
  };

  const addUpdateAddress = async (
    id: string,
    nodeTitle: string,
    name: string,
    street: string,
    zip_code: string,
    city: string,
    Phone: string,
    email: string,
    vat: string,
    employees: string,
    notes: string,
    latitude?: number,
    longitude?: number
  ) => {
    try {
      takeSnapshot();

      const existingNodeIndex = nodes.findIndex(
        (node: Node<NodeData>) => node.id === id
      );
      if (existingNodeIndex !== -1) {
        // Node exists, update its address properties
        const updatedNodes = nodes.map((node: Node<NodeData>, idx) =>
          idx === existingNodeIndex
            ? {
                ...node,
                data: {
                  ...node.data,
                  address: {
                    id,
                    nodeTitle,
                    name,
                    street,
                    zip_code,
                    city,
                    Phone,
                    email,
                    vat,
                    employees,
                    notes,
                    latitude,
                    longitude,
                  },
                },
              }
            : node
        );
        setNodes(updatedNodes);
        setSelectedNode(updatedNodes[existingNodeIndex]);
        setIsDirty(true);
        return;
      }

      const viewport = getViewport();
      let newFocusX = (viewport.x + 40) / viewport.zoom;
      let newFocusY = (viewport.y + 40) / viewport.zoom;

      const addressNode: Node<NodeData> = {
        id: nanoid(),
        type: "mindmap",
        style: {
          backgroundColor: "#fff",
        },
        data: {
          label: name || street || "Address",
          icon: "https://static.wixstatic.com/shapes/2fe974_7442ad965e4d41c3a5676f5799308e90.svg",
          object: "",
          objectType: "text",
          objectWidth: 50,
          objectHeight: 18,
          notes: notes || "",
          complete: false,
          status: "none",
          flagged: "none",
          color: "black",
          backgroundColor: "#ffffff",
          presentationOrder: "",
          priority: "",
          links: [],
          value: "0",
          values: [],
          rollupValues: [],
          customProperties: [],
          event: {} as Event,
          address: {
            id,
            nodeTitle,
            name,
            street,
            zip_code,
            city,
            Phone,
            email,
            vat,
            employees,
            notes,
            latitude,
            longitude,
          } as Address,
          task: {} as Task,
          ms365Document: {} as MS365Document,
        },
        position: { x: newFocusX, y: newFocusY },
        positionAbsolute: { x: newFocusX, y: newFocusY },
        dragging: false,
        selected: false,
        width: 50,
        height: 18,
        dragHandle: ".dragHandle",
        parentId: "",
      };
      const newFlowNodes: Node<NodeData>[] = [addressNode, ...nodes];
      const customState: FocusMapFlowState = {
        nodes: newFlowNodes,
        edges: edges,
      };
      store.setState(customState);

      setNodes(newFlowNodes);
      setEdges(edges);

      if (newFlowNodes.length < 2) {
        handleFitView();
      }
    } catch (error) {
      alert("Error adding address: " + error);
    }
  };

  const deleteAddress = async (id: string) => {
    try {
      takeSnapshot();
      const updatedNodes = nodes.map((node) =>
        node.id === id
          ? {
              ...node,
              data: {
                ...node.data,
                address: {} as Address,
              },
            }
          : node
      );
      const customState: FocusMapFlowState = {
        nodes: updatedNodes,
        edges: edges,
      };
      store.setState(customState);
      setNodes(updatedNodes);
      setEdges(edges);
    } catch (error) {
      alert("Error deleting address: " + error);
    }
  };

  const handleAddAINode = async (title: string, notes: string) => {
    try {
      takeSnapshot();

      if (showNotesModal) {
        setAIResponse(converter.makeHtml(notes));
        setBrainstormVisible(false);
        setAIMode(false);
      } else {
        // Find a non-overlapping position for the new node
        // Use helper to get a free spot
        const viewport = getViewport();
        const paneWidth = flowMapWrapper.current?.offsetWidth || 800;
        const paneHeight = flowMapWrapper.current?.offsetHeight || 600;
        const ideaWidth = 50;
        const ideaHeight = 18;
        let parentId: string | undefined = undefined;
        let parentEdge: Edge | undefined = undefined;
        if (selectedNode) {
          parentId = selectedNode.id;
        }
        const { x: newFocusX, y: newFocusY } = getNonOverlappingPosition({
          nodes,
          viewport,
          flowMapWrapper,
          selectedNode,
          ideaWidth,
          ideaHeight,
        });

        let processedNotes = notes;
        if (notes) {
          processedNotes = converter.makeHtml(notes);
        }

        const ideaNode: Node<NodeData> = {
          id: nanoid(),
          type: "mindmap",
          style: {
            backgroundColor: "#fff",
          },
          data: {
            label: title,
            icon: "https://static.wixstatic.com/media/_787025d806fc4adfb35aa3f4cadfb735~mv2.png",
            object: "",
            objectType: "text",
            objectWidth: 50,
            objectHeight: 18,
            notes: processedNotes,
            complete: false,
            status: "none",
            flagged: "none",
            color: "black",
            backgroundColor: "#ffffff",
            presentationOrder: "",
            priority: "",
            links: [],
            value: "0",
            values: [],
            rollupValues: [],
            customProperties: [],
            event: {} as Event,
            address: {} as Address,
            task: {} as Task,
            ms365Document: null,
          },
          position: { x: newFocusX, y: newFocusY },
          positionAbsolute: { x: newFocusX, y: newFocusY },
          dragging: false,
          selected: false,
          width: 50,
          height: 18,
          dragHandle: ".dragHandle",
          parentId: "",
        };
        const newFlowNodes: Node<NodeData>[] = [ideaNode, ...nodes];
        if (parentId) {
          ideaNode.parentId = parentId;
          parentEdge = {
            id: nanoid(),
            source: parentId,
            target: ideaNode.id,
            type: "center",
          };
          edges.push(parentEdge);
        }
        const customState: FocusMapFlowState = {
          nodes: newFlowNodes,
          edges: edges,
        };
        store.setState(customState);

        setNodes(newFlowNodes);
        setEdges(edges);

        if (newFlowNodes.length < 2) {
          handleFitView();
        }
      }
    } catch (error) {
      alert("Error adding event: " + error);
    }
  };

  const handleAddDocumentStructure = async (title: string, notes: string) => {
    try {
      takeSnapshot();

      if (showNotesModal) {
        setAIResponse(converter.makeHtml(notes));
        setBrainstormVisible(false);
        setAIMode(false);
        return;
      }

      // Find a non-overlapping position for the new node
      // Use helper to get a free spot
      const viewport = getViewport();
      const paneWidth = flowMapWrapper.current?.offsetWidth || 800;
      const paneHeight = flowMapWrapper.current?.offsetHeight || 600;
      const ideaWidth = 50;
      const ideaHeight = 18;
      let parentId: string | undefined = undefined;
      let parentEdge: Edge | undefined = undefined;
      if (selectedNode) {
        parentId = selectedNode.id;
      }
      const { x: newFocusX, y: newFocusY } = getNonOverlappingPosition({
        nodes,
        viewport,
        flowMapWrapper,
        selectedNode,
        ideaWidth,
        ideaHeight,
      });

      let htmlNotes = notes;
      if (notes) {
        htmlNotes = converter.makeHtml(notes);
      }

      // Parse htmlNotes into a tree structure and create nodes/edges for React Flow

      // Helper to parse the htmlNotes into a hierarchical structure
      function parseHtmlNotesToTree(htmlNotes: string) {
        // Parse HTML string
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlNotes, "text/html");

        // Get the header (assume first h1 or h2)
        const headerEl = doc.querySelector("h1, h2");
        const header = headerEl
          ? headerEl.textContent?.trim() || "Document"
          : "Document";

        // Get intro text (all <p> before first chapter heading)
        let intro = "";
        let node = headerEl
          ? headerEl.nextElementSibling
          : doc.body.firstElementChild;
        while (node && !/^H[2-6]$/i.test(node.tagName)) {
          if (node.tagName === "P") {
            intro += (node.textContent || "") + "\n";
          }
          node = node.nextElementSibling;
        }

        // Helper to recursively parse chapters and subchapters
        function parseChapters(startNode: Element, parentLevel: number) {
          const chapters: any[] = [];
          let current: any = null;
          let node = startNode;
          while (node) {
            if (/^H[2-6]$/i.test(node.tagName)) {
              const level = parseInt(node.tagName[1]);
              if (level > parentLevel) {
                // New chapter/subchapter
                if (current) chapters.push(current);
                current = {
                  label: node.textContent?.trim() || "",
                  notes: "",
                  children: [],
                  level,
                };
              } else {
                // End of this chapter level
                break;
              }
            } else if (current && node.tagName === "P") {
              current.notes += (node.textContent || "") + "\n";
            }
            // Check for subchapters
            if (
              current &&
              node.nextElementSibling &&
              /^H[2-6]$/i.test(node.nextElementSibling.tagName)
            ) {
              const nextLevel = parseInt(node.nextElementSibling.tagName[1]);
              if (nextLevel > current.level) {
                // Parse subchapters recursively
                const subChapters = parseChapters(
                  node.nextElementSibling,
                  current.level
                );
                current.children.push(...subChapters.chapters);
                node = subChapters.lastNode;
                continue;
              }
            }
            node = node.nextElementSibling;
          }
          if (current) chapters.push(current);
          return { chapters, lastNode: node };
        }

        // Start parsing chapters from first heading after intro
        let firstChapter = headerEl
          ? headerEl.nextElementSibling
          : doc.body.firstElementChild;
        while (firstChapter && !/^H[2-6]$/i.test(firstChapter.tagName)) {
          firstChapter = firstChapter.nextElementSibling;
        }
        const { chapters } = firstChapter
          ? parseChapters(firstChapter, 1)
          : { chapters: [] };

        return {
          label: header,
          notes: intro.trim(),
          children: chapters,
        };
      }

      // Helper to flatten the tree into nodes and edges for React Flow
      function treeToNodesAndEdges(
        tree: any,
        parentId: string | null = null,
        nodes: Node<NodeData>[] = [],
        edges: Edge[] = []
      ) {
        const nodeId = nanoid();
        nodes.push({
          id: nodeId,
          type: parentId ? "mindmap" : "center",
          data: {
            label: tree.label,
            notes: tree.notes,
            icon: "",
            object: "",
            objectType: "text",
            objectWidth: 50,
            objectHeight: 18,
            complete: false,
            status: "none",
            flagged: "none",
            color: "black",
            backgroundColor: "#ffffff",
            presentationOrder: "",
            priority: "",
            links: [],
            value: "0",
            values: [],
            rollupValues: [],
            customProperties: [],
            event: {} as Event,
            address: {} as Address,
            task: {} as Task,
            ms365Document: null,
          },
          position: { x: 0, y: 0 },
          positionAbsolute: { x: 0, y: 0 },
          width: 50,
          height: 18,
          dragHandle: ".dragHandle",
          parentId: parentId || "",
          selected: false,
          dragging: false,
        });
        if (parentId) {
          edges.push({
            id: nanoid(),
            source: parentId,
            target: nodeId,
            type: parentId === "root" ? "center" : "mindmap",
          });
        }
        if (tree.children && tree.children.length > 0) {
          for (const child of tree.children) {
            treeToNodesAndEdges(child, nodeId, nodes, edges);
          }
        }
        return { nodes, edges };
      }

      // Main logic for handleAddDocumentStructure
      const htmlTree = parseHtmlNotesToTree(htmlNotes);
      const { nodes: docNodes, edges: docEdges } =
        treeToNodesAndEdges(htmlTree);

      // Optionally, layout nodes in a circle for better visualization
      const layoutedNodes = await doCircleLayout(docNodes, docEdges);

      const customState: FocusMapFlowState = {
        nodes: layoutedNodes || docNodes,
        edges: docEdges,
      };
      store.setState(customState);
      setNodes(layoutedNodes || docNodes);
      setEdges(docEdges);

      if ((layoutedNodes || docNodes).length < 2) {
        handleFitView();
      }
    } catch (error) {
      alert("Error adding event: " + error);
    }
  };

  const handlePaneDoubleClick = async (event: React.MouseEvent) => {
    event.preventDefault();

    const targetElement = document.elementFromPoint(
      event.clientX,
      event.clientY
    );
    if (targetElement && targetElement.closest(".react-flow__node")) {
      return;
    }
    // Check if double-click is on an edge
    if (targetElement && targetElement.closest(".react-flow__edge")) {
      return;
    }

    // Cancel the delayed clearing of lastSelectedNodeRef since this is a double-click
    if (clickTimeoutRef.current) {
      clearTimeout(clickTimeoutRef.current);
      clickTimeoutRef.current = null;
    }

    // Use the ref to get the last selected node before clicks cleared it
    const currentlySelectedNode = lastSelectedNodeRef.current;
    const currentlySelectedNodeId = currentlySelectedNode?.id || null;

    takeSnapshot();

    // Pass the stored selected node as the parent
    const newNodeId = await handleAddIdea(
      "Idea...",
      "",
      event.clientX,
      event.clientY - 70,
      false,
      currentlySelectedNode
    );

    // Focus the input field of the newly created node
    if (newNodeId) {
      setTimeout(() => {
        const newNodeElement = document.querySelector(
          `[data-id="${newNodeId}"]`
        );
        const inputField = newNodeElement?.querySelector("input");
        if (inputField) {
          (inputField as HTMLInputElement).focus({ preventScroll: true });
        }
      }, 50);
    }

    // Restore the selected node after creation if one was selected
    if (currentlySelectedNode) {
      // Use setTimeout to ensure the new node is created before restoring selection
      setTimeout(() => {
        setSelectedNode(currentlySelectedNode);
        setSelectedNodeId(currentlySelectedNodeId);

        // Update the nodes array to mark the node as selected for visual styling
        // Use the store to get the current nodes state
        const currentNodes = useStore.getState().nodes;
        const updatedNodes = currentNodes.map((node) => ({
          ...node,
          selected: node.id === currentlySelectedNodeId,
        }));
        setNodes(updatedNodes);
      }, 0);
    }
  };

  const handleOneNoteData = async (template: any) => {
    if (oneNotePages) {
      try {
        const rootNode = {
          id: "root",
          type: "center",
          data: {
            label: oneNotePages[0].parentSection.displayName,
            icon: "",
            object: "",
            objectType: "",
            objectWidth: 40,
            objectHeight: 16,
            notes: "",
            complete: false,
            status: "none",
            flagged: "none",
            color: "black",
            backgroundColor: "#ffffff",
            presentationOrder: "",
            priority: "",
            links: [],
            value: "0",
            values: [],
            rollupValues: [],
            customProperties: [],
            event: {} as Event,
            address: {} as Address,
            task: {} as Task,
            ms365Document: null,
          },
          position: { x: 0, y: 0 },
          dragHandle: ".dragHandle",
          width: 40,
          height: 16,
          template: template,
        };

        // convert the onenote pages to nodes and edges
        const pages = oneNotePages.map((page) => ({
          id: page.id,
          type: "mindmap",
          data: {
            label: page.title,
            icon: "",
            object: "",
            objectType: "",
            objectWidth: 50,
            objectHeight: 18,
            notes: page.content,
            complete: false,
            status: "none",
            flagged: "none",
            color: "black",
            backgroundColor: "#ffffff",
            presentationOrder: "",
            priority: "",
            links: [],
            value: "0",
            values: [],
            rollupValues: [],
            customProperties: [],
            event: {} as Event,
            address: {} as Address,
            task: {} as Task,
            ms365Document: null,
          },
          position: { x: 0, y: 0 },
          positionAbsolute: { x: 0, y: 0 },
          width: 50,
          height: 18,
          selected: false,
          dragging: false,
          dragHandle: ".dragHandle",
          parentId: "root",
        }));

        const pageNodes = [rootNode, ...pages];

        const pageEdges = oneNotePages.map((page) => {
          return {
            id: nanoid(),
            source: "root",
            target: page.id,
            type: "center",
          };
        });

        const pageNodesWithLayout =
          (await doCircleLayout(pageNodes, pageEdges)) || [];

        const customState: FocusMapFlowState = {
          nodes: pageNodesWithLayout || [],
          edges: pageEdges,
        };

        store.setState(customState);
        setNodes(pageNodesWithLayout);
        setEdges(pageEdges);
      } catch (error) {
        showAlert("Error", "Error reading OneNote data: " + error);
      }
    } else {
      showAlert("Error", "A compatible data object was not found");
    }
  };

  const handleSustainabilityData = async (template: any) => {
    try {
      const colorCodes = [
        { id: 0, name: "Lys sand / beige", hex: "#efd3b3" },
        { id: 1, name: "Lys orange", hex: "#f3b481" },
        { id: 2, name: "Mellem orange", hex: "#ee8b4a" },
        { id: 3, name: "Mørk orange / rødlig", hex: "#e85c1f" },
        { id: 4, name: "Mørk rød / brændt sienna", hex: "#c33f27" },
      ];

      const rootNode = {
        id: "root",
        type: "center",
        data: {
          label: "Bæredygtighedshjulet",
          icon: "",
          object: "",
          objectType: "",
          objectWidth: 40,
          objectHeight: 16,
          notes: "",
          complete: false,
          flagged: "none",
          status: "none",
          color: "black",
          backgroundColor: "#ffffff",
          presentationOrder: "",
          priority: "",
          links: [],
          value: "0",
          values: [],
          rollupValues: [],
          customProperties: [],
          event: {} as Event,
          address: {} as Address,
          task: {} as Task,
          ms365Document: null,
        },
        position: { x: 0, y: 0 },
        dragHandle: ".dragHandle",
        width: 40,
        height: 16,
        template: template,
      };

      // convert the data/sustainability_wheel.json data structure to nodes and edges
      const pages = sustainabilityWheelData
        .map((parent, parentIndex) => {
          const parentNodeId = `parent-${parentIndex}`;
          const parentNode: Node = {
            id: parentNodeId,
            type: "mindmap",
            data: {
              label: parent.name,
              notes: "",
              icon: "",
              object: "",
              objectType: "",
              objectWidth: 50,
              objectHeight: 16,
              complete: false,
              status: "none",
              flagged: "none",
              color: "black",
              backgroundColor: Number(parent.step)
                ? colorCodes[parent.step - 1].hex
                : "#ffffff",
              presentationOrder: "",
              priority: "",
              links: [],
              value: "0",
              values: [],
              rollupValues: [],
              customProperties: [],
              event: {} as Event,
              address: {} as Address,
              task: {} as Task,
              ms365Document: {} as MS365Document,
            },
            position: { x: 0, y: 0 },
            dragHandle: ".dragHandle",
            width: 50,
            height: 18,
            parentId: "root",
          };

          // const childNodes = parent.descriptions.map((child, childIndex) => {
          //   const childNodeId = `child-${parentIndex}-${childIndex}`;
          //     return {
          //     id: childNodeId,
          //     type: "mindmap",
          //     data: {
          //       label: child,
          //       description: child,
          //       notes: "",
          //       complete: false,
          //       flagged: "none",
          //       color: "black",
          //       backgroundColor: childIndex <= Number(parent.step) ? colorCodes[childIndex].hex : "#ffffff",
          //       presentationOrder: "",
          //       priority: "",
          //       links: [],
          //       value: "0",
          //       values: [],
          //       rollupValues: [],
          //       customProperties: [],
          //     },
          //     position: { x: 0, y: 0 },
          //     dragHandle: ".dragHandle",
          //     width: 50,
          //     height: 18,
          //     parentNode: parentNodeId,
          //     };
          // });

          return [parentNode];
        })
        .flat();

      const pageNodes = [rootNode, ...pages];

      const pageEdges = pageNodes.map((page: Node<NodeData>) => {
        return {
          id: nanoid(),
          source: page.parentId || "root",
          target: page.id,
          type: page.parentId === "root" ? "center" : "mindmap",
        };
      });

      const pageNodesWithLayout =
        (await doCircleLayout(pageNodes, pageEdges)) || [];

      const customState: FocusMapFlowState = {
        nodes: pageNodesWithLayout || [],
        edges: pageEdges,
      };

      store.setState(customState);
      setNodes(pageNodesWithLayout);
      setEdges(pageEdges);
    } catch (error) {
      showAlert("Error", "Error reading sustainability data: " + error);
    }
  };

  const handleImport = async (template: any) => {
    let flowData;
    if (template !== null) {
      flowData = await loadTemplateData(template);
    } else {
      flowData = await importJsonFromFileWithPrompt();
    }
    if (flowData) {
      // Convert legacy "parentNode" property to "parentId" for each node
      if (flowData.nodes && Array.isArray(flowData.nodes)) {
        flowData.nodes = flowData.nodes.map((node: any) => {
          if (node.parentId !== undefined && node.parentId === undefined) {
            return {
              ...node,
              parentId: node.parentNode,
              ...(delete node.parentNode, node),
            };
          }
          return node;
        });
      }

      // Check if the root node has type "mindmap" and replace it with "center"
      const updatedNodes = flowData.nodes.map((node: Node<NodeData>) => {
        if (node.id === "root") {
          return {
            ...node,
            data: {
              ...node.data,
              // notes:
              //   node.data.notes &&
              //   (isHTML(node.data.notes)
              //     ? markdownConverter.convert(node.data.notes)
              //     : removeOptionalBrTags(node.data.notes)),
              event: node.data.event ?? {},
              address: node.data.address ?? {},
              task: node.data.task ?? {},
            },
            type: "center",
            position: { x: 0, y: 0 },
            width: 40,
            height: 18,
            dragHandle: ".dragHandle",
          };
        } else {
          return {
            ...node,
            data: {
              ...node.data,
              // notes:
              //   node.data.notes && isHTML(node.data.notes)
              //     ? markdownConverter.convert(node.data.notes)
              //     : removeOptionalBrTags(node.data.notes),
              event: node.data.event ?? {},
              address: node.data.address ?? {},
              task: node.data.task ?? {},
            },
          };
        }
        return node;
      });

      // Add missing properties to flowData if not exist
      if (!flowData.name) {
        flowData.name =
          typeof template === "string" ? template : "Imported Map";
      }
      if (typeof flowData.favourite === "undefined") {
        flowData.favourite = false;
      }
      if (!flowData.template) {
        flowData.template = "flow";
      }
      if (!flowData.theme) {
        flowData.theme = "default";
      }

      flowData.nodes = updatedNodes;

      const updatedEdges = flowData.edges.map((edge: Edge) => {
        if (edge.source === "root") {
          return { ...edge, type: "center" };
        }
        return edge;
      });

      flowData.edges = updatedEdges;

      try {
        const customState: FocusMapFlowState = {
          nodes: flowData.nodes,
          edges: flowData.edges,
        };
        store.setState(customState);
        setNodes(flowData.nodes);
        setEdges(flowData.edges);
      } catch (error) {
        showAlert("Error", "Error importing data: " + error);
      }
    } else {
      showAlert("Error", "A compatible data object was not found");
    }
  };

  const handleImportWord = async () => {
    try {
      const { document, fileName } = await importWordFromFile();
      if (document) {
        let htmlString = "";
        if (typeof document === "string") {
          htmlString = document;
        } else if (document.html) {
          htmlString = document.html;
        } else if (document.content) {
          htmlString = document.content;
        }

        // Parse the Word document structure
        const { parseWordDocument, createNodesFromDocument } = await import(
          "../Helpers/WordImport"
        );
        const parsedDoc = parseWordDocument(htmlString);
        const { nodes: importedNodes, edges: importedEdges } =
          createNodesFromDocument(parsedDoc);

        // Clear existing nodes and edges, then set the imported ones
        takeSnapshot();
        setNodes(importedNodes);
        setEdges(importedEdges);
        setIsDirty(true);

        // Fit the view to show the imported structure
        setTimeout(() => {
          handleFitView();
        }, 100);

        showAlert(
          "Success",
          `Imported "${parsedDoc.title}" with ${importedNodes.length - 1} nodes`
        );
      } else {
        showAlert("Error", "A compatible data object was not found");
      }
    } catch (error) {
      console.error("Error importing Word document:", error);
      showAlert(
        "Error",
        `Failed to import Word document: ${
          error instanceof Error ? error.message : "Unknown error"
        }`
      );
    }
  };

  const loadTemplateData = async (template: string) => {
    try {
      // First, try to load as a user template from storage
      // This handles both new format (template-xxx) and old format (UUID) user templates
      const data = await loadTemplate(
        template,
        useStore.getState().useLocalStorage
      );

      if (data) {
        return data;
      }

      // If not found in storage, try loading as system template from /templates folder
      // Only do this if the template ID doesn't look like a UUID (likely a system template name)
      const isUUID =
        /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(
          template
        );

      if (isUUID) {
        throw new Error("Template not found in storage");
      }

      // Try system template
      const templatePath = `/templates/template-${template}.json`;
      const response = await fetch(templatePath);

      if (!response.ok) {
        throw new Error(`System template '${template}' not found`);
      }

      // Check if response is JSON
      const contentType = response.headers.get("content-type");
      if (!contentType || !contentType.includes("application/json")) {
        throw new Error(
          `System template '${template}' is not a valid JSON file`
        );
      }

      const systemData = await response.json();
      return systemData;
    } catch (error) {
      console.error("Error loading template data:", error);
      if (error instanceof Error) {
        showAlert("Error", "Error loading template: " + error.message);
      } else {
        showAlert("Error", "Error loading template data");
      }
      return null;
    }
  };

  function findUndefinedFields(obj: any, path = "") {
    if (Array.isArray(obj)) {
      obj.forEach((item, index) =>
        findUndefinedFields(item, `${path}[${index}]`)
      );
    } else if (obj !== null && typeof obj === "object") {
      Object.entries(obj).forEach(([key, value]) => {
        if (value === undefined) {
          // console.warn(`Undefined field found at: ${path}.${key}`);
        } else {
          findUndefinedFields(value, `${path}.${key}`);
        }
      });
    }
  }

  const handleSave = async () => {
    setShowProgressSpinner(true);
    const user = auth.currentUser;
    const uniqueId =
      currentFlowId && currentFlowId !== "new" ? currentFlowId : uuidv4();

    // Find the root node and extract its label
    let rootNode = nodes.find((node) => node.id === "root");
    if (!rootNode) {
      rootNode = nodes.find((node) => node.type === "center");
    }
    const flowName = rootNode
      ? currentMapName.length > 0
        ? currentMapName
        : rootNode.data.label
      : "Unnamed Flow";

    logAppEvent("activity", {
      type: "event",
      flowId: uniqueId,
      name: "save_map",
    });

    const flowData = {
      id: uniqueId,
      name: flowName,
      email: user ? user.email : "anonymous",
      favourite: currentMapFavourite,
      timestamp: new Date().toISOString(),
      template: mapTemplate ? mapTemplate : "flow",
      theme: mapTheme ? mapTheme : "default",
      nodes,
      edges,
    };

    // Run check before saving
    findUndefinedFields(flowData);

    const result = await saveFlowData(
      uniqueId,
      flowData,
      useStore.getState().useLocalStorage
    );
    if (!result.success) {
      logAppEvent("activity", {
        type: "error",
        flowId: uniqueId,
        name: "save_error",
        message: "Error saving map",
      });
      showAlert(
        "Error",
        "Sadly, an error occurred saving your map.\nThe details have been logged and we will look into it.\nPlease use the Feedback button to report the issue as well, as that could help us resolve it faster."
      );
    } else {
      handleExportToPlaceholder(uniqueId);
      setCurrentFlowId(uniqueId);
      setIsDirty(false);
      //showAlert("Success", "Flow saved successfully");
      showMessage(
        "Information",
        "Data saved successfully",
        toastCenter as React.RefObject<Toast>,
        "info"
      );
    }
    setShowProgressSpinner(false);
  };

  const promptToSaveAsTemplate = () => {
    if (!currentFlowId || currentFlowId === "new") {
      showAlert(
        "Error",
        "Cannot save a new flow as a template. Please save the flow first."
      );
      return;
    }
    setShowCreateTemplate(true);
  };

  const handleSaveAsTemplate = async (name: string, description: string) => {
    setShowCreateTemplate(false);
    setShowProgressSpinner(true);
    const user = auth.currentUser;
    const uniqueId = `template-${Date.now()}-${nanoid()}`;

    // Find the root node and extract its label
    let rootNode = nodes.find((node) => node.id === "root");
    if (!rootNode) {
      rootNode = nodes.find((node) => node.type === "center");
    }
    const flowName = rootNode
      ? currentMapName.length > 0
        ? currentMapName
        : rootNode.data.label
      : "Unnamed Flow";

    logAppEvent("activity", {
      type: "event",
      mapId: uniqueId,
      name: "save_map_as_template",
    });

    const templateData = {
      id: uniqueId,
      name: name,
      email: user ? user.email : "anonymous",
      timestamp: new Date().toISOString(),
      description: description,
      author: "",
      nodes,
      edges,
    };

    // Run check before saving
    findUndefinedFields(templateData);

    const result = await saveTemplate(
      uniqueId,
      templateData,
      useStore.getState().useLocalStorage
    );
    if (!result.success) {
      logAppEvent("activity", {
        type: "error",
        flowId: uniqueId,
        name: "save_error",
        message: "Error saving template",
      });
      showAlert(
        "Error",
        "Sadly, an error occurred saving your template.\nThe details have been logged and we will look into it.\nPlease use the Feedback button to report the issue as well, as that could help us resolve it faster."
      );
    } else {
      handleExportToPlaceholder(uniqueId);
      // Don't change currentFlowId - keep working on the original map
      // The template has its own unique ID and should remain independent
      showMessage(
        "Information",
        "Template saved successfully",
        toastCenter as React.RefObject<Toast>,
        "info"
      );
    }
    setShowProgressSpinner(false);
  };

  const handleExport = async () => {
    const uniqueId = flowId && flowId !== "new" ? flowId : uuidv4();
    const user = auth.currentUser;

    // Find the root node and extract its label
    let rootNode = nodes.find((node) => node.id === "root");
    if (!rootNode) {
      rootNode = nodes.find((node) => node.type === "center");
    }
    const flowName = rootNode ? rootNode.data.label : "Unnamed Flow";

    const flowData = {
      id: uniqueId,
      name: flowName,
      email: user ? user.email : "anonymous",
      timestamp: new Date().toISOString(),
      template: mapTemplate ? mapTemplate : "flow",
      theme: mapTheme ? mapTheme : "default",
      nodes,
      edges,
    };
    await exportJsonToFileWithPrompt(flowName, flowData);
  };

  const exportToPng = async () => {
    if (flowMapWrapper.current) {
      try {
        const dataUrl = await toPng(flowMapWrapper.current, {
          skipFonts: true, // Skip font embedding to avoid CORS issues
          cacheBust: true,
          filter: (node) => {
            // Skip external images that might have CORS issues
            if (node instanceof HTMLImageElement) {
              const src = node.src;
              // Allow same-origin images and data URLs
              if (
                src.startsWith("data:") ||
                src.startsWith(window.location.origin)
              ) {
                return true;
              }
              // Skip external images (they'll show as broken/missing in screenshot)
              return false;
            }
            return true;
          },
        });
        const img = new Image();
        img.src = dataUrl;

        await new Promise((resolve, reject) => {
          img.onload = resolve;
          img.onerror = reject;
        });

        const canvas = document.createElement("canvas");
        canvas.width = img.width - 100;
        canvas.height = img.height - 100;
        const ctx = canvas.getContext("2d");
        if (ctx) {
          ctx.drawImage(
            img,
            75,
            50,
            canvas.width,
            canvas.height,
            0,
            0,
            canvas.width,
            canvas.height
          );
          return canvas.toDataURL();
        }
      } catch (error) {
        console.error("Error generating screenshot:", error);
        return null;
      }
    }
    return null;
  };

  const handleExportToPlaceholder = async (id: string) => {
    const dataUrl = await exportToPng();
    if (dataUrl) {
      const timestamp = Date.now();
      await uploadImageToStorage(dataUrl, `${id}.png`, {
        customMetadata: { lastUpdated: timestamp.toString() },
      }); // Upload with timestamp for cache busting
    }
  };

  const handleExportToPng = async () => {
    const dataUrl = await exportToPng();
    if (dataUrl) {
      const link = document.createElement("a");
      link.download = "flow-map.png";
      link.href = dataUrl;
      link.click();
    }
  };

  const captureScreenshot = async (): Promise<string | null> => {
    return await exportToPng();
  };

  const handleExportToClipboard = async () => {
    const dataUrl = await exportToPng();
    if (dataUrl) {
      const blob = await (await fetch(dataUrl)).blob();
      await navigator.clipboard.write([
        new ClipboardItem({
          "image/png": blob,
        }),
      ]);
      alert("Map copied to clipboard");
    }
  };

  const handleFitView = () => {
    if (reactFlowInstance) {
      reactFlowInstance.fitView({
        padding: 0.1, // optional padding around the edges
        includeHiddenNodes: true, // whether to include hidden nodes
      });
    }
  };

  const fitMapView = (includeHiddenNodes: boolean) => {
    if (reactFlowInstance) {
      setTimeout(() => {
        reactFlowInstance.fitView({
          padding: 0.1,
          includeHiddenNodes: includeHiddenNodes,
        });
      }, 100);
    }
  };

  const resolveOverlaps = () => {
    console.log("🔧 resolveOverlaps called with", nodes.length, "nodes");
    const currentNodes = [...nodes];
    const adjustedNodes: Node<NodeData>[] = [];
    let totalOverlapsFound = 0;

    // Check each node for overlaps
    currentNodes.forEach((node, index) => {
      let hasOverlap = false;
      let newPosition = { ...node.position };

      // Check against all other nodes
      for (let i = 0; i < currentNodes.length; i++) {
        if (i === index) continue;

        const otherNode = currentNodes[i];
        const nodeWidth = 150; // approximate node width
        const nodeHeight = 50; // approximate node height

        // Check if nodes overlap
        const overlapX =
          Math.abs(node.position.x - otherNode.position.x) < nodeWidth;
        const overlapY =
          Math.abs(node.position.y - otherNode.position.y) < nodeHeight;

        if (overlapX && overlapY) {
          hasOverlap = true;
          totalOverlapsFound++;
          console.log(
            `  Overlap found between node ${node.id} and ${otherNode.id}`
          );

          // Calculate direction to move away from overlap
          const dx = node.position.x - otherNode.position.x;
          const dy = node.position.y - otherNode.position.y;
          const distance = Math.sqrt(dx * dx + dy * dy);

          if (distance < 10) {
            // Too close, move in random direction
            const angle = Math.random() * Math.PI * 2;
            newPosition.x += Math.cos(angle) * nodeWidth;
            newPosition.y += Math.sin(angle) * nodeHeight;
          } else {
            // Move away from overlap
            const moveDistance = nodeWidth - Math.abs(dx);
            newPosition.x += (dx / distance) * moveDistance;
            newPosition.y += (dy / distance) * (nodeHeight - Math.abs(dy));
          }
        }
      }

      adjustedNodes.push({
        ...node,
        position: hasOverlap ? newPosition : node.position,
      });
    });

    console.log(`✅ Total overlaps found and resolved: ${totalOverlapsFound}`);
    setNodes(adjustedNodes);
  };

  const handleFocus = (value: string) => {
    setFocusValue(value);
  };

  const handleUndo = () => {
    undo();
  };

  const handleRedo = () => {
    redo();
  };

  const onLayout = useCallback(
    (direction: string) => {
      // console.log(nodes);
      takeSnapshot();
      const layouted = getLayoutedElements(nodes, edges, { direction });

      setNodes([...layouted.nodes]);
      setEdges([...layouted.edges]);

      window.requestAnimationFrame(() => {
        fitView();
      });
    },
    [nodes, edges]
  );

  const g = tree();
  const getLayoutedElements = (
    nodes: Node<NodeData>[],
    edges: Edge[],
    options: { direction?: string }
  ): { nodes: Node<NodeData>[]; edges: Edge[] } => {
    try {
      if (nodes.length === 0) return { nodes, edges };

      let width = 0;
      let height = 0;

      if (nodes.length > 0) {
        const nodeElement = document.querySelector(
          `[data-id="${nodes[0].id}"]`
        );
        if (nodeElement) {
          const rect = nodeElement.getBoundingClientRect();
          width = rect.width;
          height = rect.height;
        }
      }
      const hierarchy = stratify()
        .id((d) => (d as { id: string }).id)
        .parentId(
          (d) =>
            edges.find((edge) => edge.target === (d as { id: string }).id)
              ?.source
        );
      const root = hierarchy(nodes);
      const layout = g.nodeSize([width * 2, height * 2])(root);

      const updatedNodes = nodes.map((node) => {
        const layoutNode = layout.descendants().find((n) => n.id === node.id);
        if (layoutNode) {
          return {
            ...node,
            position: { x: (layoutNode as any).x, y: (layoutNode as any).y },
          };
        }
        return node;
      });

      return {
        nodes: updatedNodes,
        edges,
      };
    } catch (error) {
      showAlert("Error", "Error reading nodes: " + error);
      console.error("Error reading nodes:", error);
      return { nodes, edges };
    }
  };

  const doCircleLayout = async (
    nodesInput: Node<NodeData>[] | null,
    edgesInput: Edge[] | null
  ) => {
    try {
      takeSnapshot();

      fitMapView(false);

      const nodeSet = nodesInput && nodesInput.length > 0 ? nodesInput : nodes;
      const edgeSet = edgesInput && edgesInput.length > 0 ? edgesInput : edges;

      // Find the center node
      let centerNode = nodeSet.find((node) => node.type === "center");
      const selectedNode = nodeSet.find((node) => node.id === selectedNodeId);

      const centerNodes = nodeSet.filter((node) => node.type === "center");
      if (centerNodes.length > 1) {
        if (selectedNode?.type !== "center") {
          showAlert(
            "Attention",
            "Multiple focus maps found. Click on the focus map to layout."
          );
          return;
        } else {
          centerNode = selectedNode;
        }
      } else {
        centerNode = centerNodes[0];
      }

      const centerNodeId = centerNode ? centerNode.id : "root";

      // Create adjacency list based on edges
      const adjacencyList: Record<string, string[]> = edgeSet.reduce(
        (acc, edge) => {
          if (!acc[edge.source]) acc[edge.source] = [];
          acc[edge.source].push(edge.target);
          return acc;
        },
        {} as Record<string, string[]>
      );

      // Step 1: Assign levels to each node based on distance from the center node
      const levels: Record<string, number> = { [centerNodeId]: 0 }; // Root node starts at level 0
      const levelNodes: Record<number, string[]> = { 0: [centerNodeId] };

      const assignLevels = (nodeId: string, level: number) => {
        if (!adjacencyList[nodeId]) return;

        adjacencyList[nodeId].forEach((childId) => {
          if (levels[childId] === undefined) {
            levels[childId] = level + 1;
            if (!levelNodes[level + 1]) levelNodes[level + 1] = [];
            levelNodes[level + 1].push(childId);
            assignLevels(childId, level + 1);
          }
        });
      };
      assignLevels(centerNodeId, 0);

      // Step 2: Arrange nodes in a circular layout
      const baseRadiusStep = 200; // Base distance between levels
      const scalingFactor = 0.8; // Controls how much the radius grows for each level
      const centerX = centerNode.width * 0.5; // 25;
      const centerY = 9;

      const newNodes: Node<NodeData>[] = nodeSet.map((node) => {
        const level = levels[node.id];
        const nodesOnLevel = levelNodes[level] ? levelNodes[level].length : 0;

        if (level === 0) {
          // Center node stays at the center
          return {
            ...node,
            position: { x: centerX, y: centerY },
          };
        }

        try {
          const angleStep = (2 * Math.PI) / nodesOnLevel; // Divide the circle evenly
          const indexOnLevel = levelNodes[level].indexOf(node.id);
          const angle = indexOnLevel * angleStep; // Calculate the angle for this node
          const radius = baseRadiusStep * level * scalingFactor; // Apply scaling factor to radius

          // Calculate position based on the angle and radius
          const x = centerX + radius * Math.cos(angle);
          const y = centerY + radius * Math.sin(angle);

          return {
            ...node,
            position: {
              x: Math.round(x),
              y: Math.round(y),
            },
          };
        } catch (error) {
          return {
            ...node,
            position: {
              x: node.position.x,
              y: node.position.y,
            },
          };
        }
      });

      if (nodesInput && nodesInput.length > 0) {
        return newNodes;
      } else {
        setNodes(newNodes);
        setIsDirty(true);
      }
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : "Unknown error";
      showAlert("Error", "Error in Circle Layout: " + errorMessage);
    }
  };

  const doTreeLeftLayout = () => {
    try {
      takeSnapshot();
      fitMapView(false);

      // Map nodes by ID for quick lookup
      const nodesById: Record<string, Node> = Object.fromEntries(
        nodes.map((node) => [node.id, node])
      );

      // Create adjacency list based on edges
      const adjacencyList: Record<string, string[]> = edges.reduce(
        (acc, edge) => {
          if (!acc[edge.source]) acc[edge.source] = [];
          acc[edge.source].push(edge.target);
          return acc;
        },
        {} as Record<string, string[]>
      );

      // Step 1: Assign levels to each node based on distance from root
      let centerNode = nodes.find((node) => node.id === "root");
      let centerNodeId = "root";
      if (!centerNode) {
        centerNode = nodes.find((node) => node.type === "center");
      }
      if (centerNode !== undefined && centerNode !== null) {
        centerNodeId = centerNode.id;
      } else {
        centerNodeId = "root";
      }

      const levels: Record<string, number> = { [centerNodeId]: 0 }; // Root node starts at level 0
      const levelNodes: Record<number, string[]> = { 0: [centerNodeId] };

      const assignLevels = (nodeId: string, level: number) => {
        if (!adjacencyList[nodeId]) return;

        adjacencyList[nodeId].forEach((childId) => {
          levels[childId] = level + 1;
          if (!levelNodes[level + 1]) levelNodes[level + 1] = [];
          levelNodes[level + 1].push(childId);
          assignLevels(childId, level + 1);
        });
      };
      assignLevels(centerNodeId, 0);

      // Step 2: Arrange nodes in a tree layout (left-to-right)
      const horizontalSpacing = 150; // Space between levels (left to right)
      const verticalSpacing = 50; // Space between nodes in the same level (top to bottom)

      const newNodes: Node<NodeData>[] = nodes.map((node) => {
        try {
          const level = levels[node.id];
          const indexInLevel = levelNodes[level].indexOf(node.id);

          // Calculate position based on tree layout
          const yAdjust = 9;

          let x = horizontalSpacing;
          let y =
            indexInLevel * verticalSpacing -
            (levelNodes[level].length * verticalSpacing) / 2;
          y = y + level * yAdjust;

          return {
            ...node,
            position: { x: Math.round(x), y: Math.round(y) },
          };
        } catch (error) {
          return {
            ...node,
            position: { x: node.position.x, y: node.position.y },
          };
        }
      });

      setNodes(newNodes);
      setIsDirty(true);
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : "Unknown error";
      showAlert("Error", "Error in Tree Left Layout: " + errorMessage);
    }
  };

  const doTreeTopBottomLayout = () => {
    try {
      takeSnapshot();
      fitMapView(false);

      // Map nodes by ID for quick lookup
      const nodesById: Record<string, Node> = Object.fromEntries(
        nodes.map((node) => [node.id, node])
      );

      // Create adjacency list based on edges
      const adjacencyList: Record<string, string[]> = edges.reduce(
        (acc, edge) => {
          if (!acc[edge.source]) acc[edge.source] = [];
          acc[edge.source].push(edge.target);
          return acc;
        },
        {} as Record<string, string[]>
      );

      // Step 1: Assign levels to each node based on distance from root
      let centerNode = nodes.find((node) => node.id === "root");
      let centerNodeId = "root";
      if (!centerNode) {
        centerNode = nodes.find((node) => node.type === "center");
      }
      if (centerNode !== undefined && centerNode !== null) {
        centerNodeId = centerNode.id;
      } else {
        centerNodeId = "root";
      }
      const levels: Record<string, number> = { [centerNodeId]: 0 }; // Root node starts at level 0
      const levelNodes: Record<number, string[]> = { 0: [centerNodeId] };

      let maxX = 75;
      nodes.map((node) => {
        if (node.position.x > maxX) {
          maxX = node.position.x;
        }
      });

      const assignLevels = (nodeId: string, level: number) => {
        if (!adjacencyList[nodeId]) return;

        adjacencyList[nodeId].forEach((childId) => {
          levels[childId] = level + 1;
          if (!levelNodes[level + 1]) levelNodes[level + 1] = [];
          levelNodes[level + 1].push(childId);
          assignLevels(childId, level + 1);
        });
      };
      assignLevels(centerNodeId, 0);

      // Step 2: Arrange nodes in a tree layout (top-to-bottom)
      const verticalSpacing = 100; // Space between levels (top to bottom)
      const horizontalSpacing = 75; // Space between nodes in the same level (left to right)
      const xAdjust = 37;

      const newNodes: Node<NodeData>[] = nodes.map((node) => {
        try {
          const level = levels[node.id];
          const indexInLevel = levelNodes[level].indexOf(node.id);

          // Calculate position based on tree layout
          let x =
            indexInLevel * horizontalSpacing -
            (levelNodes[level].length * horizontalSpacing) / 2;
          let y = verticalSpacing;
          x = x + level * (maxX / 2); //xAdjust;

          return {
            ...node,
            position: { x: Math.round(x), y: Math.round(y) },
          };
        } catch (error) {
          return {
            ...node,
            position: { x: node.position.x, y: node.position.y },
          };
        }
      });

      setNodes(newNodes);
      setIsDirty(true);
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : "Unknown error";
      showAlert("Error", "Error in Tree Down Layout: " + errorMessage);
    }
  };

  const doTreeLayout = (direction: string) => {
    switch (direction) {
      case "left":
        doTreeLeftLayout();
        //onLayout("LR");
        break;
      case "down":
        doTreeTopBottomLayout();
        //onLayout("TB");
        break;
      default:
        return;
    }
  };

  const doTimelineEventFiltering = async (
    timelineEventFiltering: MS365DocumentFilter
  ) => {
    try {
      setShowProgressSpinner(true);
      const startDate = timelineEventFiltering.dateRange.start
        ? new Date(timelineEventFiltering.dateRange.start)
        : undefined;
      const endDate = timelineEventFiltering.dateRange.end
        ? new Date(timelineEventFiltering.dateRange.end)
        : undefined;

      let data = [];
      if (timelineEventFiltering.useCopilot) {
        data = await fetchCopilotData(
          timelineEventFiltering.searchText,
          timelineEventFiltering.maxResults
        );
      } else {
        data = await fetchTimelineData(
          timelineEventFiltering.searchText,
          timelineEventFiltering.maxResults,
          startDate,
          endDate,
          timelineEventFiltering.types
        );
      }

      if (data) {
        // If output mode is picklist, emit event with data instead of adding to canvas
        if (timelineEventFiltering.outputMode === "picklist") {
          const event = new CustomEvent("ms365DataReady", {
            detail: data,
          });
          window.dispatchEvent(event);
          setShowProgressSpinner(false);
          return;
        }
        let idIfUnknown: number = 0;
        const newNodes: Node<NodeData>[] = data.map((item: MS365Document) => ({
          id: item.id ? item.id : `ms365-${idIfUnknown++}`,
          data: {
            label: item.title || "Event",
            icon: `https://static2.sharepointonline.com/files/fabric/assets/item-types/96/${getExtensionFromString(
              item
            )}.png`,
            object: "",
            objectType: "",
            objectWidth: undefined,
            objectHeight: undefined,
            notes: item.body?.content || item.summary || "",
            complete: false,
            status: "none",
            flagged: "none",
            color: "#333333",
            backgroundColor: "#ffffff",
            presentationOrder: "",
            priority: "",
            links: Array.isArray(item.attachments)
              ? item.attachments.map((att: any) => {
                  if (att.url || att.webUrl) {
                    return {
                      title: att.title || att.name || "",
                      url: att.url || att.webUrl,
                    };
                  }
                  if (typeof att === "string" && att.length > 100) {
                    return {
                      title: "Inline Attachment",
                      url: `data:image/jpeg;base64,${att}`,
                    };
                  }
                  if (att.contentBytes) {
                    const mime = att.contentType || "image/jpeg";
                    return {
                      title: att.title || att.name || "Inline Attachment",
                      url: `data:${mime};base64,${att.contentBytes}`,
                    };
                  }
                  return {
                    title: att.title || att.name || "Attachment",
                    url: "",
                  };
                })
              : [],
            value: "0",
            values: [],
            rollupValues: [],
            customProperties: [],
            event: {} as Event,
            address: {} as Address,
            task: {} as Task,
            ms365Document: item,
            conversationId: item.conversationId,
          },
          position: {
            x: Math.random() * 800,
            y: Math.random() * 600,
          },
          type: "nodeItem",
          dragHandle: ".dragHandle",
          parentId: "",
          selected: false,
          dragging: false,
        }));

        const crosslineEdges = [];
        const conversationIdMap: Record<string, string[]> = {};
        data.forEach((item: MS365Document) => {
          if (item.conversationId) {
            if (!conversationIdMap[item.conversationId]) {
              conversationIdMap[item.conversationId] = [];
            }
            conversationIdMap[item.conversationId].push(item.id);
          }
        });
        Object.entries(conversationIdMap).forEach(([conversationId, ids]) => {
          if (ids.length > 1) {
            for (let i = 0; i < ids.length; i++) {
              for (let j = i + 1; j < ids.length; j++) {
                crosslineEdges.push({
                  id: `crossline-${ids[i]}-${ids[j]}`,
                  source: ids[i],
                  target: ids[j],
                  type: "crossline",
                });
              }
            }
          }
        });

        setNodes(newNodes);
        setEdges(crosslineEdges);

        setIdeationMode(true);

        setShowProgressSpinner(false);
      } else {
        setShowProgressSpinner(false);
        showAlert("Error", "No data found for the given search term.");
      }
    } catch (error) {
      setShowProgressSpinner(false);
      showAlert(
        "Error",
        "Error fetching timeline data: " +
          (error instanceof Error ? error.message : "Unknown error")
      );
    }
    // setShowProgressSpinner(true);
    // const startDate = timelineEventFiltering.dateRange.start
    //   ? new Date(timelineEventFiltering.dateRange.start)
    //   : undefined;
    // const endDate = timelineEventFiltering.dateRange.end
    //   ? new Date(timelineEventFiltering.dateRange.end)
    //   : undefined;

    // let data = [];
    // if (timelineEventFiltering.useCopilot) {
    //   data = await fetchCopilotData(
    //     timelineEventFiltering.searchText,
    //     timelineEventFiltering.maxResults
    //   );
    // } else {
    //   data = await fetchTimelineData(
    //     timelineEventFiltering.searchText,
    //     timelineEventFiltering.maxResults,
    //     startDate,
    //     endDate,
    //     timelineEventFiltering.types
    //   );
    // }

    // if (data) {
    //   // create nodes and edges based on the data
    //   // If the attachment is an inline base64 string (like images), you can create a data URL to open it.
    //   // If it's a file with a URL (webUrl or url), you can open that directly.
    //   let idIfUnknown: number = 0;
    //   const newNodes: Node<NodeData>[] = data.map((item: MS365Document) => ({
    //     id: item.id ? item.id : `ms365-${idIfUnknown++}`,
    //     data: {
    //       label: item.title || "Event",
    //       icon: `https://static2.sharepointonline.com/files/fabric/assets/item-types/96/${getExtensionFromString(
    //         item
    //       )}.png`,
    //       object: "",
    //       objectType: "",
    //       objectWidth: 50,
    //       objectHeight: 18,
    //       notes: item.body?.content || item.summary || "",
    //       complete: false,
    //       status: "none",
    //       flagged: "none",
    //       color: "black",
    //       backgroundColor: "#ffffff",
    //       presentationOrder: "",
    //       priority: "",
    //       links: Array.isArray(item.attachments)
    //         ? item.attachments.map((att: any) => {
    //             // If att.url or att.webUrl exists, use that as the link
    //             if (att.url || att.webUrl) {
    //               return {
    //                 title: att.title || att.name || "",
    //                 url: att.url || att.webUrl,
    //               };
    //             }
    //             // If att is a base64 string (inline), create a data URL (assume image/jpeg for demo)
    //             if (typeof att === "string" && att.length > 100) {
    //               return {
    //                 title: "Inline Attachment",
    //                 url: `data:image/jpeg;base64,${att}`,
    //               };
    //             }
    //             // If att.contentBytes exists (base64), create a data URL
    //             if (att.contentBytes) {
    //               // Try to detect mime type, fallback to image/jpeg
    //               const mime = att.contentType || "image/jpeg";
    //               return {
    //                 title: att.title || att.name || "Inline Attachment",
    //                 url: `data:${mime};base64,${att.contentBytes}`,
    //               };
    //             }
    //             return {
    //               title: att.title || att.name || "Attachment",
    //               url: "",
    //             };
    //           })
    //         : [],
    //       value: "0",
    //       values: [],
    //       rollupValues: [],
    //       customProperties: [],
    //       event: {} as Event,
    //       address: {} as Address,
    //       task: {} as Task,
    //       ms365Document: item,
    //       conversationId: item.conversationId,
    //     },
    //     position: {
    //       x: 0,
    //       y: 0,
    //     },
    //     type: "ms365",
    //     width: 50,
    //     height: 18,
    //     dragHandle: ".dragHandle",
    //     parentId: "",
    //     selected: false,
    //     dragging: false,
    //   }));

    //   // Example: Add crossline edges for related items
    //   const crosslineEdges = [];
    //   const conversationIdMap: Record<string, string[]> = {};
    //   data.forEach((item: MS365Document) => {
    //     if (item.conversationId) {
    //       if (!conversationIdMap[item.conversationId]) {
    //         conversationIdMap[item.conversationId] = [];
    //       }
    //       conversationIdMap[item.conversationId].push(item.id);
    //     }
    //   });
    //   Object.entries(conversationIdMap).forEach(([conversationId, ids]) => {
    //     if (ids.length > 1) {
    //       for (let i = 0; i < ids.length; i++) {
    //         for (let j = i + 1; j < ids.length; j++) {
    //           crosslineEdges.push({
    //             id: `crossline-${ids[i]}-${ids[j]}`,
    //             source: ids[i],
    //             target: ids[j],
    //             type: "ms365",
    //           });
    //         }
    //       }
    //     }
    //   });

    //   setNodes(newNodes);
    //   setEdges(crosslineEdges);

    //   setIdeationMode(true);

    //   setShowProgressSpinner(false);
    // } else {
    //   setShowProgressSpinner(false);
    //   showAlert("Error", "No data found for the given search term.");
    // }
  };

  const doFeatures = () => {
    alert("This feature is in progress and will be available soon");
  };

  const doShare = () => {
    alert("Work in Progress...");
  };

  const doAutoLayout = async (type: string) => {
    switch (type) {
      case "circle":
        const updatedNodes = updateNodePositions(nodes, edges);
        setNodes(updatedNodes);
        setIsDirty(true);
        break;
      case "tree":
        const updatedTreeNodes = await treeLayout(nodes, edges, {
          direction: "TD",
        });
        setNodes(updatedTreeNodes.nodes);
        setEdges(updatedTreeNodes.edges);
        setIsDirty(true);
        break;
      default:
        break;
    }
  };

  const handleNodeClickText = (node: Node) => {
    if (node.id === "root" || node.type === "center") {
      const centerTextField = document.getElementById("center-text-field");
      centerTextField?.focus();
    } else {
      const nodeInputField = document.querySelector(
        `[data-id="${node.id}"] input`
      );
      (nodeInputField as HTMLInputElement)?.focus();
    }
  };

  const handleNodeDoubleClick = (event: React.MouseEvent, node: Node) => {
    setSelectedNodeId(node.id);
    setSelectedNode(node);
    setCurrentNodeLabel(node.data.label);
    setCurrentLinks(node.data.links);
    setCurrentNotes(node.data.notes);
    setShowNotesModal(true);
    simulation?.stop();
  };

  const handleMapData = async (data: any) => {
    setShowProgressSpinner(true);
    try {
      if (!data) {
        data = nodes
          .filter((node) => node.data.notes)
          .map((node) => node.data.notes)
          .join("\n\n");
      }
      console.log("Data to be sent to CVR:", data);
      const enrichedData = await getEnrichedCVRdata(data);
      console.log("Enriched Data", enrichedData);
      const { choices } = enrichedData;
      const { message } = choices[0];
      const { content } = message;
      let parsedContent: any;
      try {
        const sanitizedContent = content.replace(/```json|```/g, "").trim();
        parsedContent = JSON.parse(sanitizedContent);
      } catch (error) {
        console.error("Error parsing JSON content:", error);
        showAlert("Error", "Invalid JSON format. Please check the content.");
        return;
      }
      const result = parsedContent;
      // Extract detected addresses and events and update state
      // if (result.addresses) {
      //   setDetectedAddresses(result.addresses);
      // }
      // if (result.events) {
      //   setDetectedEvents(result.events);
      // }
      showAlert("Success", "Relevant data extracted successfully");
    } catch (error) {
      console.error("Error handling map data:", error);
      showAlert(
        "Error",
        "Error handling map data: " +
          (error instanceof Error ? error.message : "Unknown error")
      );
    } finally {
      setShowProgressSpinner(false);
    }
  };

  // const handleMapData = async (data: any) => {
  //   setShowProgressSpinner(true);
  //   try {
  //     const enrichedData = await getEnrichedCVRdata(data);
  //     console.log("Enriched Data", enrichedData);
  //     const { choices } = enrichedData;
  //     const { message } = choices[0];
  //     const { content } = message;
  //     let parsedContent;
  //     try {
  //       const sanitizedContent = content.replace(/```json|```/g, "").trim();
  //       parsedContent = JSON.parse(sanitizedContent);
  //     } catch (error) {
  //       console.error("Error parsing JSON content:", error);
  //       showAlert("Error", "Invalid JSON format. Please check the content.");
  //       return;
  //     }
  //     const result = parsedContent;
  //     // Extract detected addresses and events and update state
  //     if (result.addresses) {
  //       setDetectedAddresses(result.addresses);
  //     }
  //     if (result.events) {
  //       setDetectedEvents(result.events);
  //     }
  //     showAlert("Success", JSON.stringify(result));
  //   } catch (error) {
  //     console.error("Error handling map data:", error);
  //     showAlert(
  //       "Error",
  //       "Error handling map data: " +
  //         (error instanceof Error ? error.message : "Unknown error")
  //     );
  //   } finally {
  //     setShowProgressSpinner(false);
  //   }
  // };

  const playGame = async (
    players: string,
    categories: string,
    questions: string
  ) => {
    setUserSettingsVisible(false);

    setShowProgressSpinner(true);
    try {
      await startGaming(
        players,
        categories,
        questions,
        nodes,
        edges,
        setNodes,
        setEdges,
        showAlert,
        newFlowPosition
      );
      if (edges.length > 0) {
        setTimeout(() => {
          doCircleLayout(nodes, edges);
        }, 1000);
      }
    } catch (error) {
      console.error("Error handling game data:", error);
      showAlert(
        "Error",
        "Error handling game data: " +
          (error instanceof Error ? error.message : "Unknown error")
      );
    } finally {
      setShowProgressSpinner(false);
    }
  };

  const handleSaveNotes = (
    notes: string,
    links: { title: string; url: string }[]
  ) => {
    if (selectedNodeId) {
      updateNodeNotes(selectedNodeId, notes, links);
    }
    setShowNotesModal(false);
    //exportToPng();
  };

  const handleCancelEditNotes = () => {
    setShowNotesModal(false);
  };

  const handleNodeClick = (event: React.MouseEvent, node: Node) => {
    // console.log("Node clicked", node);
    setSelectedNode(node);
    setSelectedNodeId(node.id);
    lastSelectedNodeRef.current = node as Node<NodeData>;
    setCurrentNodeColor(node.data.backgroundColor);
    // handleNodeClickText(node);
    simulation?.stop();
  };

  const handleCanvasClick = () => {
    // console.log("Canvas Click");

    // Don't clear selection if we just created a node via drag/connect
    if (justCreatedNodeViaConnect.current) {
      justCreatedNodeViaConnect.current = false;
      return;
    }

    // Stop Tab mode when clicking on canvas
    if (tabModeActive) {
      setTabModeActive(false);
      setTabModeParentId(null);
    }

    setSelectedNode(null);
    setSelectedNodeId(null);

    // Delay clearing the ref to allow double-click to capture it first
    if (clickTimeoutRef.current) {
      clearTimeout(clickTimeoutRef.current);
    }
    clickTimeoutRef.current = setTimeout(() => {
      lastSelectedNodeRef.current = null;
    }, 300); // 300ms is typical double-click threshold
  };

  const handlePaneMoveStart = () => {
    // Deselect nodes when user starts dragging the pane
    setSelectedNode(null);
    setSelectedNodeId(null);
    // Also clear ReactFlow's internal selection state
    reactFlowInstance.setNodes((nodes) =>
      nodes.map((node) => ({ ...node, selected: false }))
    );
  };

  // Global mousedown handler to stop Tab mode on any click
  React.useEffect(() => {
    const handleMouseDown = (event: MouseEvent) => {
      // Check if tab mode is active
      const currentTabMode = useStore.getState().tabModeActive;
      if (currentTabMode) {
        // Check if click is on an input field (to allow typing)
        const target = event.target as HTMLElement;
        if (target.tagName === "INPUT" || target.tagName === "TEXTAREA") {
          return;
        }
        // Stop Tab mode on any other click
        useStore.getState().setTabModeActive(false);
        useStore.getState().setTabModeParentId(null);
      }
    };

    document.addEventListener("mousedown", handleMouseDown);
    return () => {
      document.removeEventListener("mousedown", handleMouseDown);
    };
  }, []); // Empty dependency array - handler reads from store directly

  const handleNodeDragStart = (event: React.MouseEvent, node: Node) => {
    // console.log("Node drag started", node);
    takeSnapshot();
    setSelectedNode(node);
    setSelectedNodeId(node.id);
    lastSelectedNodeRef.current = node as Node<NodeData>;
    setCurrentNodeColor(node.data.backgroundColor);
    simulation?.stop();
  };

  const onNodeDragStart: NodeDragHandler = useCallback(() => {
    // 👇 make dragging a node undoable
    takeSnapshot();
    // 👉 you can place your event handlers here
  }, [takeSnapshot]);

  const onSelectionDragStart: SelectionDragHandler = useCallback(() => {
    // 👇 make dragging a selection undoable
    takeSnapshot();
  }, [takeSnapshot]);

  const onNodesDelete: OnNodesDelete = useCallback(() => {
    // 👇 make deleting nodes undoable
    takeSnapshot();
  }, [takeSnapshot]);

  const onEdgesDelete: OnEdgesDelete = useCallback(() => {
    // 👇 make deleting edges undoable
    takeSnapshot();
  }, [takeSnapshot]);

  const handleDrop = async (event: React.DragEvent) => {
    event.preventDefault();

    const file = event.dataTransfer.files[0];
    if (file && file.type === "application/json") {
      const reader = new FileReader();
      reader.onload = async (e) => {
        try {
          const json = JSON.parse(e.target?.result as string);
          // Validate the JSON structure
          if (json.nodes && json.edges) {
            const customState: FocusMapFlowState = {
              nodes: json.nodes,
              edges: json.edges,
            };
            store.setState(customState);
            setNodes(json.nodes);
            setEdges(json.edges);
            setIsDirty(true);
          } else {
            alert("Invalid JSON structure");
          }
        } catch (error) {
          alert("Error parsing JSON file: " + error);
        }
      };
      reader.readAsText(file);
    } else if (file && file.type === "application/pdf") {
      processPDF(file);
    } else if (file && file.type === "message/rfc822") {
      processEML(file);
    } else if (!file) {
      const textData = event.dataTransfer.getData("text/plain");
      if (textData) {
        console.log(
          "Data Read - Dropped data not yet supported for further processing. Here's what we got:",
          textData
        );
      } else {
        alert("No valid data found in the drag-and-drop operation");
      }
    } else {
      showAlert("Alert", "Could not read any content from the file.");
    }
  };

  const extractPDFContent = async (pdfUrl: string): Promise<any[]> => {
    const pdf = await getDocument(pdfUrl).promise;
    const content: any[] = [];

    for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
      const page = await pdf.getPage(pageNum);
      const textContent = await page.getTextContent();
      const pageText = textContent.items.map((item: any) => item.str);
      content.push(...pageText);
    }

    return content;
  };

  const parseContentToNodesAndEdges = (
    content: string[]
  ): { mNodes: Node<NodeData>[]; mEdges: Edge[] } => {
    const mNodes: Node<NodeData>[] = [];
    const mEdges: Edge[] = [];

    let nodeId = 1;

    const createNode = (
      id: string,
      text: string,
      parentId?: string
    ): Node<NodeData> => {
      const label = text.length > 20 ? text.slice(0, 17) + "..." : text;
      return {
        id,
        data: {
          label,
          notes: text,
          icon: "",
          object: "",
          objectType: "",
          objectWidth: 0,
          objectHeight: 0,
          complete: false,
          status: "none",
          flagged: "none",
          color: "black",
          backgroundColor: "#ffffff",
          presentationOrder: "",
          priority: "",
          links: [],
          value: "0",
          values: [],
          rollupValues: [],
          customProperties: [],
          event: {} as Event,
          address: {} as Address,
          task: {} as Task,
          ms365Document: {} as MS365Document,
        },
        position: { x: 0, y: 0 },
        width: 40,
        height: 18,
        type: parentId ? "mindmap" : "center",
        dragHandle: parentId ? ".dragHandle" : ".dragHandle",
        parentId,
      };
    };

    const createEdge = (
      source: string,
      target: string,
      type?: string
    ): Edge => ({
      id: `${source}-${target}`,
      source,
      target,
      type,
    });

    let currentParentId = "root";
    mNodes.push(createNode(currentParentId, "Root Node"));

    content.forEach((text, index) => {
      if (text.trim() === "") return;

      if (isTitle(text)) {
        const newNodeId = `node-${nodeId++}`;
        mNodes.push(createNode(newNodeId, text, "root"));
        mEdges.push(createEdge("root", newNodeId, "center"));
        currentParentId = newNodeId;
      } else if (isSubTitle(text)) {
        const newNodeId = `node-${nodeId++}`;
        mNodes.push(createNode(newNodeId, text, currentParentId));
        mEdges.push(createEdge(currentParentId, newNodeId, "mindmap"));
        currentParentId = newNodeId;
      } else if (isChapter(text)) {
        const newNodeId = `node-${nodeId++}`;
        mNodes.push(createNode(newNodeId, text, currentParentId));
        mEdges.push(createEdge(currentParentId, newNodeId, "mindmap"));
        currentParentId = newNodeId;
      } else if (isBulletPoint(text)) {
        const newNodeId = `node-${nodeId++}`;
        mNodes.push(createNode(newNodeId, text, currentParentId));
        mEdges.push(createEdge(currentParentId, newNodeId, "mindmap"));
      }
    });

    return { mNodes, mEdges };
  };

  const isTitle = (text: string): boolean => {
    // Implement logic to identify titles
    return text.match(/^[A-Z\s]+$/) !== null;
  };

  const isSubTitle = (text: string): boolean => {
    // Implement logic to identify subtitles
    return text.match(/^[A-Z][a-z\s]+$/) !== null;
  };

  const isChapter = (text: string): boolean => {
    // Implement logic to identify chapters
    return text.match(/^\d+\.\d+/) !== null;
  };

  const isBulletPoint = (text: string): boolean => {
    // Implement logic to identify bullet points
    return text.match(/^\•/) !== null;
  };

  const saveImages = (images: any[], nodes: Node<NodeData>[]): void => {
    images.forEach((image, index) => {
      const nodeId = nodes[index]?.id || `image-${index}`;
      const fileName = `${nodeId}.png`;
      const blob = new Blob([image], { type: "image/png" });
      saveAs(blob, fileName);
    });
  };

  const processPDF = async (file: File) => {
    try {
      const pdfUrl = URL.createObjectURL(file);
      const content = await extractPDFContent(pdfUrl);

      const { mNodes: parsedNodes, mEdges: parsedEdges } =
        parseContentToNodesAndEdges(content);
      const customState: FocusMapFlowState = {
        nodes: parsedNodes,
        edges: parsedEdges,
      };
      store.setState(customState);
      setNodes(parsedNodes);
      setEdges(parsedEdges);
      setIsDirty(true);
    } catch (error) {
      alert("Error processing PDF file: " + error);
    }
  };

  const truncateText = (
    text: string,
    maxLength: number
  ): { label: string; notes: string } => {
    if (text.length <= maxLength) {
      return { label: text, notes: text };
    }
    return {
      label: text.slice(0, maxLength - 3) + "...",
      notes: text,
    };
  };

  const askOllama = async (text: string): Promise<string> => {
    const res = await fetch("http://localhost:11434/api/generate", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        model: "llama3",
        prompt: text,
        stream: false,
      }),
    });
    const data = await res.json();
    return data.output;
  };

  // app.post("/api/generate", async (req, res) => {
  //   const prompt = req.body.prompt;

  //   try {
  //     const response = await axios.post("http://localhost:11434/api/generate", {
  //       model: "llama3",
  //       prompt,
  //       stream: false,
  //     });

  //     res.json({ output: response.data.response.trim() });
  //   } catch (error) {
  //     console.error(error);
  //     res.status(500).send("Failed to communicate with Ollama: " + error.message);
  //   }
  // });

  const getEmailSummary = async (emailText: string) => {
    //showAlert("emails", emailText);
    const prompt = `Extract a table with subject, date and body per line from each email in this list:\n${emailText}`;
    const summary = await askOllama(prompt);
    return summary;
  };

  const [emailContent, setEmailContent] = useState<any>(null);
  const processEML = async (file: File) => {
    setShowProgressSpinner(true);
    const startTime = performance.now();
    try {
      const emlContent = await file.text();
      let parsedResult: string = "";
      let summaryResult = "";
      readEml(emlContent, (err, parsed) => {
        if (!err) {
          console.log(parsed?.text);
          parsedResult = parsed?.text || ""; //JSON.stringify(parsed); //`${parsed?.date}: ${parsed?.subject}, ${parsed?.text}`;
        } else {
          showAlert("Error ", "Error parsing EML file: " + err);
        }
      });
      if (parsedResult) {
        summaryResult = await getEmailSummary(parsedResult);
        const endTime = performance.now();
        const elapsedTime = ((endTime - startTime) / 1000).toFixed(2);
        showAlert(
          `Success - Time Elapsed: ${elapsedTime}s`,
          `${summaryResult}`
        );
      } else {
        showAlert("Error", "Parsed result is empty.");
      }
    } catch (error) {
      showAlert("Error", "Error processing EML file: " + error);
    }
    setShowProgressSpinner(false);
  };

  const handleMicrosoft365Data = async (template: any) => {
    try {
      const rootNode = {
        id: "root",
        type: "center",
        data: {
          label: "Microsoft 365 Data",
          icon: "",
          object: "",
          objectType: "",
          objectWidth: 40,
          objectHeight: 16,
          notes: "",
          complete: false,
          status: "none",
          flagged: "none",
          color: "black",
          backgroundColor: "#ffffff",
          presentationOrder: "",
          priority: "",
          links: [],
          value: "0",
          values: [],
          rollupValues: [],
          customProperties: [],
          event: {} as Event,
          address: {} as Address,
          task: {} as Task,
          ms365Document: null,
        },
        position: { x: 0, y: 0 },
        dragHandle: ".dragHandle",
        width: 40,
        height: 16,
        template: template,
      };
      const pageEdges = oneNotePages.map((page) => {
        return {
          id: nanoid(),
          source: "root",
          target: page.id,
          type: "center",
        };
      });
      const pageNodesWithLayout =
        (await doCircleLayout([rootNode], pageEdges)) || [];
      const customState: FocusMapFlowState = {
        nodes: pageNodesWithLayout || [],
        edges: pageEdges,
      };
      store.setState(customState);
      setNodes(pageNodesWithLayout);
      setEdges(pageEdges);
    } catch (error) {
      showAlert("Error", "Error preparing Microsoft 365 Data: " + error);
    }
  };

  async function handleLawyerData(template: string) {
    try {
      //const location = useLocation();
      const data: LawyerData = location.state?.data;
      //console.log(data); // Access the passed data here

      const rootNode: Node<NodeData> = {
        id: "root",
        type: "center",
        data: {
          label: data?.name || "Lawyer Data",
          notes: "",
          icon: "",
          object: "",
          objectType: "",
          objectWidth: 0,
          objectHeight: 0,
          complete: false,
          status: "none",
          flagged: "none",
          color: "black",
          backgroundColor: "#ffffff",
          presentationOrder: "",
          priority: "",
          links: [],
          value: "0",
          values: [],
          rollupValues: [],
          customProperties: [],
          event: {} as Event,
          address: {} as Address,
          task: {} as Task,
          ms365Document: {} as MS365Document,
        },
        position: { x: 0, y: 0 },
        dragHandle: ".dragHandle",
        width: 40,
        height: 16,
      };

      // Simulate fetching legal data based on the template
      // const legalData = [
      //   {
      //     id: "case-details",
      //     label: "Case Details",
      //     children: [
      //       { id: "case-number", label: "Case Number: 12345" },
      //       { id: "case-type", label: "Case Type: Civil" },
      //     ],
      //   },
      //   {
      //     id: "parties",
      //     label: "Parties Involved",
      //     children: [
      //       { id: "plaintiff", label: "Plaintiff: John Doe" },
      //       { id: "defendant", label: "Defendant: Jane Smith" },
      //     ],
      //   },
      //   {
      //     id: "timeline",
      //     label: "Case Timeline",
      //     children: [
      //       { id: "filed", label: "Filed: 01/01/2023" },
      //       { id: "hearing", label: "Hearing: 02/15/2023" },
      //     ],
      //   },
      // ];

      const nodes: Node<NodeData>[] = [rootNode];
      const edges: Edge[] = [];

      // legalData.forEach((section) => {
      //   const sectionNode = {
      //     id: section.id,
      //     type: "mindmap",
      //     data: {
      //       label: section.label,
      //       description: "",
      //       icon: "",
      //       notes: "",
      //       complete: false,
      //       flagged: "none",
      //       color: "black",
      //       backgroundColor: "#ffffff",
      //       presentationOrder: "",
      //       priority: "",
      //       links: [],
      //       value: "0",
      //       values: [],
      //       rollupValues: [],
      //       customProperties: [],
      //     },
      //     position: { x: 0, y: 0 },
      //     dragHandle: ".dragHandle",
      //     width: 50,
      //     height: 18,
      //     parentNode: "root",
      //   };

      //   nodes.push(sectionNode);
      //   edges.push({
      //     id: nanoid(),
      //     source: "root",
      //     target: section.id,
      //     type: "center",
      //   });

      //   section.children.forEach((child) => {
      //     const childNode = {
      //       id: child.id,
      //       type: "mindmap",
      //       data: {
      //         label: child.label,
      //         description: "",
      //         icon: "",
      //         notes: "",
      //         complete: false,
      //         flagged: "none",
      //         color: "black",
      //         backgroundColor: "#ffffff",
      //         presentationOrder: "",
      //         priority: "",
      //         links: [],
      //         value: "0",
      //         values: [],
      //         rollupValues: [],
      //         customProperties: [],
      //       },
      //       position: { x: 0, y: 0 },
      //       dragHandle: ".dragHandle",
      //       width: 50,
      //       height: 18,
      //       parentNode: section.id,
      //     };

      //     nodes.push(childNode);
      //     edges.push({
      //       id: nanoid(),
      //       source: section.id,
      //       target: child.id,
      //       type: "mindmap",
      //     });
      //   });
      // });

      let sectionNode = await createSectionNode(
        "BBR Data",
        data.formattedBbrData
      );
      nodes.push(sectionNode);
      edges.push({
        id: nanoid(),
        source: "root",
        target: sectionNode.id,
        type: "center",
      });

      sectionNode = await createSectionNode("CPR Data", data.formattedCprData);
      nodes.push(sectionNode);
      edges.push({
        id: nanoid(),
        source: "root",
        target: sectionNode.id,
        type: "center",
      });

      sectionNode = await createSectionNode("CVR Data", data.formattedCvrData);
      nodes.push(sectionNode);
      edges.push({
        id: nanoid(),
        source: "root",
        target: sectionNode.id,
        type: "center",
      });

      sectionNode = await createSectionNode("DAR Data", data.formattedDarData);
      nodes.push(sectionNode);
      edges.push({
        id: nanoid(),
        source: "root",
        target: sectionNode.id,
        type: "center",
      });

      sectionNode = await createSectionNode("EJF Data", data.formattedEjfData);
      nodes.push(sectionNode);
      edges.push({
        id: nanoid(),
        source: "root",
        target: sectionNode.id,
        type: "center",
      });

      sectionNode = await createSectionNode("SVR Data", data.formattedSvrData);
      nodes.push(sectionNode);
      edges.push({
        id: nanoid(),
        source: "root",
        target: sectionNode.id,
        type: "center",
      });

      sectionNode = await createSectionNode("VUR Data", data.formattedVurData);
      nodes.push(sectionNode);
      edges.push({
        id: nanoid(),
        source: "root",
        target: sectionNode.id,
        type: "center",
      });

      const layoutedNodes = await doCircleLayout(nodes, edges);

      const customState: FocusMapFlowState = {
        nodes: layoutedNodes || [],
        edges,
      };

      store.setState(customState);
      setNodes(layoutedNodes);
      setEdges(edges);
    } catch (error) {
      showAlert("Error", "Error loading lawyer data: " + error);
    }
  }

  async function handleRapidLearningCyclesData(template: string) {
    try {
      const templateData = location.state?.data;

      if (!templateData || !templateData.nodes || !templateData.edges) {
        showAlert("Error", "No rapid learning cycles template data found");
        return;
      }

      // Use the template data directly - it already has the proper structure
      const customState: FocusMapFlowState = {
        nodes: templateData.nodes || [],
        edges: templateData.edges || [],
      };

      store.setState(customState);
      setNodes(templateData.nodes);
      setEdges(templateData.edges);

      // Set map metadata if provided
      if (templateData.name) {
        setCurrentMapName(templateData.name);
      }

      // Fit the view to show the imported structure
      setTimeout(() => {
        handleFitView();
      }, 100);
    } catch (error) {
      showAlert("Error", "Error loading rapid learning cycles data: " + error);
    }
  }

  const createSectionNode = async (label: string, formattedData: string) => {
    const nodeId = nanoid();
    const sectionNode = {
      id: nodeId,
      type: "mindmap",
      data: {
        label: label,
        icon: "https://static.wixstatic.com/shapes/2fe974_9b063d7aca7245bea75d0d36b4c5eb17.svg",
        object: "",
        objectType: "",
        objectWidth: 0,
        objectHeight: 0,
        notes: formattedData || "",
        complete: false,
        status: "none",
        flagged: formattedData ? "green" : "none",
        color: "black",
        backgroundColor: "#ffffff",
        presentationOrder: "",
        priority: "",
        links: [],
        value: "0",
        values: [],
        rollupValues: [],
        customProperties: [],
        event: {} as Event,
        address: {} as Address,
        task: {} as Task,
        ms365Document: {} as MS365Document,
      },
      position: { x: 0, y: 0 },
      dragHandle: ".dragHandle",
      width: 50,
      height: 18,
      parentId: "root",
    };
    return sectionNode;
  };

  useEffect(() => {
    if (emailContent && emailContent.length === 0) {
      showAlert("Alert", "No email content to display.");
    } else {
      showAlert("Info", emailContent);
    }
  }, [emailContent]);

  const parseTextToReactFlow = (text: string): FocusMapFlowState => {
    const lines = text.split("\n");
    const nodes: Node<NodeData>[] = [];
    const edges: Edge[] = [];

    const centerNodeId = "root";

    // Add the center node
    nodes.push({
      id: centerNodeId,
      type: "center",
      data: {
        label: "Center Node",
        icon: "",
        object: "",
        objectType: "",
        objectWidth: 40,
        objectHeight: 18,
        notes: "",
        complete: false,
        status: "none",
        flagged: "none",
        color: "black",
        backgroundColor: "#ffffff",
        presentationOrder: "",
        priority: "",
        links: [],
        value: "0",
        values: [],
        rollupValues: [],
        customProperties: [],
        event: {} as Event,
        address: {} as Address,
        task: {} as Task,
        ms365Document: {} as MS365Document,
      }, // Customize as needed
      position: { x: 0, y: 0 },
      width: 40,
      height: 18,
      dragHandle: ".dragHandle",
      parentNode: "",
    });

    let nodeId = 1;

    lines.forEach((line) => {
      if (/^\d+/.test(line)) {
        // Detect a top-level header
        const { label, notes } = truncateText(line.trim(), 20);
        const newNodeId = `node-${nodeId++}`;

        nodes.push({
          id: newNodeId,
          data: {
            label,
            notes,
            icon: "",
            object: "",
            objectType: "",
            objectWidth: 40,
            objectHeight: 18,
            complete: false,
            status: "none",
            flagged: "none",
            color: "black",
            backgroundColor: "#ffffff",
            presentationOrder: "",
            priority: "",
            links: [],
            value: "0",
            values: [],
            rollupValues: [],
            customProperties: [],
            event: {} as Event,
            address: {} as Address,
            task: {} as Task,
            ms365Document: {} as MS365Document,
          },
          position: { x: 200 + nodeId * 50, y: 300 + nodeId * 50 },
          type: "mindmap",
        });

        edges.push({
          id: `edge-${centerNodeId}-${newNodeId}`,
          source: centerNodeId,
          target: newNodeId,
          type: "center",
        });
      } else if (/^\d+\.\d+/.test(line)) {
        // Detect a sub-header
        const { label, notes } = truncateText(line.trim(), 20);
        const newNodeId = `node-${nodeId++}`;

        nodes.push({
          id: newNodeId,
          data: {
            label,
            notes,
            icon: "",
            object: "",
            objectType: "",
            objectWidth: 40,
            objectHeight: 18,
            complete: false,
            status: "none",
            flagged: "none",
            color: "black",
            backgroundColor: "#ffffff",
            presentationOrder: "",
            priority: "",
            links: [],
            value: "0",
            values: [],
            rollupValues: [],
            customProperties: [],
            event: {} as Event,
            address: {} as Address,
            task: {} as Task,
            ms365Document: {} as MS365Document,
          },
          position: { x: 300 + nodeId * 50, y: 400 + nodeId * 50 },
          type: "mindmap",
        });

        // Connect to the last top-level node
        const parentId = `node-${nodeId - 2}`;
        edges.push({
          id: `edge-${parentId}-${newNodeId}`,
          source: parentId,
          type: parentId === centerNodeId ? "center" : undefined,
          target: newNodeId,
        });
      }
    });

    return { nodes, edges };
  };

  const handleNodeContextMenu = (event: React.MouseEvent, node: Node) => {
    console.log("🖱️ Right-click on node:", node.id);
    console.log("🎬 Quick Start Video Modal:", showGettingStartedVideoModal);

    // Check if any PrimeReact dialog is visible (excluding Quick Start video)
    const visibleDialogs = document.querySelectorAll(
      ".p-dialog:not(.p-dialog-hidden)"
    );
    console.log("📋 Visible dialogs count:", visibleDialogs.length);

    // Filter out the Quick Start video dialog by checking for its header text
    const blockingDialogs = Array.from(visibleDialogs).filter((dialog) => {
      const header = dialog.querySelector(".p-dialog-header");
      const headerText = header?.textContent || "";
      console.log("📝 Dialog header:", headerText);
      return headerText !== "Quick Start Video";
    });

    if (blockingDialogs.length > 0 || showNotesModal) {
      console.log("🚫 Context menu blocked by dialog");
      event.preventDefault();
      event.stopPropagation();
      return; // Don't show context menu if any blocking dialog is open
    }

    console.log("✅ Showing context menu");
    event.preventDefault();
    setSelectedNodeId(node.id);
    setSelectedNode(node);

    if (ncm.current) {
      ncm.current?.show(event);
    }

    setColorPickerPosition({ x: event.clientX, y: event.clientY });
  };

  const isChildNode = (parentId: string, nodeId: string): boolean => {
    const parentNode = nodes.find((node) => node.id === parentId);
    if (!parentNode) return false;

    const childNodes = nodes.filter((node) => node.parentId === parentId);
    for (const childNode of childNodes) {
      if (childNode.id === nodeId || isChildNode(childNode.id, nodeId)) {
        return true;
      }
    }
    return false;
  };

  const handleFlagChange = (color: string, event: MenuItemCommandEvent) => {
    if (selectedNodeId) {
      takeSnapshot();
      const updatedNodes = nodes.map((node) => {
        if (
          selectedNodeId &&
          node.id === selectedNodeId
          //|| (event.shiftKey && isChildNode(selectedNodeId, node.id))
        ) {
          return {
            ...node,
            data: {
              ...node.data,
              flagged: color,
            },
          };
        }
        return node;
      });
      setNodes(updatedNodes);
      setIsDirty(true);
    }
    handleCloseContextMenu();
  };

  const handleOpenNotes = (event: MenuItemCommandEvent) => {
    if (selectedNode) {
      takeSnapshot();
      const node = selectedNode as Node;
      const {
        id: nodeId,
        data: {
          label: nodeLabel,
          notes: notes,
          complete: complete,
          flagged: flagged,
          links: links = [],
        },
      } = node;
      setSelectedNode(node);
      setSelectedNodeId(nodeId);
      setCurrentNodeLabel(nodeLabel);
      setCurrentLinks(links || []);
      setCurrentNotes(notes);
      setCurrentNodeComplete(complete);
      setCurrentNodeFlagged(flagged);
      setShowNotesModal(true);
    }
    handleCloseContextMenu();
  };

  const handleSelectColor = (event: MenuItemCommandEvent) => {
    if (selectedNodeId) {
      takeSnapshot();
      setColorPickerVisible(true);
    }
    handleCloseContextMenu();
  };

  const handleColorChange = (color: any) => {
    setNodeColor(color.hex);
  };

  const handleColorChangeComplete = (color: any, event: any) => {
    if (selectedNode) {
      // Check if shift key was pressed (event is passed as the second argument)
      const shiftKey = event?.shiftKey;

      // Helper to get all child node ids recursively
      const getAllChildNodeIds = (parentId: string): string[] => {
        const directChildren = nodes.filter((n) => n.parentId === parentId);
        return directChildren.reduce<string[]>(
          (acc, child) => [...acc, child.id, ...getAllChildNodeIds(child.id)],
          []
        );
      };

      let nodeIdsToUpdate: string[] = [selectedNode.id];
      if (shiftKey) {
        nodeIdsToUpdate = [
          selectedNode.id,
          ...getAllChildNodeIds(selectedNode.id),
        ];
      }

      const updatedNodes = nodes.map((node) =>
        nodeIdsToUpdate.includes(node.id)
          ? {
              ...node,
              style: {
                ...node.style,
                backgroundColor: color.hex,
              },
              data: {
                ...node.data,
                color: getContrastColor(color.hex),
                backgroundColor: color.hex,
              },
            }
          : node
      );
      setNodes(updatedNodes);
      setIsDirty(true);
      setColorPickerVisible(false);
    }
  };

  const getContrastColor = (hex: string) => {
    // Convert hex to RGB
    const r = parseInt(hex.substring(1, 3), 16);
    const g = parseInt(hex.substring(3, 5), 16);
    const b = parseInt(hex.substring(5, 7), 16);

    // Calculate relative luminance using sRGB gamma correction (WCAG standard)
    const rsRGB = r / 255;
    const gsRGB = g / 255;
    const bsRGB = b / 255;

    const rLinear =
      rsRGB <= 0.03928 ? rsRGB / 12.92 : Math.pow((rsRGB + 0.055) / 1.055, 2.4);
    const gLinear =
      gsRGB <= 0.03928 ? gsRGB / 12.92 : Math.pow((gsRGB + 0.055) / 1.055, 2.4);
    const bLinear =
      bsRGB <= 0.03928 ? bsRGB / 12.92 : Math.pow((bsRGB + 0.055) / 1.055, 2.4);

    const luminance = 0.2126 * rLinear + 0.7152 * gLinear + 0.0722 * bLinear;

    // Return black for light colors, white for dark colors
    // Using 0.179 threshold for better readability (YIQ perceived brightness)
    const contrastColor = luminance > 0.179 ? "#000000" : "#FFFFFF";
    console.info(
      "Contrast color for",
      hex,
      "luminance:",
      luminance.toFixed(3),
      "→",
      contrastColor
    );
    return contrastColor;
  };

  const updateNodeLabelWithEmoji = (
    nodeId: string,
    emoji: string,
    cursorPosition: number
  ) => {
    const updatedNodes = nodes.map((node) =>
      node.id === nodeId
        ? {
            ...node,
            data: {
              ...node.data,
              icon: emoji,
            },
          }
        : node
    );
    setNodes(updatedNodes);
    setIsDirty(true);
  };

  const handleEmojiSelect = (emojiData: EmojiClickData) => {
    if (emojiNodeId) {
      updateNodeLabelWithEmoji(emojiNodeId, emojiData.emoji, cursorPosition);
      setEmojiPickerVisible(false);
      setCursorPosition(0);
    }
  };

  const handleEmojiMenuItemClick = (event: MenuItemCommandEvent) => {
    if (selectedNode) {
      takeSnapshot();
      setEmojiNodeId(selectedNode.id);
      setEmojiPickerPosition({
        x: (event.originalEvent as unknown as MouseEvent).clientX - 50,
        y: (event.originalEvent as unknown as MouseEvent).clientY - 200,
      });
      setEmojiPickerVisible(true);
    }
    handleCloseContextMenu();
  };

  const handleRemoveImage = (event: MenuItemCommandEvent) => {
    if (selectedNode) {
      takeSnapshot();
      const updatedNodes = nodes.map((node) =>
        node.id === selectedNode.id
          ? {
              ...node,
              data: {
                ...node.data,
                icon: "",
              },
            }
          : node
      );
      setNodes(updatedNodes);
      setIsDirty(true);
    }
    handleCloseContextMenu();
  };

  const handleImageMenuItemClick = (event: MenuItemCommandEvent) => {
    if (selectedNode) {
      takeSnapshot();
      setEmojiNodeId(selectedNode.id);
      // setEmojiPickerPosition({
      //   x: (event.originalEvent as unknown as MouseEvent).clientX - 50,
      //   y: (event.originalEvent as unknown as MouseEvent).clientY - 200,
      // });
      setImagePickerVisible(true);
    }
    handleCloseContextMenu();
  };

  const handleImageByUrlMenuItemClick = (event: MenuItemCommandEvent) => {
    if (selectedNode) {
      takeSnapshot();
      setShowSetImageByUrl(true);
    }
    handleCloseContextMenu();
  };

  const handleConfirmImageUrl = (event: React.MouseEvent, url: string) => {
    if (selectedNode) {
      const updatedNodes = nodes.map((node) =>
        node.id === selectedNode.id
          ? {
              ...node,
              type: "image",
              data: {
                ...node.data,
                icon: url,
              },
            }
          : node
      );
      setNodes(updatedNodes);
      setIsDirty(true);
    }
    setShowSetImageByUrl(false);
  };

  const handleSummaryMenuItemClick = () => {
    if (selectedNode) {
      showAlert("Summary", calculateSummary(selectedNode.id));
    }
    handleCloseContextMenu();
  };

  const handleLoadCustomProperties = async (event: MenuItemCommandEvent) => {
    const node = selectedNode;
    if (node) {
      setSelectedNodeId(node.id);

      // Get flow-level property definitions
      const flowProps = await loadFlowProps(
        flowId ? flowId : "",
        useStore.getState().useLocalStorage
      );

      // Merge flow-level definitions with node's actual values
      const mergedProperties = (flowProps || []).map(
        (flowProp: CustomProperty) => {
          const nodeProp = node.data.customProperties?.find(
            (p: CustomProperty) => p.name === flowProp.name
          );
          // Use node's value if it exists, otherwise use empty value
          return (
            nodeProp || {
              name: flowProp.name,
              type: flowProp.type,
              value:
                flowProp.type === "calculated"
                  ? flowProp.value
                  : flowProp.type === "boolean"
                  ? false
                  : "",
              visible: flowProp.visible,
            }
          );
        }
      );

      setInitialCustomProperties(mergedProperties);
      setShowCustomPropertiesModal(true);
    }
  };

  const [copiedNodes, setCopiedNodes] = useState<Node<NodeData>[]>([]);
  const [copiedEdges, setCopiedEdges] = useState<Edge[]>([]);

  const handleCopyNodes = (event: MenuItemCommandEvent) => {
    const thisNode = nodes.find(
      (n): n is Node<NodeData> => n.id === selectedNodeId
    );
    if (thisNode) {
      thisNode.parentId = "";
      const getAllChildNodes = (parentId: string): Node<NodeData>[] => {
        return nodes
          .filter((n) => n.parentId === parentId)
          .reduce(
            (acc: Node<NodeData>[], child) => [
              ...acc,
              child as Node<NodeData>,
              ...getAllChildNodes(child.id),
            ],
            []
          );
      };

      const copiedNodes: Node<NodeData>[] = [
        thisNode,
        ...getAllChildNodes(thisNode.id),
      ];
      const copiedEdges = edges.filter((e) =>
        // nb: not including the parent copied node's edges
        copiedNodes.some(
          (n) =>
            (n.id === e.source && n.id !== thisNode.id) ||
            (n.id === e.target && n.id !== thisNode.id)
        )
      );

      setCopiedNodes(copiedNodes);
      setCopiedEdges(copiedEdges);
    }
  };

  const handleSaveCustomProperties = (customProperties: CustomProperty[]) => {
    try {
      const updateNodeCustomProperties =
        useStore.getState().updateNodeCustomProperties;
      if (selectedNodeId) {
        updateNodeCustomProperties(selectedNodeId, customProperties);
      }
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : "Unknown error";
      showAlert("Error", "Error in Custom Properties: " + errorMessage);
    }
  };

  const handleMouseMove = (event: React.MouseEvent) => {
    // const quickLookDiv = document.getElementById("quick-look");
    //   if (quickLookDiv) {
    //     document.body.removeChild(quickLookDiv);
    //   }
  };

  // function handleShowTourGuide() {
  //   setTourSteps([
  //     {
  //       target: "#center-goal-node",
  //       content:
  //         "Dette er dit centrale mål eller fokuspunkt. Du kan bygge dit mindmap ud fra dette punkt.",
  //       placement: "bottom",
  //     },
  //   ]);
  //   setShowTour(true);
  // }

  const handleCanvasContextMenu = (event: React.MouseEvent) => {
    //event.preventDefault();

    const targetElement = document.elementFromPoint(
      event.clientX,
      event.clientY
    );

    if (targetElement && targetElement.closest(".react-flow__node")) {
      return;
    } else {
      if (showNotesModal) {
        return;
      }

      setNewFlowPosition({ x: event.clientX, y: event.clientY });

      if (cm.current) {
        cm.current?.show(event);
      }
    }
  };

  const [showAiModal, setShowAiModal] = useState(false);
  const [aiTopic, setAiTopic] = useState("");

  const [showFocusAiModal, setShowFocusAiModal] = useState(false);
  const [focusAiTopic, setFocusAiTopic] = useState("");

  // Double Ctrl/Cmd press to toggle Focus AI modal
  useEffect(() => {
    let ctrlPressCount = 0;
    let ctrlPressTimer: NodeJS.Timeout | null = null;
    let lastKeyWasModifier = false;

    const handleCtrlDoublePress = (event: KeyboardEvent) => {
      // Check for Ctrl (Windows/Linux) or Cmd/Meta (Mac)
      const isModifierKey =
        event.key === "Control" ||
        event.key === "Meta" ||
        event.code === "ControlLeft" ||
        event.code === "ControlRight" ||
        event.code === "MetaLeft" ||
        event.code === "MetaRight";

      if (isModifierKey) {
        ctrlPressCount++;
        lastKeyWasModifier = true;

        // Clear existing timer
        if (ctrlPressTimer) {
          clearTimeout(ctrlPressTimer);
        }

        // Check if it's a double press (within 400ms)
        if (ctrlPressCount === 2) {
          // Toggle the AI Input modal (same as the button in menu)
          setShowAIInput((prev) => !prev);
          ctrlPressCount = 0;
        }

        // Reset counter after 400ms
        ctrlPressTimer = setTimeout(() => {
          ctrlPressCount = 0;
        }, 400);
      }
    };

    const handleKeyUp = (event: KeyboardEvent) => {
      // Reset on any non-modifier key press
      const isModifierKey =
        event.key === "Control" ||
        event.key === "Meta" ||
        event.code === "ControlLeft" ||
        event.code === "ControlRight" ||
        event.code === "MetaLeft" ||
        event.code === "MetaRight";

      if (!isModifierKey && lastKeyWasModifier) {
        // User pressed another key, reset
        ctrlPressCount = 0;
        if (ctrlPressTimer) {
          clearTimeout(ctrlPressTimer);
        }
      }
    };

    window.addEventListener("keydown", handleCtrlDoublePress);
    window.addEventListener("keyup", handleKeyUp);
    return () => {
      window.removeEventListener("keydown", handleCtrlDoublePress);
      window.removeEventListener("keyup", handleKeyUp);
      if (ctrlPressTimer) {
        clearTimeout(ctrlPressTimer);
      }
    };
  }, [setShowAIInput, showAIInput]);

  const [showPubMedModal, setShowPubMedModal] = useState(false);
  const [pubMedTopic, setPubMedTopic] = useState("");

  const [showBonsaiModal, setShowBonsaiModal] = useState(false);
  const [bonsaiTopic, setBonsaiTopic] = useState("");

  const [showCvrModal, setShowCvrModal] = useState(false);
  const [cvrTopic, setCvrTopic] = useState("");

  const [showBrainstorm, setShowBrainstorm] = useState(false);
  const [showGuidedCreation, setShowGuidedCreation] = useState(false);

  const handleBrainstormStructureUpdate = (structure: {
    nodes: Node<NodeData>[];
    edges: MapEdge[];
  }) => {
    if (!structure || !structure.nodes || structure.nodes.length === 0) return;

    takeSnapshot();

    const newNodes: Node<NodeData>[] = [];
    const newEdges: MapEdge[] = [];

    // Find center/root node to position children below it
    const centerNode = nodes.find(
      (n) => n.type === "center" || n.id === "root" || n.type === "input"
    );
    const startY = centerNode ? centerNode.position.y + 150 : 150;
    const startX = centerNode ? centerNode.position.x : 0;

    structure.nodes.forEach((structNode, index: number) => {
      const existingNode = nodes.find((n) => n.id === structNode.id);
      if (existingNode) return; // Skip if already exists

      // Calculate position in a row below center node
      const xOffset = (index - structure.nodes.length / 2) * 200;

      // Use the incoming node structure directly, just add missing required fields
      const newNode: Node<NodeData> = {
        ...structNode,
        type: structNode.type || "mindmap",
        style: structNode.style || { backgroundColor: "#fff" },
        position: structNode.position || { x: startX + xOffset, y: startY },
        positionAbsolute: structNode.positionAbsolute || {
          x: startX + xOffset,
          y: startY,
        },
        dragging: structNode.dragging ?? false,
        selected: structNode.selected ?? false,
        width: structNode.width || 50,
        height: structNode.height || 18,
        dragHandle: structNode.dragHandle || ".dragHandle",
        parentId: structNode.parentId || (centerNode ? centerNode.id : ""),
        data: {
          label: structNode.data?.label || "",
          icon:
            structNode.data?.icon ||
            "https://static.wixstatic.com/media/_787025d806fc4adfb35aa3f4cadfb735~mv2.png",
          object: structNode.data?.object || "",
          objectType: structNode.data?.objectType || "text",
          objectWidth: structNode.data?.objectWidth || 50,
          objectHeight: structNode.data?.objectHeight || 18,
          notes: structNode.data?.notes || "",
          complete: structNode.data?.complete ?? false,
          status: structNode.data?.status || "none",
          flagged: structNode.data?.flagged || "none",
          color: structNode.data?.color || "black",
          backgroundColor: structNode.data?.backgroundColor || "#ffffff",
          presentationOrder: structNode.data?.presentationOrder || "",
          priority: structNode.data?.priority || "",
          links: structNode.data?.links || [],
          value: structNode.data?.value || "0",
          values: structNode.data?.values || [],
          rollupValues: structNode.data?.rollupValues || [],
          customProperties: structNode.data?.customProperties || [],
          event: structNode.data?.event || ({} as Event),
          address: structNode.data?.address || ({} as Address),
          task: structNode.data?.task || ({} as Task),
          ms365Document: structNode.data?.ms365Document || null,
        },
      };

      newNodes.push(newNode);
    });

    // Create edges from structure or from parent relationships
    if (structure.edges && structure.edges.length > 0) {
      structure.edges.forEach((structEdge) => {
        const existingEdge = edges.find((e) => e.id === structEdge.id);
        if (!existingEdge) {
          newEdges.push({
            id: structEdge.id,
            source: structEdge.source,
            target: structEdge.target,
            type: structEdge.type || "smoothstep",
          });
        }
      });
    } else {
      // Auto-create edges based on parentId
      newNodes.forEach((node) => {
        if (node.parentId) {
          newEdges.push({
            id: nanoid(),
            source: node.parentId,
            target: node.id,
            type: "smoothstep",
          });
        }
      });
    }

    setNodes([...nodes, ...newNodes]);
    setEdges([...edges, ...newEdges]);
    setIsDirty(true);
  };

  const handleAiQuery = async (includeMapDetails: boolean) => {
    setShowAiModal(false);

    let mapDetails = "";
    if (includeMapDetails) {
      mapDetails = getMapDetails(nodes, edges);
    }

    await generateAiMap(
      aiTopic + " " + mapDetails,
      3,
      setLoading,
      nodes,
      edges,
      setNodes,
      setEdges,
      showAlert,
      newFlowPosition
    );

    doCircleLayout(nodes, edges);
  };

  const handlePubMedQuery = async () => {
    setShowPubMedModal(false);
    showAlert("Coming up", "Searching PubMed for articles on " + pubMedTopic);
  };

  const handleBonsaiQuery = async () => {
    setShowBonsaiModal(false);
    showAlert("Coming up", "Searching Bonsai for articles on " + bonsaiTopic);
  };

  const handleCvrQuery = async () => {
    setShowCvrModal(false);
    showAlert("Coming up", `Searching CVR for data on "${cvrTopic}"`);
  };

  const handleOnNodesChange = async (nodes: NodeChange[]) => {
    //takeSnapshot();
    onNodesChange(nodes);
  };

  const handleOnEdgesChange = async (edges: EdgeChange[]) => {
    //takeSnapshot();
    onEdgesChange(edges);
  };

  const focusOnNode = (nodeId: string) => {
    const node = nodes.find((n) => n.id === nodeId);
    if (!node) return;

    fitView({
      nodes: [{ id: node.id }],
      duration: 800,
      minZoom: 2,
      maxZoom: 2,
    });
  };

  const showUserSettings = async () => {
    const authUser = auth.currentUser;
    if (authUser) {
      const user: User | null = await getUserDoc(authUser.uid, false);
      if (user) {
        setUserDetails(user);
        setUser(user); // Update store with user data
        setPresentWithShowHideButtons(
          user.settings?.presentWithShowHideButtons || false
        );
        setCurrency(user.settings?.currency || "EUR");
        setShowWhyTag(user.settings?.showWhyTag !== false); // Default to true
        setShowStartupDialog(user.settings?.showStartupDialog === true); // Default to false - must be explicitly enabled
        setShowAIPromptOnNewMap(user.settings?.showAIPromptOnNewMap === true); // Default to false
        setAiModel(user.settings?.aiModel || "gpt-4o-mini"); // Default to gpt-4o-mini
        setUserSettingsVisible(true);
      } else {
        showAlert("User Not Found", "User details could not be retrieved.");
      }
    }
  };

  const saveUserSettings = async () => {
    const authUser = auth.currentUser;
    if (authUser) {
      await updateUserSettings(
        authUser?.uid,
        {
          presentWithShowHideButtons,
          currency,
          showWhyTag,
          showStartupDialog,
          showAIPromptOnNewMap,
          aiModel,
        },
        false
      );

      // Update the user object in the store with the new settings
      if (userDetails) {
        const updatedUser = {
          ...userDetails,
          settings: {
            ...userDetails.settings,
            presentWithShowHideButtons,
            currency,
            showWhyTag,
            showStartupDialog,
            showAIPromptOnNewMap,
            aiModel,
          },
        };
        setUser(updatedUser);
      }

      setUserSettingsVisible(false);
    }
  };

  const getMapDetails = (nodes: Node<NodeData>[], edges: Edge[]): string => {
    const nodeMap = new Map<string, Node<NodeData>>();
    nodes.forEach((node) => nodeMap.set(node.id, node));

    const buildOutline = (nodeId: string, level: number): string => {
      const node = nodeMap.get(nodeId);
      if (!node) return "";

      const indent = "  ".repeat(level);
      let outline = `${indent}${node.data.label}\n`;
      if (node.data.notes) {
        outline += `${indent}  Notes: ${node.data.notes}\n`;
      }

      const childEdges = edges.filter((edge) => edge.source === nodeId);
      childEdges.forEach((edge) => {
        outline += buildOutline(edge.target, level + 1);
      });

      return outline;
    };

    const rootNode = nodes.find(
      (node) => node.type === "center" || node.id === "root"
    );
    if (!rootNode) return "";

    return buildOutline(rootNode.id, 0);
  };

  const headerElement = (
    <div className="inline-flex align-items-center justify-content-center gap-2">
      <span className="font-bold white-space-nowrap">User Settings</span>
    </div>
  );

  const footerContent = (
    <div>
      <Button
        label="Ok"
        icon="pi pi-check"
        onClick={() => saveUserSettings()}
        autoFocus
      />
    </div>
  );

  const handleShowGettingStartedVideo = () => {
    setDoNotShowGettingStartedNextTime(!doNotShowGettingStartedNextTime);
    localStorage.setItem(
      "doNotShowGettingStartedNextTime",
      JSON.stringify(!doNotShowGettingStartedNextTime)
    );
  };

  // Handler for controlling Getting Started from User Settings
  const handleSetShowGettingStarted = (value: boolean) => {
    // Note: showGettingStarted is the inverse of doNotShowGettingStartedNextTime
    setDoNotShowGettingStartedNextTime(!value);
    localStorage.setItem(
      "doNotShowGettingStartedNextTime",
      JSON.stringify(!value)
    );
  };

  const loadShowGettingStartedVideoFromLocalStorage = () => {
    const doNotShowGettingStartedNextTimeString = localStorage.getItem(
      "doNotShowGettingStartedNextTime"
    );
    if (doNotShowGettingStartedNextTimeString) {
      setDoNotShowGettingStartedNextTime(
        doNotShowGettingStartedNextTimeString === "true"
      );
    }
  };

  useEffect(() => {
    loadShowGettingStartedVideoFromLocalStorage();
  }, []);

  function updateNodesData(updated: Node<NodeData>[]): void {
    // Update the nodes in the store and mark as dirty
    takeSnapshot();
    const customState: FocusMapFlowState = {
      nodes: updated,
      edges: edges,
    };
    store.setState(customState);
    setNodes(updated);
    setIsDirty(true);
  }

  // Handler for TourGuideButton: show only first step
  function handleShowTourGuide() {
    // setTourSteps([
    //   {
    //     target: "#center-goal-node",
    //     content:
    //       "Dette er dit centrale mål eller fokuspunkt. Du kan bygge dit mindmap ud fra dette punkt.",
    //     placement: "bottom",
    //   },
    //   {
    //     target: "#tour-guide-btn",
    //     content:
    //       "Denne knap åbner denne Tour Guide når som helst, hvis du har brug for hjælp.",
    //     placement: "bottom",
    //   },
    //   {
    //     target: "#ai-menu-btn",
    //     content:
    //       "Klik her for at bruge AI til at generere nye ideer eller hjælpe med dit mindmap.",
    //     placement: "bottom",
    //   },
    // ]);
    // setTourKey((k) => k + 1);
    // setShowTour(true);
  }

  const handleAIInputSubmit = (text: string) => {
    console.log("AI Input submitted:", text);
    // Keep the input visible after submission - it will be cleared in the component
  };

  const handleUpdateNodesFromAI = (
    newNodes: Node<NodeData>[],
    newEdges: Edge[],
    deleteNodeIds: string[] = [],
    selectNodeId: string | null = null,
    formatAll: boolean = false
  ) => {
    try {
      takeSnapshot();

      // Get latest nodes and edges from useStore to ensure we have the most recent state
      let updatedNodes = [...useStore.getState().nodes];
      let updatedEdges = [...useStore.getState().edges];

      console.log(
        "Starting update with current node count:",
        updatedNodes.length
      );

      // Validate nodes before processing to prevent circular references
      const validateNodeHierarchy = (
        nodeId: string,
        parentId: string,
        allEdges: Edge[]
      ): boolean => {
        if (nodeId === parentId) {
          console.error("Node cannot be its own parent:", nodeId);
          return false;
        }

        // Check if parentId would create a circular reference
        const visited = new Set<string>();
        let currentId = parentId;

        while (currentId) {
          if (currentId === nodeId) {
            console.error(
              "Circular reference detected:",
              nodeId,
              "->",
              parentId
            );
            return false;
          }

          if (visited.has(currentId)) {
            console.error("Circular reference in hierarchy:", currentId);
            return false;
          }

          visited.add(currentId);

          // Find parent of current node
          const parentEdge = allEdges.find((e) => e.target === currentId);
          currentId = parentEdge ? parentEdge.source : "";

          if (visited.size > 100) {
            console.error("Hierarchy too deep, possible circular reference");
            return false;
          }
        }

        return true;
      };

      // Only validate NEW nodes or nodes where parentId is CHANGING
      for (const newNode of newNodes) {
        console.log(
          `Validating node: ${newNode.data?.label}, id: ${newNode.id}, parentId: ${newNode.parentId}, type: ${newNode.type}`
        );

        // Skip validation for center nodes (they have no parent)
        if (newNode.type === "center" || !newNode.parentId) {
          console.log(
            `Skipping validation for center/root node: ${newNode.data?.label}`
          );
          continue;
        }

        if (newNode.parentId) {
          const existingNode = updatedNodes.find((n) => n.id === newNode.id);

          // Skip validation if:
          // 1. Node exists and parentId hasn't changed (style update)
          // 2. Node exists and has no edges in newEdges (style update without move)
          if (existingNode && existingNode.parentId === newNode.parentId) {
            console.log(
              `Skipping validation for style update on node: ${newNode.data?.label}`
            );
            continue;
          }

          const isValid = validateNodeHierarchy(newNode.id, newNode.parentId, [
            ...edges,
            ...newEdges,
          ]);
          if (!isValid) {
            throw new Error(
              `Ugyldig node struktur detekteret. Node "${
                newNode.data?.label || newNode.id
              }" kan ikke placeres under den angivne parent.`
            );
          }
        }
      }

      // Handle deletions first (including all descendants)
      if (deleteNodeIds.length > 0) {
        console.log("Deleting nodes:", deleteNodeIds);

        // Find all descendants recursively
        const findDescendants = (
          nodeId: string,
          allEdges: Edge[]
        ): string[] => {
          const children = allEdges
            .filter((e) => e.source === nodeId)
            .map((e) => e.target);

          const descendants: string[] = [...children];
          children.forEach((childId) => {
            descendants.push(...findDescendants(childId, allEdges));
          });

          return descendants;
        };

        // Collect all node IDs to delete (requested nodes + their descendants)
        const allNodesToDelete = new Set<string>();
        deleteNodeIds.forEach((nodeId) => {
          allNodesToDelete.add(nodeId);
          const descendants = findDescendants(nodeId, updatedEdges);
          descendants.forEach((id) => allNodesToDelete.add(id));
        });

        console.log(
          "Deleting nodes and descendants:",
          Array.from(allNodesToDelete)
        );

        // Remove nodes
        updatedNodes = updatedNodes.filter(
          (node) => !allNodesToDelete.has(node.id)
        );

        // Remove edges connected to deleted nodes
        updatedEdges = updatedEdges.filter(
          (edge) =>
            !allNodesToDelete.has(edge.source) &&
            !allNodesToDelete.has(edge.target)
        );
      }

      // Check if any nodes already exist (being moved/updated rather than created)
      const newNodeIds = new Set(newNodes.map((n) => n.id));
      const existingNodeUpdates = newNodes.filter((n) =>
        updatedNodes.find((existing) => existing.id === n.id)
      );

      const isUpdatingNodes = existingNodeUpdates.length > 0;

      if (isUpdatingNodes) {
        // Determine if this is a style update or a move
        // Style update: parentId is either the same or undefined (when stripped by AIInputFloat)
        const isStyleUpdate = existingNodeUpdates.every((newNode) => {
          const existingNode = updatedNodes.find((n) => n.id === newNode.id);
          return (
            existingNode &&
            (existingNode.parentId === newNode.parentId ||
              newNode.parentId === undefined)
          );
        });

        if (isStyleUpdate) {
          console.log("Detected style/property update operation");
          console.log("Existing nodes count:", updatedNodes.length);
          console.log("Nodes to update count:", newNodes.length);
          console.log(
            "Nodes to update IDs:",
            newNodes.map((n) => n.id)
          );

          // For style updates: merge properties, keep existing edges
          updatedNodes = updatedNodes.map((existingNode) => {
            const newNode = newNodes.find((n) => n.id === existingNode.id);
            if (newNode) {
              // Check if backgroundColor changed and update text color accordingly
              const newBackgroundColor = newNode.data?.backgroundColor;
              const backgroundColorChanged =
                newBackgroundColor &&
                newBackgroundColor !== existingNode.data?.backgroundColor;

              let updatedData = {
                ...existingNode.data,
                ...newNode.data,
              };

              // If backgroundColor changed, calculate contrasting text color
              if (backgroundColorChanged) {
                const contrastColor = getContrastColor(newBackgroundColor);
                console.log(
                  `Setting contrast color ${contrastColor} for background ${newBackgroundColor}`
                );
                updatedData = {
                  ...updatedData,
                  color: contrastColor,
                };
              } else if (
                !backgroundColorChanged &&
                newNode.data?.color === "black"
              ) {
                // If background didn't change and AI returned default "black" color,
                // preserve the existing color (don't overwrite calculated contrast colors)
                updatedData = {
                  ...updatedData,
                  color: existingNode.data?.color || "black",
                };
              }

              // Merge data properties, preserving parentId, position, and type
              return {
                ...existingNode,
                ...newNode,
                type: existingNode.type, // Preserve original type (e.g., "center")
                parentId: existingNode.parentId, // Preserve original parentId
                position: existingNode.position, // Preserve original position
                data: updatedData,
              };
            }
            return existingNode;
          });

          // Don't modify edges for style updates - keep all existing edges
          // (edges in response are likely duplicates)
          console.log("After style update, nodes count:", updatedNodes.length);
          console.log(
            "Updated node IDs:",
            updatedNodes.map((n) => n.id)
          );
        } else {
          console.log("Detected node movement operation");

          // For moving nodes: update nodes and manage edges
          updatedNodes = updatedNodes.map((existingNode) => {
            const newNode = newNodes.find((n) => n.id === existingNode.id);
            return newNode || existingNode; // Replace if found, keep original otherwise
          });

          // Add any truly new nodes that don't exist yet
          const trulyNewNodes = newNodes.filter(
            (n) => !updatedNodes.find((existing) => existing.id === n.id)
          );
          updatedNodes = [...updatedNodes, ...trulyNewNodes];

          // Remove old edges for nodes that are being moved
          // An edge should be removed if its target is one of the moved nodes
          // and it's not in the new edges list
          const newEdgeTargets = new Set(newEdges.map((e) => e.target));
          updatedEdges = updatedEdges.filter((edge) => {
            // Keep edge if its target is not being moved
            if (!newNodeIds.has(edge.target)) return true;

            // Keep edge if it's in the new edges (same source and target)
            const isInNewEdges = newEdges.some(
              (newEdge) =>
                newEdge.source === edge.source && newEdge.target === edge.target
            );

            if (!isInNewEdges) {
              console.log(
                `Removing old edge: ${edge.source} -> ${edge.target}`
              );
            }

            return isInNewEdges;
          });

          // Add the new edges
          updatedEdges = [
            ...updatedEdges,
            ...newEdges.filter(
              (newEdge) =>
                !updatedEdges.some(
                  (e) =>
                    e.source === newEdge.source && e.target === newEdge.target
                )
            ),
          ];
        }
      } else {
        // For adding new nodes: simply append
        updatedNodes = [...updatedNodes, ...newNodes];
        updatedEdges = [...updatedEdges, ...newEdges];
      }

      // Update state
      const customState: FocusMapFlowState = {
        nodes: updatedNodes,
        edges: updatedEdges,
      };
      store.setState(customState);

      setNodes(updatedNodes);
      setEdges(updatedEdges);
      setIsDirty(true);

      // Handle node selection if requested
      if (selectNodeId) {
        console.log("Selecting node:", selectNodeId);
        const nodeToSelect = updatedNodes.find((n) => n.id === selectNodeId);
        if (nodeToSelect) {
          // Deselect all nodes first
          updatedNodes = updatedNodes.map((node) => ({
            ...node,
            selected: node.id === selectNodeId,
          }));

          // Update state again with selection
          const customStateWithSelection: FocusMapFlowState = {
            nodes: updatedNodes,
            edges: updatedEdges,
          };
          store.setState(customStateWithSelection);
          setNodes(updatedNodes);
        } else {
          console.warn("Node to select not found:", selectNodeId);
        }
      }

      // Handle format all (layout redistribution like Cmd+L)
      if (formatAll) {
        console.log(
          "Format all requested - redistributing all nodes from center"
        );
        const { redistributeAllChildNodes } = useStore.getState();
        const centerNode = updatedNodes.find((n) => n.type === "center");
        if (centerNode) {
          redistributeAllChildNodes(centerNode.id);
        }
      }

      // Show success message
      let action = "Added";
      if (isUpdatingNodes) {
        const isStyleUpdate = existingNodeUpdates.every((newNode) => {
          const originalNode = nodes.find((n) => n.id === newNode.id);
          return originalNode && originalNode.parentId === newNode.parentId;
        });
        action = isStyleUpdate ? "Updated" : "Moved";
      }

      // Success - no need to show toast message for AI operations
      // let message = `${action} ${newNodes.length} node(s)`;
      // if (deleteNodeIds.length > 0) {
      //   message =
      //     `Deleted ${deleteNodeIds.length} node(s)` +
      //     (newNodes.length > 0 ? ` and ${message.toLowerCase()}` : "");
      // }
      // if (selectNodeId && newNodes.length === 0 && deleteNodeIds.length === 0) {
      //   message = "Selected node";
      //   action = "Selected";
      // }
      // showMessage(
      //   "Nodes " + (deleteNodeIds.length > 0 ? "Updated" : action),
      //   message,
      //   toast,
      //   "success"
      // );
    } catch (error) {
      console.error("Error updating nodes from AI:", error);

      // User-friendly error message in Danish
      const errorMessage =
        error instanceof Error ? error.message : "Kunne ikke opdatere kortet";

      if (
        errorMessage.includes("Ugyldig") ||
        errorMessage.includes("circular")
      ) {
        showAlert(
          "Fejl i struktur",
          errorMessage + " Prøv at formulere din anmodning på en anden måde."
        );
      } else if (errorMessage.includes("Maximum call stack")) {
        showAlert(
          "Strukturfejl",
          "Der opstod en fejl i kortets struktur. Prøv at genindlæse siden og prøv igen."
        );
      } else {
        showAlert("Fejl", "Kunne ikke opdatere kortet: " + errorMessage);
      }

      // Reset loading state if AI input is visible
      setIsDirty(false);
    }
  };

  return (
    <div
      id="baseDiv"
      style={{ display: "flex", flexFlow: "column", height: "100%" }}
      onDrop={handleDrop}
      onDragOver={(event) => event.preventDefault()}
      onMouseMove={handleEmojiPickerMouseMove}
      onMouseUp={handleEmojiPickerMouseUp}
      onContextMenu={handleCanvasContextMenu}
    >
      <Toast ref={toast} position="top-center" />
      {/* TourGuide overlay */}
      {/* <TourGuide
        key={tourKey}
        run={showTour}
        steps={tourSteps}
        onClose={() => setShowTour(false)}
      /> */}
      {loading && (
        <div className="progress-overlay">
          <div className="progress-indicator"></div>
          <div className="working">
            <div>Insights</div>
            <div>coming up...</div>
          </div>
        </div>
      )}
      <MenuBar
        onShowTourGuide={handleShowTourGuide}
        // Handler for TourGuideButton: show only first step
        //onLoad={() => handleLoad(flowId)}
        onSave={handleSave}
        onImport={handleImport}
        onImportWord={handleImportWord}
        onExport={handleExport}
        onUndo={handleUndo}
        onRedo={handleRedo}
        onAutoCircle={() => doCircleLayout(null, null)}
        onAutoTree={(direction) => doTreeLayout(direction)}
        onFeatures={doFeatures}
        onShare={doShare}
        onFocus={handleFocus}
        focusValue={focusValue}
        onToggleSnapToGrid={toggleSnapToGrid}
        snapToGrid={snapToGrid}
        onToggleShowMiniMap={toggleShowMiniMap}
        showMiniMap={showMiniMap}
        onToggleAIInput={() => setShowAIInput(!showAIInput)}
        flowId={currentFlowId} // Pass flowId to MenuBar
        onSetNodes={setNodes}
        onSetEdges={setEdges}
        onExportToPng={handleExportToPng} // Pass handleExportToPng to MenuBar
        onExportToClipboard={handleExportToClipboard} // Pass handleExportToClipboard to MenuBar
        captureScreenshot={captureScreenshot} // Pass captureScreenshot to MenuBar
        onFitView={handleFitView}
        onFitMapView={fitMapView} // Pass fitMapView as a prop
        focusOnNode={focusOnNode}
        setShowAiModal={setShowAiModal}
        setShowFocusAiModal={setShowFocusAiModal}
        setShowPubMedModal={setShowPubMedModal}
        setShowBonsaiModal={setShowBonsaiModal}
        setBrainstormVisible={setBrainstormVisible}
        guideVisible={guideVisible}
        setGuideVisible={setGuideVisible}
        //handleSideBarToggle={handleSideBarToggle}
        handleUserSettings={showUserSettings}
        setShowCvrModal={setShowCvrModal}
        ideationMode={ideationMode}
        setIdeationMode={setIdeationMode}
        ms365Mode={ms365Mode}
        setMS365Mode={setMS365Mode}
        aiMode={aiMode}
        setAIMode={setAIMode}
        detailsMode={detailsMode}
        setDetailsMode={setDetailsMode}
        onSaveAsTemplate={promptToSaveAsTemplate}
        handleMapData={handleMapData}
        mapTemplate={mapTemplate}
        msDocumentFiltering={(timelineEventFiltering: MS365DocumentFilter) =>
          doTimelineEventFiltering(timelineEventFiltering)
        }
        setShowTips={(tabIndex?: number) => {
          setTipsActiveIndex(tabIndex ?? 0);
          setShowTips(true);
        }}
      />
      <GuidePanel
        visible={guideVisible}
        templateId={currentTemplateId}
        currentView={currentView}
        onClose={() => setGuideVisible(false)}
        onReselect={() => setShowGuidedCreation(true)}
        onOpen={() => setGuideVisible(true)}
      />
      {currentView === viewTypes.FocusMap && (
        <>
          {false && (
            <BrainstormComponent
              nodes={nodes as Node<NodeData>[]}
              brainstormVisible={brainstormVisible || aiMode === true}
              setBrainstormVisible={setBrainstormVisible}
              setAIMode={setAIMode}
              handleAddAINode={handleAddAINode}
              handleAddDocumentStructure={handleAddDocumentStructure}
            />
          )}
          <DetailsSidebar
            detailsSidebarVisible={detailsMode}
            setDetailsSidebarVisible={setDetailsMode}
            selectedNode={selectedNode}
          />
        </>
      )}
      {currentView === viewTypes.FocusMap && (
        <div ref={flowMapWrapper} className="flow-map-wrapper">
          <ReactFlow
            className="flow-canvas"
            nodes={nodes.map((node) =>
              node.type === "center"
                ? { ...node, data: { ...node.data, id: node.id }, id: node.id }
                : node
            )}
            edges={edges}
            zoomOnDoubleClick={false}
            onNodesChange={handleOnNodesChange}
            onEdgesChange={handleOnEdgesChange}
            onConnect={handleOnConnect}
            isValidConnection={isValidConnection}
            onConnectStart={onConnectStart}
            onConnectEnd={onConnectEnd}
            //onNodeDoubleClick={(event, node) => handleNodeDoubleClick(event, node)}
            onNodeContextMenu={handleNodeContextMenu}
            onDoubleClick={handlePaneDoubleClick}
            onPaneClick={handleCanvasClick}
            onMoveStart={handlePaneMoveStart}
            onNodeClick={handleNodeClick}
            onNodeDragStart={handleNodeDragStart}
            onMouseMove={handleMouseMove}
            nodeTypes={nodeTypes}
            edgeTypes={edgeTypes}
            nodeOrigin={nodeOrigin}
            defaultEdgeOptions={defaultEdgeOptions}
            connectionLineStyle={connectionLineStyle}
            connectionLineType={ConnectionLineType.Straight}
            snapToGrid={snapToGrid}
            deleteKeyCode={["Delete", "Backspace"]}
            disableKeyboardA11y={true}
            fitView
          >
            <Controls showInteractive={false} />
            {showMiniMap && <MiniMap zoomable pannable />}

            {snapToGrid && (
              <Background
                variant={BackgroundVariant.Dots}
                gap={15}
                size={1}
                color="gray"
              />
            )}
          </ReactFlow>

          {/* Center/Goal node marker for Joyride */}
          {/* <div
            id="center-goal-node"
            style={{
              position: "absolute",
              left: 0,
              top: 0,
              width: 1,
              height: 1,
              pointerEvents: "none",
            }}
          /> */}

          {/* {showBrainstorm && (
            <BrainstormPanel
              onClose={() => setShowBrainstorm(false)}
              onStructureUpdate={handleBrainstormStructureUpdate}
            />
          )} */}

          {showGuidedCreation && (
            <GuidedCreationDialog
              visible={showGuidedCreation}
              onClose={() => setShowGuidedCreation(false)}
              onTemplateSelect={handleGuidedTemplateSelect}
            />
          )}

          <AIInputFloat
            visible={showAIInput}
            onClose={() => setShowAIInput(false)}
            onSubmit={handleAIInputSubmit}
            nodes={nodes}
            edges={edges}
            selectedNodeId={selectedNodeId}
            onUpdateNodes={handleUpdateNodesFromAI}
            aiModel={aiModel}
          />

          <Tips
            flowId={currentFlowId}
            visible={showTips}
            onClose={() => {
              setShowTips(false);
              setTipsActiveIndex(0);
            }}
            activeIndex={tipsActiveIndex}
            doNotShowGettingStartedNextTime={doNotShowGettingStartedNextTime}
            onToggleGettingStarted={handleShowGettingStartedVideo}
            onOpenVideo={() => setShowGettingStartedVideoModal(true)}
          />

          <ContextMenu model={contextMenuItems} ref={cm} />

          <Dialog
            header="Quick Start Video"
            modal={false}
            visible={gettingStartedVisible && !doNotShowGettingStartedNextTime}
            style={{
              position: "absolute",
              width: "350px",
              top: "70px",
              right: "12px",
            }}
            onHide={() => {
              if (!gettingStartedVisible) return;
              setGettingStartedVisible(false);
            }}
          >
            <p>Click the video to get started fast!</p>
            <div className="card flex justify-content-center">
              {/* <p>Getting Started Video</p> */}
              <video
                ref={gettingStartedVideoRef}
                // width="300"
                height="125"
                onClick={(e) => togglePlay(e)}
                style={{ cursor: "pointer" }}
                poster="https://firebasestorage.googleapis.com/v0/b/focuspoint-98783.firebasestorage.app/o/images%2Fgetting-started-thumbnail-v4.png?alt=media&token=8df879dc-514a-46cd-9d95-3a8ee3936ef8"
              >
                <source
                  src="https://firebasestorage.googleapis.com/v0/b/focuspoint-98783.firebasestorage.app/o/videos%2Fgetting-started-v6.mp4?alt=media&token=1408d206-5ee4-450b-ad9b-2e49178f9296"
                  type="video/mp4"
                />
                Your browser does not support the video tag.
              </video>
              <div
                style={{
                  width: "100%",
                  alignItems: "flex-start",
                  alignContent: "flex-start",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "flex-start",
                  }}
                >
                  <input
                    style={{
                      marginLeft: "-2px",
                      marginTop: "7px",
                      height: "16px",
                      width: "16px",
                      backgroundColor: "white",
                      color: "black",
                    }}
                    type="checkbox"
                    checked={doNotShowGettingStartedNextTime}
                    onChange={() => {
                      handleShowGettingStartedVideo();
                    }}
                  />
                  <p style={{ marginLeft: "3px" }}>Do not show this again</p>
                </div>
              </div>
            </div>
          </Dialog>

          <div
            id="reactflow-hide"
            style={{
              position: "fixed",
              bottom: 0,
              right: 0,
              width: "60px",
              height: "15px",
              paddingLeft: "5px",
              paddingTop: "3px",
              backgroundColor: "white",
              fontSize: "8px",
              userSelect: "none",
              zIndex: 1,
            }}
          ></div>
        </div>
      )}
      {currentView.type === viewTypes.TimeLine.type && (
        <div
          ref={timelineWrapper}
          style={{
            flex: "1 1 auto",
            textAlign: "center",
            alignContent: "center",
            overflowY: "auto",
            overflowX: "hidden",
            backgroundColor: "white",
          }}
        >
          <TimeLineArea
            nodes={nodes as Node<NodeData>[]}
            handleAddUpdateEvent={addUpdateEvent}
            handleDeleteEvent={handleDeleteEvent}
            handleAddUpdateTask={addUpdateTask}
            mapTemplate={mapTemplate}
          />
        </div>
      )}
      {currentView.type === viewTypes.Kanban.type && (
        <div
          ref={kanbanWrapper}
          style={{
            flex: "1 1 auto",
            textAlign: "center",
            alignContent: "start",
          }}
        >
          <KanbanArea
            nodes={nodes as Node<NodeData>[]}
            handleAddUpdateTask={addUpdateTask}
            handleDeleteTask={deleteTask}
          />
        </div>
      )}
      {currentView.type === viewTypes.Grid.type && (
        <div
          ref={gridWrapper}
          style={{
            flex: "1 1 auto",
            textAlign: "center",
            alignContent: "start",
          }}
        >
          <GridArea detectedAddresses={[]} />
        </div>
      )}
      {currentView.type === viewTypes.WorldMap.type && (
        <div
          ref={worldMapWrapper}
          style={{
            flex: "1 1 auto",
            textAlign: "center",
            alignContent: "start",
          }}
        >
          <WorldMapArea
            nodes={nodes as Node<NodeData>[]}
            handleAddUpdateAddress={addUpdateAddress}
            handleDeleteAddress={deleteAddress}
          />
        </div>
      )}
      {currentView.type === viewTypes.Wheel.type && (
        <div
          ref={wheelWrapper}
          style={{
            flex: "1 1 auto",
            textAlign: "center",
            alignContent: "start",
          }}
        >
          {mapTemplate == "flow" &&
            currentView.type === viewTypes.Wheel.type && (
              <FocusWheel
                name={currentMapName || ""}
                nodes={nodes as Node<NodeData>[]}
                edges={edges as MapEdge[]}
                onClickNode={(node: any) =>
                  handleNodeDoubleClick(undefined as any, node)
                }
                onUpdateData={() => alert("updateData not yet implemented")}
              />
            )}

          {mapTemplate == "flow" && currentView === viewTypes.Kanban.type && (
            <KanbanArea
              nodes={nodes as Node<NodeData>[]}
              handleAddUpdateTask={addUpdateTask}
              handleDeleteTask={deleteTask}
            />
          )}

          {mapTemplate == "sustainability" && (
            <SustainabilityWheel
              data={wheelData.map((item) => ({
                ...item,
                group: item.group as
                  | "Kunderelationer"
                  | "Virksomhedsdrift"
                  | "Organisation"
                  | "Forretningskoncept",
              }))}
              onClickNode={(node: any) => console.log("Klikket:", node)}
              onUpdateData={(data: WheelData[]) => {
                setWheelData(data);
                updateNodesData(
                  nodes.map((node) => ({
                    ...node,
                    data: {
                      ...node.data,
                      wheelData: data,
                    },
                  }))
                );
              }}
            />
          )}
        </div>
      )}
      {!showViewSelector && !isPresentationMode && (
        <Panel
          position="bottom-center"
          style={{
            position: "fixed",
            bottom: 0,
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 1000,
          }}
        >
          <div className="card flex justify-content-center align-items-center">
            <SelectButton
              key={"view"}
              allowEmpty={false}
              value={currentView}
              onChange={(e: SelectButtonChangeEvent) =>
                handleViewChange(e.value)
              }
              options={viewItems.map((item) => ({
                label: (
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 6,
                      minWidth: 100,
                      justifyContent: "center",
                    }}
                    data-pr-tooltip={item.description}
                    data-pr-position="top"
                  >
                    {item.type === viewTypes.TimeLine.type && (
                      <i className="pi pi-calendar" style={{ fontSize: 18 }} />
                    )}
                    {item.type === viewTypes.WorldMap.type && (
                      <i
                        className="pi pi-map-marker"
                        style={{ fontSize: 18 }}
                      />
                    )}
                    {item.type === viewTypes.FocusMap.type && (
                      <i className="pi pi-lightbulb" style={{ fontSize: 18 }} />
                    )}
                    {item.type === viewTypes.Wheel.type && (
                      <i className="pi pi-circle-on" style={{ fontSize: 18 }} />
                    )}
                    {item.type === viewTypes.Kanban.type && (
                      <i
                        className="pi pi-check-circle"
                        style={{ fontSize: 18 }}
                      />
                    )}
                    {item.label}
                    <Tooltip
                      target="[data-pr-tooltip]"
                      style={{
                        fontSize: 16,
                        marginTop: "-40px",
                        maxWidth: 300,
                        wordBreak: "break-word",
                        whiteSpace: "pre-line",
                        backgroundColor: "transparent",
                      }}
                    />
                  </span>
                ),
                value: item,
                tooltip: item.description || item.label,
              }))}
              itemTemplate={(option) => (
                <span
                  // title={option.tooltip}
                  style={{ width: "100%" }}
                >
                  {option.label}
                </span>
              )}
              style={{ minWidth: viewItems.length * 120 }}
            />
          </div>
        </Panel>
      )}
      <ContextMenu model={nodeContextMenuItems} ref={ncm} />
      {colorPickerVisible && (
        <div
          className="color-picker"
          style={{
            position: "absolute",
            top: colorPickerPosition.y,
            left: colorPickerPosition.x,
          }}
        >
          <div
            style={{
              position: "fixed",
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
            }}
            onClick={() => setColorPickerVisible(false)}
          />
          <SwatchesPicker
            colors={colorArray}
            width={400}
            onChange={handleColorChange}
            onChangeComplete={handleColorChangeComplete}
          />
        </div>
      )}
      {emojiPickerVisible && (
        <EmojiPickerPopup
          position={emojiPickerPosition}
          isDragging={isDraggingEmojiPicker}
          onMouseDown={handleEmojiPickerMouseDown}
          onClose={() => setEmojiPickerVisible(false)}
          onEmojiSelect={handleEmojiSelect}
        />
      )}

      {imagePickerVisible && (
        <Dialog
          header="Pick an image"
          visible={imagePickerVisible}
          modal
          closable={true}
          style={{ width: "80%", height: "80%" }}
          onHide={() => {
            setImagePickerVisible(false);
          }}
        >
          <UnsplashImagePicker
            imagePickerVisible={imagePickerVisible}
            selectedNode={selectedNode}
            nodes={nodes}
            setNodes={setNodes}
            setIsDirty={setIsDirty}
            setImagePickerVisible={setImagePickerVisible}
          />
        </Dialog>
      )}

      <CustomPropertiesModal
        isOpen={showCustomPropertiesModal}
        inputOnly={true}
        onClose={() => setShowCustomPropertiesModal(false)}
        onSave={handleSaveCustomProperties}
        initialProperties={initialCustomProperties}
      />
      {showNotesModal && (
        <NotesModal
          isOpen={showNotesModal}
          node={selectedNode || null}
          nodes={nodes}
          handleSaveNotes={handleSaveNotes}
          handleCancelEditNotes={handleCancelEditNotes}
          aiMode={aiMode}
          setAIMode={setAIMode}
          handleAddUpdateEvent={addUpdateEvent}
          handleDeleteEvent={handleDeleteEvent}
          handleAddUpdateAddress={addUpdateAddress}
          handleDeleteAddress={deleteAddress}
          handleAddUpdateTask={addUpdateTask}
          handleDeleteTask={deleteTask}
        />
      )}
      {alertMessage && (
        <CustomAlert
          title={alertTitle}
          message={alertMessage}
          htmlMessage={null}
          onClose={handleCloseAlert}
        />
      )}
      <Dialog
        header="Enter a name and description for the template"
        visible={showCreateTemplate}
        style={{ width: "450px" }}
        onHide={() => {
          setShowCreateTemplate(false);
          setTemplateName("");
          setTemplateDescription("");
        }}
        footer={
          <div>
            <Button
              label="Yes"
              icon="pi pi-check"
              onClick={(e) => {
                if (templateName.trim() === "") {
                  alert("Please enter a template name.");
                  return;
                }
                if (templateDescription.trim() === "") {
                  alert("Please enter a template description.");
                  return;
                }
                handleSaveAsTemplate(templateName, templateDescription);
                setTemplateName("");
                setTemplateDescription("");
              }}
              autoFocus
            />
            <Button
              label="No"
              icon="pi pi-times"
              onClick={() => {
                setShowCreateTemplate(false);
                setTemplateName("");
                setTemplateDescription("");
              }}
              className="p-button-text"
            />
          </div>
        }
      >
        <div style={{ marginTop: "1rem" }}>
          <label
            htmlFor="templateName"
            style={{ display: "block", marginBottom: "0.5rem" }}
          >
            Template Name:
          </label>
          <InputText
            id="templateName"
            value={templateName}
            onChange={(e) => setTemplateName(e.target.value)}
            placeholder="Enter text"
            style={{ width: "100%", marginBottom: "1rem" }}
            onKeyDown={(e) => {
              if (
                e.key === "Enter" &&
                templateName.trim() !== "" &&
                templateDescription.trim() !== ""
              ) {
                handleSaveAsTemplate(templateName, templateDescription);
                setTemplateName("");
                setTemplateDescription("");
              }
            }}
          />
          <label
            htmlFor="templateDescription"
            style={{ display: "block", marginBottom: "0.5rem" }}
          >
            Description:
          </label>
          <InputText
            id="templateDescription"
            value={templateDescription}
            onChange={(e) => setTemplateDescription(e.target.value)}
            placeholder="Enter description"
            style={{ width: "100%" }}
            onKeyDown={(e) => {
              if (
                e.key === "Enter" &&
                templateName.trim() !== "" &&
                templateDescription.trim() !== ""
              ) {
                handleSaveAsTemplate(templateName, templateDescription);
                setTemplateName("");
                setTemplateDescription("");
              }
            }}
          />
        </div>
      </Dialog>

      <Dialog
        header="Paste Image URL"
        visible={showSetImageByUrl}
        style={{ width: "450px" }}
        onHide={() => {
          setShowSetImageByUrl(false);
          setImageUrl("");
        }}
        footer={
          <div>
            <Button
              label="OK"
              icon="pi pi-check"
              onClick={(e) => {
                if (imageUrl.trim() === "") {
                  alert("Please enter an image URL.");
                  return;
                }
                handleConfirmImageUrl(e, imageUrl);
                setImageUrl("");
              }}
              autoFocus
            />
            <Button
              label="Cancel"
              icon="pi pi-times"
              onClick={() => {
                setShowSetImageByUrl(false);
                setImageUrl("");
              }}
              className="p-button-text"
            />
          </div>
        }
      >
        <div style={{ marginTop: "1rem" }}>
          <label
            htmlFor="imageUrl"
            style={{ display: "block", marginBottom: "0.5rem" }}
          >
            Image URL:
          </label>
          <InputText
            id="imageUrl"
            value={imageUrl}
            onChange={(e) => setImageUrl(e.target.value)}
            placeholder="Enter image URL"
            style={{ width: "100%" }}
            onKeyDown={(e) => {
              if (e.key === "Enter" && imageUrl.trim() !== "") {
                handleConfirmImageUrl(e as any, imageUrl);
                setImageUrl("");
              }
            }}
          />
        </div>
      </Dialog>
      <AIQueryForm
        isOpen={showAiModal}
        onRequestClose={() => setShowAiModal(false)}
        aiTopic={aiTopic}
        setAiTopic={setAiTopic}
        handleAiQuery={handleAiQuery}
      />
      <PubMedQueryForm
        isOpen={showPubMedModal}
        onRequestClose={() => setShowPubMedModal(false)}
        pubMedTopic={pubMedTopic}
        setPubMedTopic={setPubMedTopic}
        handlePubMedQuery={handlePubMedQuery}
      />
      <BonsaiQueryForm
        isOpen={showBonsaiModal}
        onRequestClose={() => setShowBonsaiModal(false)}
        bonsaiTopic={bonsaiTopic}
        setBonsaiTopic={setBonsaiTopic}
        handleBonsaiQuery={handleBonsaiQuery}
      />
      <CVRQueryForm
        isOpen={showCvrModal}
        onRequestClose={() => setShowCvrModal(false)}
        cvrTopic={cvrTopic}
        setCvrTopic={setCvrTopic}
        handleCvrQuery={handleCvrQuery}
      />
      <div className="card flex justify-content-center"></div>
      {showProgressSpinner && (
        <div className="progress-overlay">
          <ProgressSpinner strokeWidth="8" aria-label="Saving data..." />
        </div>
      )}
      <Toast ref={toastCenter} position="center" />
      <UserSettings
        visible={userSettingsVisible}
        onHide={() => setUserSettingsVisible(false)}
        headerElement={headerElement}
        footerContent={footerContent}
        currency={currency}
        setCurrency={setCurrency}
        showWhyTag={showWhyTag}
        setShowWhyTag={setShowWhyTag}
        showStartupDialog={showStartupDialog}
        setShowStartupDialog={setShowStartupDialog}
        showAIPromptOnNewMap={showAIPromptOnNewMap}
        setShowAIPromptOnNewMap={setShowAIPromptOnNewMap}
        showGettingStarted={!doNotShowGettingStartedNextTime}
        setShowGettingStarted={handleSetShowGettingStarted}
        aiModel={aiModel}
        setAiModel={setAiModel}
      />
      <Dialog
        visible={showGettingStartedVideoModal}
        onHide={() => setShowGettingStartedVideoModal(false)}
        header="Quick Start Video"
        modal={false}
        blockScroll={false}
        dismissableMask={false}
        closable={true}
        style={{ width: "80vw", maxWidth: "800px" }}
        contentStyle={{ padding: "0" }}
      >
        <video
          controls
          autoPlay
          style={{ width: "100%", height: "auto", display: "block" }}
        >
          <source
            src="https://firebasestorage.googleapis.com/v0/b/focuspoint-98783.firebasestorage.app/o/videos%2Fgetting-started-v6.mp4?alt=media&token=1408d206-5ee4-450b-ad9b-2e49178f9296"
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video>
      </Dialog>
      <HelpModal
        showHelpModal={showHelpModal}
        onClose={() => setShowHelpModal(false)}
        initialVideoUrl={initialVideoUrl}
      />

      {/* Startup modal removed - Goal node with BrainstormPanel shown automatically */}
    </div>
  );
}

export default Flow;
